var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKadenai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 213.13 209.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-60);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-61);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-62);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-63);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-64);\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-65);\n      }\n\n      .cls-68 {\n        fill: url(#linear-gradient-66);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-67);\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-68);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-69);\n      }\n\n      .cls-72 {\n        fill: url(#linear-gradient-70);\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-71);\n      }\n\n      .cls-74 {\n        fill: url(#linear-gradient-72);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-73);\n      }\n\n      .cls-76 {\n        fill: url(#linear-gradient-74);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-75);\n      }\n\n      .cls-78 {\n        fill: url(#linear-gradient-76);\n      }\n\n      .cls-79 {\n        fill: url(#linear-gradient-77);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-78);\n      }\n\n      .cls-81 {\n        fill: url(#linear-gradient-79);\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-80);\n      }\n\n      .cls-83 {\n        fill: url(#linear-gradient-81);\n      }\n\n      .cls-84 {\n        fill: url(#linear-gradient-82);\n      }\n\n      .cls-85 {\n        fill: url(#linear-gradient-83);\n      }\n\n      .cls-86 {\n        fill: url(#linear-gradient-84);\n      }\n\n      .cls-87 {\n        fill: url(#linear-gradient-85);\n      }\n\n      .cls-88 {\n        fill: url(#linear-gradient-86);\n      }\n\n      .cls-89 {\n        fill: url(#linear-gradient-87);\n      }\n\n      .cls-90 {\n        fill: url(#linear-gradient-88);\n      }\n\n      .cls-91 {\n        fill: url(#linear-gradient-89);\n      }\n\n      .cls-92 {\n        fill: url(#linear-gradient-90);\n      }\n\n      .cls-93 {\n        fill: url(#linear-gradient-91);\n      }\n\n      .cls-94 {\n        fill: url(#linear-gradient-92);\n      }\n\n      .cls-95 {\n        fill: url(#linear-gradient-93);\n      }\n\n      .cls-96 {\n        fill: url(#linear-gradient-94);\n      }\n\n      .cls-97 {\n        fill: url(#linear-gradient-95);\n      }\n\n      .cls-98 {\n        fill: url(#linear-gradient-96);\n      }\n\n      .cls-99 {\n        fill: url(#linear-gradient-97);\n      }\n\n      .cls-100 {\n        fill: url(#linear-gradient-98);\n      }\n\n      .cls-101 {\n        fill: url(#linear-gradient-99);\n      }\n\n      .cls-102 {\n        fill: url(#linear-gradient-100);\n      }\n\n      .cls-103 {\n        fill: url(#linear-gradient-101);\n      }\n\n      .cls-104 {\n        fill: url(#linear-gradient-102);\n      }\n\n      .cls-105 {\n        fill: url(#linear-gradient-103);\n      }\n\n      .cls-106 {\n        fill: url(#linear-gradient-104);\n      }\n\n      .cls-107 {\n        fill: url(#linear-gradient-105);\n      }\n\n      .cls-108 {\n        fill: url(#linear-gradient-106);\n      }\n\n      .cls-109 {\n        fill: url(#linear-gradient-107);\n      }\n\n      .cls-110 {\n        fill: url(#linear-gradient-108);\n      }\n\n      .cls-111 {\n        fill: url(#linear-gradient-109);\n      }\n\n      .cls-112 {\n        fill: url(#linear-gradient-110);\n      }\n\n      .cls-113 {\n        fill: url(#linear-gradient-111);\n      }\n\n      .cls-114 {\n        fill: url(#linear-gradient-112);\n      }\n\n      .cls-115 {\n        fill: url(#linear-gradient-113);\n      }\n\n      .cls-116 {\n        fill: url(#linear-gradient-114);\n      }\n\n      .cls-117 {\n        fill: url(#linear-gradient-115);\n      }\n\n      .cls-118 {\n        fill: url(#linear-gradient-116);\n      }\n\n      .cls-119 {\n        fill: url(#linear-gradient-117);\n      }\n\n      .cls-120 {\n        fill: url(#linear-gradient-118);\n      }\n\n      .cls-121 {\n        fill: url(#linear-gradient-119);\n      }\n\n      .cls-122 {\n        fill: url(#linear-gradient-120);\n      }\n\n      .cls-123 {\n        fill: url(#linear-gradient-121);\n      }\n\n      .cls-124 {\n        fill: url(#linear-gradient-122);\n      }\n\n      .cls-125 {\n        fill: url(#linear-gradient-123);\n      }\n\n      .cls-126 {\n        fill: url(#linear-gradient-124);\n      }\n\n      .cls-127 {\n        fill: url(#linear-gradient-125);\n      }\n\n      .cls-128 {\n        fill: url(#linear-gradient-126);\n      }\n\n      .cls-129 {\n        fill: url(#linear-gradient-127);\n      }\n\n      .cls-130 {\n        fill: url(#linear-gradient-128);\n      }\n\n      .cls-131 {\n        fill: url(#linear-gradient-129);\n      }\n\n      .cls-132 {\n        fill: url(#linear-gradient-130);\n      }\n\n      .cls-133 {\n        fill: url(#linear-gradient-131);\n      }\n\n      .cls-134 {\n        fill: url(#linear-gradient-132);\n      }\n\n      .cls-135 {\n        fill: url(#linear-gradient-133);\n      }\n\n      .cls-136 {\n        fill: url(#linear-gradient-134);\n      }\n\n      .cls-137 {\n        fill: url(#linear-gradient-135);\n      }\n\n      .cls-138 {\n        fill: url(#linear-gradient-136);\n      }\n\n      .cls-139 {\n        fill: url(#linear-gradient-137);\n      }\n\n      .cls-140 {\n        fill: url(#linear-gradient-138);\n      }\n\n      .cls-141 {\n        fill: url(#linear-gradient-139);\n      }\n\n      .cls-142 {\n        fill: url(#linear-gradient-140);\n      }\n\n      .cls-143 {\n        fill: url(#linear-gradient-141);\n      }\n\n      .cls-144 {\n        fill: url(#linear-gradient-142);\n      }\n\n      .cls-145 {\n        fill: url(#linear-gradient-143);\n      }\n\n      .cls-146 {\n        fill: url(#linear-gradient-144);\n      }\n\n      .cls-147 {\n        fill: url(#linear-gradient-145);\n      }\n\n      .cls-148 {\n        fill: url(#linear-gradient-146);\n      }\n\n      .cls-149 {\n        fill: url(#linear-gradient-147);\n      }\n\n      .cls-150 {\n        fill: url(#linear-gradient-148);\n      }\n\n      .cls-151 {\n        fill: url(#linear-gradient-149);\n      }\n\n      .cls-152 {\n        fill: url(#linear-gradient-150);\n      }\n\n      .cls-153 {\n        fill: url(#linear-gradient-151);\n      }\n\n      .cls-154 {\n        fill: url(#linear-gradient-152);\n      }\n\n      .cls-155 {\n        fill: url(#linear-gradient-153);\n      }\n\n      .cls-156 {\n        fill: url(#linear-gradient-154);\n      }\n\n      .cls-157 {\n        fill: url(#linear-gradient-155);\n      }\n\n      .cls-158 {\n        fill: url(#linear-gradient-156);\n      }\n\n      .cls-159 {\n        fill: url(#linear-gradient-157);\n      }\n\n      .cls-160 {\n        fill: url(#linear-gradient-158);\n      }\n\n      .cls-161 {\n        fill: url(#linear-gradient-159);\n      }\n\n      .cls-162 {\n        fill: url(#linear-gradient-160);\n      }\n\n      .cls-163 {\n        fill: url(#linear-gradient-161);\n      }\n\n      .cls-164 {\n        fill: url(#linear-gradient-162);\n      }\n\n      .cls-165 {\n        fill: url(#linear-gradient-163);\n      }\n\n      .cls-166 {\n        fill: url(#linear-gradient-164);\n      }\n\n      .cls-167 {\n        fill: url(#linear-gradient-165);\n      }\n\n      .cls-168 {\n        fill: url(#linear-gradient-166);\n      }\n\n      .cls-169 {\n        fill: url(#linear-gradient-167);\n      }\n\n      .cls-170 {\n        fill: url(#linear-gradient-168);\n      }\n\n      .cls-171 {\n        fill: url(#linear-gradient-169);\n      }\n\n      .cls-172 {\n        fill: url(#linear-gradient-170);\n      }\n\n      .cls-173 {\n        fill: url(#linear-gradient-171);\n      }\n\n      .cls-174 {\n        fill: url(#linear-gradient-172);\n      }\n\n      .cls-175 {\n        fill: url(#linear-gradient-173);\n      }\n\n      .cls-176 {\n        fill: url(#linear-gradient-174);\n      }\n\n      .cls-177 {\n        fill: url(#linear-gradient-175);\n      }\n\n      .cls-178 {\n        fill: url(#linear-gradient-176);\n      }\n\n      .cls-179 {\n        fill: url(#linear-gradient-177);\n      }\n\n      .cls-180 {\n        fill: url(#linear-gradient-178);\n      }\n\n      .cls-181 {\n        fill: url(#linear-gradient-179);\n      }\n\n      .cls-182 {\n        fill: url(#linear-gradient-180);\n      }\n\n      .cls-183 {\n        fill: url(#linear-gradient-181);\n      }\n\n      .cls-184 {\n        fill: url(#linear-gradient-182);\n      }\n\n      .cls-185 {\n        fill: url(#linear-gradient-183);\n      }\n\n      .cls-186 {\n        fill: url(#linear-gradient-184);\n      }\n\n      .cls-187 {\n        fill: url(#linear-gradient-185);\n      }\n\n      .cls-188 {\n        fill: url(#linear-gradient-186);\n      }\n\n      .cls-189 {\n        fill: url(#linear-gradient-187);\n      }\n\n      .cls-190 {\n        fill: url(#linear-gradient-188);\n      }\n\n      .cls-191 {\n        fill: url(#linear-gradient-189);\n      }\n\n      .cls-192 {\n        fill: url(#linear-gradient-190);\n      }\n\n      .cls-193 {\n        fill: url(#linear-gradient-191);\n      }\n\n      .cls-194 {\n        fill: url(#linear-gradient-192);\n      }\n\n      .cls-195 {\n        fill: url(#linear-gradient-193);\n      }\n\n      .cls-196 {\n        fill: url(#linear-gradient-194);\n      }\n\n      .cls-197 {\n        fill: url(#linear-gradient-195);\n      }\n\n      .cls-198 {\n        fill: url(#linear-gradient-196);\n      }\n\n      .cls-199 {\n        fill: url(#linear-gradient-197);\n      }\n\n      .cls-200 {\n        fill: url(#linear-gradient-198);\n      }\n\n      .cls-201 {\n        fill: url(#linear-gradient-199);\n      }\n\n      .cls-202 {\n        fill: url(#linear-gradient-200);\n      }\n\n      .cls-203 {\n        fill: url(#linear-gradient-201);\n      }\n\n      .cls-204 {\n        fill: url(#linear-gradient-202);\n      }\n\n      .cls-205 {\n        fill: url(#linear-gradient-203);\n      }\n\n      .cls-206 {\n        fill: url(#linear-gradient-204);\n      }\n\n      .cls-207 {\n        fill: url(#linear-gradient-205);\n      }\n\n      .cls-208 {\n        fill: url(#linear-gradient-206);\n      }\n\n      .cls-209 {\n        fill: url(#linear-gradient-207);\n      }\n\n      .cls-210 {\n        fill: url(#linear-gradient-208);\n      }\n\n      .cls-211 {\n        fill: url(#linear-gradient-209);\n      }\n\n      .cls-212 {\n        fill: url(#linear-gradient-210);\n      }\n\n      .cls-213 {\n        fill: url(#linear-gradient-211);\n      }\n\n      .cls-214 {\n        fill: url(#linear-gradient-212);\n      }\n\n      .cls-215 {\n        fill: url(#linear-gradient-213);\n      }\n\n      .cls-216 {\n        fill: url(#linear-gradient-214);\n      }\n\n      .cls-217 {\n        fill: url(#linear-gradient-215);\n      }\n\n      .cls-218 {\n        fill: url(#linear-gradient-216);\n      }\n\n      .cls-219 {\n        fill: url(#linear-gradient-217);\n      }\n\n      .cls-220 {\n        fill: url(#linear-gradient-218);\n      }\n\n      .cls-221 {\n        fill: url(#linear-gradient-219);\n      }\n\n      .cls-222 {\n        fill: url(#linear-gradient-220);\n      }\n\n      .cls-223 {\n        fill: url(#linear-gradient-221);\n      }\n\n      .cls-224 {\n        fill: url(#linear-gradient-222);\n      }\n\n      .cls-225 {\n        fill: url(#linear-gradient-223);\n      }\n\n      .cls-226 {\n        fill: url(#linear-gradient-224);\n      }\n\n      .cls-227 {\n        fill: url(#linear-gradient-225);\n      }\n\n      .cls-228 {\n        fill: url(#linear-gradient-226);\n      }\n\n      .cls-229 {\n        fill: url(#linear-gradient-227);\n      }\n\n      .cls-230 {\n        fill: url(#linear-gradient-228);\n      }\n\n      .cls-231 {\n        fill: url(#linear-gradient-229);\n      }\n\n      .cls-232 {\n        fill: url(#linear-gradient-230);\n      }\n\n      .cls-233 {\n        fill: url(#linear-gradient-231);\n      }\n\n      .cls-234 {\n        fill: url(#linear-gradient-232);\n      }\n\n      .cls-235 {\n        fill: url(#linear-gradient-233);\n      }\n\n      .cls-236 {\n        fill: url(#linear-gradient-234);\n      }\n\n      .cls-237 {\n        fill: url(#linear-gradient-235);\n      }\n\n      .cls-238 {\n        fill: url(#linear-gradient-236);\n      }\n\n      .cls-239 {\n        fill: url(#linear-gradient-237);\n      }\n\n      .cls-240 {\n        fill: url(#linear-gradient-238);\n      }\n\n      .cls-241 {\n        fill: url(#linear-gradient-239);\n      }\n\n      .cls-242 {\n        fill: url(#linear-gradient-240);\n      }\n\n      .cls-243 {\n        fill: url(#linear-gradient-241);\n      }\n\n      .cls-244 {\n        fill: url(#linear-gradient-242);\n      }\n\n      .cls-245 {\n        fill: url(#linear-gradient-243);\n      }\n\n      .cls-246 {\n        fill: url(#linear-gradient-244);\n      }\n\n      .cls-247 {\n        fill: url(#linear-gradient-245);\n      }\n\n      .cls-248 {\n        fill: url(#linear-gradient-246);\n      }\n\n      .cls-249 {\n        fill: url(#linear-gradient-247);\n      }\n\n      .cls-250 {\n        fill: url(#linear-gradient-248);\n      }\n\n      .cls-251 {\n        fill: url(#linear-gradient-249);\n      }\n\n      .cls-252 {\n        fill: url(#linear-gradient-250);\n      }\n\n      .cls-253 {\n        fill: url(#linear-gradient-251);\n      }\n\n      .cls-254 {\n        fill: url(#linear-gradient-252);\n      }\n\n      .cls-255 {\n        fill: url(#linear-gradient-253);\n      }\n\n      .cls-256 {\n        fill: url(#linear-gradient-254);\n      }\n\n      .cls-257 {\n        fill: url(#linear-gradient-255);\n      }\n\n      .cls-258 {\n        fill: url(#linear-gradient-256);\n      }\n\n      .cls-259 {\n        fill: url(#linear-gradient-257);\n      }\n\n      .cls-260 {\n        fill: url(#linear-gradient-258);\n      }\n\n      .cls-261 {\n        fill: url(#linear-gradient-259);\n      }\n\n      .cls-262 {\n        fill: url(#linear-gradient-260);\n      }\n\n      .cls-263 {\n        fill: url(#linear-gradient-261);\n      }\n\n      .cls-264 {\n        fill: url(#linear-gradient-262);\n      }\n\n      .cls-265 {\n        fill: url(#linear-gradient-263);\n      }\n\n      .cls-266 {\n        fill: url(#linear-gradient-264);\n      }\n\n      .cls-267 {\n        fill: url(#linear-gradient-265);\n      }\n\n      .cls-268 {\n        fill: url(#linear-gradient-266);\n      }\n\n      .cls-269 {\n        fill: url(#linear-gradient-267);\n      }\n\n      .cls-270 {\n        fill: url(#linear-gradient-268);\n      }\n\n      .cls-271 {\n        fill: url(#linear-gradient-269);\n      }\n\n      .cls-272 {\n        fill: url(#linear-gradient-270);\n      }\n\n      .cls-273 {\n        fill: url(#linear-gradient-271);\n      }\n\n      .cls-274 {\n        fill: url(#linear-gradient-272);\n      }\n\n      .cls-275 {\n        fill: url(#linear-gradient-273);\n      }\n\n      .cls-276 {\n        fill: url(#linear-gradient-274);\n      }\n\n      .cls-277 {\n        fill: url(#linear-gradient-275);\n      }\n\n      .cls-278 {\n        fill: url(#linear-gradient-276);\n      }\n\n      .cls-279 {\n        fill: url(#linear-gradient-277);\n      }\n\n      .cls-280 {\n        fill: url(#linear-gradient-278);\n      }\n\n      .cls-281 {\n        fill: url(#linear-gradient-279);\n      }\n\n      .cls-282 {\n        fill: url(#linear-gradient-280);\n      }\n\n      .cls-283 {\n        fill: url(#linear-gradient-281);\n      }\n\n      .cls-284 {\n        fill: url(#linear-gradient-282);\n      }\n\n      .cls-285 {\n        fill: url(#linear-gradient-283);\n      }\n\n      .cls-286 {\n        fill: url(#linear-gradient-284);\n      }\n\n      .cls-287 {\n        fill: url(#linear-gradient-285);\n      }\n\n      .cls-288 {\n        fill: url(#linear-gradient-286);\n      }\n\n      .cls-289 {\n        fill: url(#linear-gradient-287);\n      }\n\n      .cls-290 {\n        fill: url(#linear-gradient-288);\n      }\n\n      .cls-291 {\n        fill: url(#linear-gradient-289);\n      }\n\n      .cls-292 {\n        fill: url(#linear-gradient-290);\n      }\n\n      .cls-293 {\n        fill: url(#linear-gradient-291);\n      }\n\n      .cls-294 {\n        fill: url(#linear-gradient-292);\n      }\n\n      .cls-295 {\n        fill: url(#linear-gradient-293);\n      }\n\n      .cls-296 {\n        fill: url(#linear-gradient-294);\n      }\n\n      .cls-297 {\n        fill: url(#linear-gradient-295);\n      }\n\n      .cls-298 {\n        fill: url(#linear-gradient-296);\n      }\n\n      .cls-299 {\n        fill: url(#linear-gradient-297);\n      }\n\n      .cls-300 {\n        fill: url(#linear-gradient-298);\n      }\n\n      .cls-301 {\n        fill: url(#linear-gradient-299);\n      }\n\n      .cls-302 {\n        fill: url(#linear-gradient-300);\n      }\n\n      .cls-303 {\n        fill: url(#linear-gradient-301);\n      }\n\n      .cls-304 {\n        fill: url(#linear-gradient-302);\n      }\n\n      .cls-305 {\n        fill: url(#linear-gradient-303);\n      }\n\n      .cls-306 {\n        fill: url(#linear-gradient-304);\n      }\n\n      .cls-307 {\n        fill: url(#linear-gradient-305);\n      }\n\n      .cls-308 {\n        fill: url(#linear-gradient-306);\n      }\n\n      .cls-309 {\n        fill: url(#linear-gradient-307);\n      }\n\n      .cls-310 {\n        fill: url(#linear-gradient-308);\n      }\n\n      .cls-311 {\n        fill: url(#linear-gradient-309);\n      }\n\n      .cls-312 {\n        fill: url(#linear-gradient-310);\n      }\n\n      .cls-313 {\n        fill: url(#linear-gradient-311);\n      }\n\n      .cls-314 {\n        fill: url(#linear-gradient-312);\n      }\n\n      .cls-315 {\n        fill: url(#linear-gradient-313);\n      }\n\n      .cls-316 {\n        fill: url(#linear-gradient-314);\n      }\n\n      .cls-317 {\n        fill: url(#linear-gradient-315);\n      }\n\n      .cls-318 {\n        fill: url(#linear-gradient-316);\n      }\n\n      .cls-319 {\n        fill: url(#linear-gradient-317);\n      }\n\n      .cls-320 {\n        fill: url(#linear-gradient-318);\n      }\n\n      .cls-321 {\n        fill: url(#linear-gradient-319);\n      }\n\n      .cls-322 {\n        fill: url(#linear-gradient-320);\n      }\n\n      .cls-323 {\n        fill: url(#linear-gradient-321);\n      }\n\n      .cls-324 {\n        fill: url(#linear-gradient-322);\n      }\n\n      .cls-325 {\n        fill: url(#linear-gradient-323);\n      }\n\n      .cls-326 {\n        fill: url(#linear-gradient-324);\n      }\n\n      .cls-327 {\n        fill: url(#linear-gradient-325);\n      }\n\n      .cls-328 {\n        fill: url(#linear-gradient-326);\n      }\n\n      .cls-329 {\n        fill: url(#linear-gradient-327);\n      }\n\n      .cls-330 {\n        fill: url(#linear-gradient-328);\n      }\n\n      .cls-331 {\n        fill: url(#linear-gradient-329);\n      }\n\n      .cls-332 {\n        fill: url(#linear-gradient-330);\n      }\n\n      .cls-333 {\n        fill: url(#linear-gradient-331);\n      }\n\n      .cls-334 {\n        fill: url(#linear-gradient-332);\n      }\n\n      .cls-335 {\n        fill: url(#linear-gradient-333);\n      }\n\n      .cls-336 {\n        fill: url(#linear-gradient-334);\n      }\n\n      .cls-337 {\n        fill: url(#linear-gradient-335);\n      }\n\n      .cls-338 {\n        fill: url(#linear-gradient-336);\n      }\n\n      .cls-339 {\n        fill: url(#linear-gradient-337);\n      }\n\n      .cls-340 {\n        fill: url(#linear-gradient-338);\n      }\n\n      .cls-341 {\n        fill: url(#linear-gradient-339);\n      }\n\n      .cls-342 {\n        fill: url(#linear-gradient-340);\n      }\n\n      .cls-343 {\n        fill: url(#linear-gradient-341);\n      }\n\n      .cls-344 {\n        fill: url(#linear-gradient-342);\n      }\n\n      .cls-345 {\n        fill: url(#linear-gradient-343);\n      }\n\n      .cls-346 {\n        fill: url(#linear-gradient-344);\n      }\n\n      .cls-347 {\n        fill: url(#linear-gradient-345);\n      }\n\n      .cls-348 {\n        fill: url(#linear-gradient-346);\n      }\n\n      .cls-349 {\n        fill: url(#linear-gradient-347);\n      }\n\n      .cls-350 {\n        fill: url(#linear-gradient-348);\n      }\n\n      .cls-351 {\n        fill: url(#linear-gradient-349);\n      }\n\n      .cls-352 {\n        fill: url(#linear-gradient-350);\n      }\n\n      .cls-353 {\n        fill: url(#linear-gradient-351);\n      }\n\n      .cls-354 {\n        fill: url(#linear-gradient-352);\n      }\n\n      .cls-355 {\n        fill: url(#linear-gradient-353);\n      }\n\n      .cls-356 {\n        fill: url(#linear-gradient-354);\n      }\n\n      .cls-357 {\n        fill: url(#linear-gradient-355);\n      }\n\n      .cls-358 {\n        fill: url(#linear-gradient-356);\n      }\n\n      .cls-359 {\n        fill: url(#linear-gradient-357);\n      }\n\n      .cls-360 {\n        fill: url(#linear-gradient-358);\n      }\n\n      .cls-361 {\n        fill: url(#linear-gradient-359);\n      }\n\n      .cls-362 {\n        fill: url(#linear-gradient-360);\n      }\n\n      .cls-363 {\n        fill: url(#linear-gradient-361);\n      }\n\n      .cls-364 {\n        fill: url(#linear-gradient-362);\n      }\n\n      .cls-365 {\n        fill: url(#linear-gradient-363);\n      }\n\n      .cls-366 {\n        fill: url(#linear-gradient-364);\n      }\n\n      .cls-367 {\n        fill: url(#linear-gradient-365);\n      }\n\n      .cls-368 {\n        fill: url(#linear-gradient-366);\n      }\n\n      .cls-369 {\n        fill: url(#linear-gradient-367);\n      }\n\n      .cls-370 {\n        fill: url(#linear-gradient-368);\n      }\n\n      .cls-371 {\n        fill: url(#linear-gradient-369);\n      }\n\n      .cls-372 {\n        fill: url(#linear-gradient-370);\n      }\n\n      .cls-373 {\n        fill: url(#linear-gradient-371);\n      }\n\n      .cls-374 {\n        fill: url(#linear-gradient-372);\n      }\n\n      .cls-375 {\n        fill: url(#linear-gradient-373);\n      }\n\n      .cls-376 {\n        fill: url(#linear-gradient-374);\n      }\n\n      .cls-377 {\n        fill: url(#linear-gradient-375);\n      }\n\n      .cls-378 {\n        fill: url(#linear-gradient-376);\n      }\n\n      .cls-379 {\n        fill: url(#linear-gradient-377);\n      }\n\n      .cls-380 {\n        fill: url(#linear-gradient-378);\n      }\n\n      .cls-381 {\n        fill: url(#linear-gradient-379);\n      }\n\n      .cls-382 {\n        fill: url(#linear-gradient-380);\n      }\n\n      .cls-383 {\n        fill: url(#linear-gradient-381);\n      }\n\n      .cls-384 {\n        fill: url(#linear-gradient-382);\n      }\n\n      .cls-385 {\n        fill: url(#linear-gradient-383);\n      }\n\n      .cls-386 {\n        fill: url(#linear-gradient-384);\n      }\n\n      .cls-387 {\n        fill: url(#linear-gradient-385);\n      }\n\n      .cls-388 {\n        fill: url(#linear-gradient-386);\n      }\n\n      .cls-389 {\n        fill: url(#linear-gradient-387);\n      }\n\n      .cls-390 {\n        fill: url(#linear-gradient-388);\n      }\n\n      .cls-391 {\n        fill: url(#linear-gradient-389);\n      }\n\n      .cls-392 {\n        fill: url(#linear-gradient-390);\n      }\n\n      .cls-393 {\n        fill: url(#linear-gradient-391);\n      }\n\n      .cls-394 {\n        fill: url(#linear-gradient-392);\n      }\n\n      .cls-395 {\n        fill: url(#linear-gradient-393);\n      }\n\n      .cls-396 {\n        fill: url(#linear-gradient-394);\n      }\n\n      .cls-397 {\n        fill: url(#linear-gradient-395);\n      }\n\n      .cls-398 {\n        fill: url(#linear-gradient-396);\n      }\n\n      .cls-399 {\n        fill: url(#linear-gradient-397);\n      }\n\n      .cls-400 {\n        fill: url(#linear-gradient-398);\n      }\n\n      .cls-401 {\n        fill: url(#linear-gradient-399);\n      }\n\n      .cls-402 {\n        fill: url(#linear-gradient-400);\n      }\n\n      .cls-403 {\n        fill: url(#linear-gradient-401);\n      }\n\n      .cls-404 {\n        fill: url(#linear-gradient-402);\n      }\n\n      .cls-405 {\n        fill: url(#linear-gradient-403);\n      }\n\n      .cls-406 {\n        fill: url(#linear-gradient-404);\n      }\n\n      .cls-407 {\n        fill: url(#linear-gradient-405);\n      }\n\n      .cls-408 {\n        fill: url(#linear-gradient-406);\n      }\n\n      .cls-409 {\n        fill: url(#linear-gradient-407);\n      }\n\n      .cls-410 {\n        fill: url(#linear-gradient-408);\n      }\n\n      .cls-411 {\n        fill: url(#linear-gradient-409);\n      }\n\n      .cls-412 {\n        fill: url(#linear-gradient-410);\n      }\n\n      .cls-413 {\n        fill: url(#linear-gradient-411);\n      }\n\n      .cls-414 {\n        fill: url(#linear-gradient-412);\n      }\n\n      .cls-415 {\n        fill: url(#linear-gradient-413);\n      }\n\n      .cls-416 {\n        fill: url(#linear-gradient-414);\n      }\n\n      .cls-417 {\n        fill: url(#linear-gradient-415);\n      }\n\n      .cls-418 {\n        fill: url(#linear-gradient-416);\n      }\n\n      .cls-419 {\n        fill: url(#linear-gradient-417);\n      }\n\n      .cls-420 {\n        fill: url(#linear-gradient-418);\n      }\n\n      .cls-421 {\n        fill: url(#linear-gradient-419);\n      }\n\n      .cls-422 {\n        fill: url(#linear-gradient-420);\n      }\n\n      .cls-423 {\n        fill: url(#linear-gradient-421);\n      }\n\n      .cls-424 {\n        fill: url(#linear-gradient-422);\n      }\n\n      .cls-425 {\n        fill: url(#linear-gradient-423);\n      }\n\n      .cls-426 {\n        fill: url(#linear-gradient-424);\n      }\n\n      .cls-427 {\n        fill: url(#linear-gradient-425);\n      }\n\n      .cls-428 {\n        fill: url(#linear-gradient-426);\n      }\n\n      .cls-429 {\n        fill: url(#linear-gradient-427);\n      }\n\n      .cls-430 {\n        fill: url(#linear-gradient-428);\n      }\n\n      .cls-431 {\n        fill: url(#linear-gradient-429);\n      }\n\n      .cls-432 {\n        fill: url(#linear-gradient-430);\n      }\n\n      .cls-433 {\n        fill: url(#linear-gradient-431);\n      }\n\n      .cls-434 {\n        fill: url(#linear-gradient-432);\n      }\n\n      .cls-435 {\n        fill: url(#linear-gradient-433);\n      }\n\n      .cls-436 {\n        fill: url(#linear-gradient-434);\n      }\n\n      .cls-437 {\n        fill: url(#linear-gradient-435);\n      }\n\n      .cls-438 {\n        fill: url(#linear-gradient-436);\n      }\n\n      .cls-439 {\n        fill: url(#linear-gradient-437);\n      }\n\n      .cls-440 {\n        fill: url(#linear-gradient-438);\n      }\n\n      .cls-441 {\n        fill: url(#linear-gradient-439);\n      }\n\n      .cls-442 {\n        fill: url(#linear-gradient-440);\n      }\n\n      .cls-443 {\n        fill: url(#linear-gradient-441);\n      }\n\n      .cls-444 {\n        fill: url(#linear-gradient-442);\n      }\n\n      .cls-445 {\n        fill: url(#linear-gradient-443);\n      }\n\n      .cls-446 {\n        fill: url(#linear-gradient-444);\n      }\n\n      .cls-447 {\n        fill: url(#linear-gradient-445);\n      }\n\n      .cls-448 {\n        fill: url(#linear-gradient-446);\n      }\n\n      .cls-449 {\n        fill: url(#linear-gradient-447);\n      }\n\n      .cls-450 {\n        fill: url(#linear-gradient-448);\n      }\n\n      .cls-451 {\n        fill: url(#linear-gradient-449);\n      }\n\n      .cls-452 {\n        fill: url(#linear-gradient-450);\n      }\n\n      .cls-453 {\n        fill: url(#linear-gradient-451);\n      }\n\n      .cls-454 {\n        fill: url(#linear-gradient-452);\n      }\n\n      .cls-455 {\n        fill: url(#linear-gradient-453);\n      }\n\n      .cls-456 {\n        fill: url(#linear-gradient-454);\n      }\n\n      .cls-457 {\n        fill: url(#linear-gradient-455);\n      }\n\n      .cls-458 {\n        fill: url(#linear-gradient-456);\n      }\n\n      .cls-459 {\n        fill: url(#linear-gradient-457);\n      }\n\n      .cls-460 {\n        fill: url(#linear-gradient-458);\n      }\n\n      .cls-461 {\n        fill: url(#linear-gradient-459);\n      }\n\n      .cls-462 {\n        fill: url(#linear-gradient-460);\n      }\n\n      .cls-463 {\n        fill: url(#linear-gradient-461);\n      }\n\n      .cls-464 {\n        fill: url(#linear-gradient-462);\n      }\n\n      .cls-465 {\n        fill: url(#linear-gradient-463);\n      }\n\n      .cls-466 {\n        fill: url(#linear-gradient-464);\n      }\n\n      .cls-467 {\n        fill: url(#linear-gradient-465);\n      }\n\n      .cls-468 {\n        fill: url(#linear-gradient-466);\n      }\n\n      .cls-469 {\n        fill: url(#linear-gradient-467);\n      }\n\n      .cls-470 {\n        fill: url(#linear-gradient-468);\n      }\n\n      .cls-471 {\n        fill: url(#linear-gradient-469);\n      }\n\n      .cls-472 {\n        fill: url(#linear-gradient-470);\n      }\n\n      .cls-473 {\n        fill: url(#linear-gradient-471);\n      }\n\n      .cls-474 {\n        fill: url(#linear-gradient-472);\n      }\n\n      .cls-475 {\n        fill: url(#linear-gradient-473);\n      }\n\n      .cls-476 {\n        fill: url(#linear-gradient-474);\n      }\n\n      .cls-477 {\n        fill: url(#linear-gradient-475);\n      }\n\n      .cls-478 {\n        fill: url(#linear-gradient-476);\n      }\n\n      .cls-479 {\n        fill: url(#linear-gradient-477);\n      }\n\n      .cls-480 {\n        fill: url(#linear-gradient-478);\n      }\n\n      .cls-481 {\n        fill: url(#linear-gradient-479);\n      }\n\n      .cls-482 {\n        fill: url(#linear-gradient-480);\n      }\n\n      .cls-483 {\n        fill: url(#linear-gradient-481);\n      }\n\n      .cls-484 {\n        fill: url(#linear-gradient-482);\n      }\n\n      .cls-485 {\n        fill: url(#linear-gradient-483);\n      }\n\n      .cls-486 {\n        fill: url(#linear-gradient-484);\n      }\n\n      .cls-487 {\n        fill: url(#linear-gradient-485);\n      }\n\n      .cls-488 {\n        fill: url(#linear-gradient-486);\n      }\n\n      .cls-489 {\n        fill: url(#linear-gradient-487);\n      }\n\n      .cls-490 {\n        fill: url(#linear-gradient-488);\n      }\n\n      .cls-491 {\n        fill: url(#linear-gradient-489);\n      }\n\n      .cls-492 {\n        fill: url(#linear-gradient-490);\n      }\n\n      .cls-493 {\n        fill: url(#linear-gradient-491);\n      }\n\n      .cls-494 {\n        fill: url(#linear-gradient-492);\n      }\n\n      .cls-495 {\n        fill: url(#linear-gradient-493);\n      }\n\n      .cls-496 {\n        fill: url(#linear-gradient-494);\n      }\n\n      .cls-497 {\n        fill: url(#linear-gradient-495);\n      }\n\n      .cls-498 {\n        fill: url(#linear-gradient-496);\n      }\n\n      .cls-499 {\n        fill: url(#linear-gradient-497);\n      }\n\n      .cls-500 {\n        fill: url(#linear-gradient-498);\n      }\n\n      .cls-501 {\n        fill: url(#linear-gradient-499);\n      }\n\n      .cls-502 {\n        fill: url(#linear-gradient-500);\n      }\n\n      .cls-503 {\n        fill: url(#linear-gradient-501);\n      }\n\n      .cls-504 {\n        fill: url(#linear-gradient-502);\n      }\n\n      .cls-505 {\n        fill: url(#linear-gradient-503);\n      }\n\n      .cls-506 {\n        fill: url(#linear-gradient-504);\n      }\n\n      .cls-507 {\n        fill: url(#linear-gradient-505);\n      }\n\n      .cls-508 {\n        fill: url(#linear-gradient-506);\n      }\n\n      .cls-509 {\n        fill: url(#linear-gradient-507);\n      }\n\n      .cls-510 {\n        fill: url(#linear-gradient-508);\n      }\n\n      .cls-511 {\n        fill: url(#linear-gradient-509);\n      }\n\n      .cls-512 {\n        fill: url(#linear-gradient-510);\n      }\n\n      .cls-513 {\n        fill: url(#linear-gradient-511);\n      }\n\n      .cls-514 {\n        fill: url(#linear-gradient-512);\n      }\n\n      .cls-515 {\n        fill: url(#linear-gradient-513);\n      }\n\n      .cls-516 {\n        fill: url(#linear-gradient-514);\n      }\n\n      .cls-517 {\n        fill: url(#linear-gradient-515);\n      }\n\n      .cls-518 {\n        fill: url(#linear-gradient-516);\n      }\n\n      .cls-519 {\n        fill: url(#linear-gradient-517);\n      }\n\n      .cls-520 {\n        fill: url(#linear-gradient-518);\n      }\n\n      .cls-521 {\n        fill: url(#linear-gradient-519);\n      }\n\n      .cls-522 {\n        fill: url(#linear-gradient-520);\n      }\n\n      .cls-523 {\n        fill: url(#linear-gradient-521);\n      }\n\n      .cls-524 {\n        fill: url(#linear-gradient-522);\n      }\n\n      .cls-525 {\n        fill: url(#linear-gradient-523);\n      }\n\n      .cls-526 {\n        fill: url(#linear-gradient-524);\n      }\n\n      .cls-527 {\n        fill: url(#linear-gradient-525);\n      }\n\n      .cls-528 {\n        fill: url(#linear-gradient-526);\n      }\n\n      .cls-529 {\n        fill: url(#linear-gradient-527);\n      }\n\n      .cls-530 {\n        fill: url(#linear-gradient-528);\n      }\n\n      .cls-531 {\n        fill: url(#linear-gradient-529);\n      }\n\n      .cls-532 {\n        fill: url(#linear-gradient-530);\n      }\n\n      .cls-533 {\n        fill: url(#linear-gradient-531);\n      }\n\n      .cls-534 {\n        fill: url(#linear-gradient-532);\n      }\n\n      .cls-535 {\n        fill: url(#linear-gradient-533);\n      }\n\n      .cls-536 {\n        fill: url(#linear-gradient-534);\n      }\n\n      .cls-537 {\n        fill: url(#linear-gradient-535);\n      }\n\n      .cls-538 {\n        fill: url(#linear-gradient-536);\n      }\n\n      .cls-539 {\n        fill: url(#linear-gradient-537);\n      }\n\n      .cls-540 {\n        fill: url(#linear-gradient-538);\n      }\n\n      .cls-541 {\n        fill: url(#linear-gradient-539);\n      }\n\n      .cls-542 {\n        fill: url(#linear-gradient-540);\n      }\n\n      .cls-543 {\n        fill: url(#linear-gradient-541);\n      }\n\n      .cls-544 {\n        fill: url(#linear-gradient-542);\n      }\n\n      .cls-545 {\n        fill: url(#linear-gradient-543);\n      }\n\n      .cls-546 {\n        fill: url(#linear-gradient-544);\n      }\n\n      .cls-547 {\n        fill: url(#linear-gradient-545);\n      }\n\n      .cls-548 {\n        fill: url(#linear-gradient-546);\n      }\n\n      .cls-549 {\n        fill: url(#linear-gradient-547);\n      }\n\n      .cls-550 {\n        fill: url(#linear-gradient-548);\n      }\n\n      .cls-551 {\n        fill: url(#linear-gradient-549);\n      }\n\n      .cls-552 {\n        fill: url(#linear-gradient-550);\n      }\n\n      .cls-553 {\n        fill: url(#linear-gradient-551);\n      }\n\n      .cls-554 {\n        fill: url(#linear-gradient-552);\n      }\n\n      .cls-555 {\n        fill: url(#linear-gradient-553);\n      }\n\n      .cls-556 {\n        fill: url(#linear-gradient-554);\n      }\n\n      .cls-557 {\n        fill: url(#linear-gradient-555);\n      }\n\n      .cls-558 {\n        fill: url(#linear-gradient-556);\n      }\n\n      .cls-559 {\n        fill: url(#linear-gradient-557);\n      }\n\n      .cls-560 {\n        fill: url(#linear-gradient-558);\n      }\n\n      .cls-561 {\n        fill: url(#linear-gradient-559);\n      }\n\n      .cls-562 {\n        fill: url(#linear-gradient-560);\n      }\n\n      .cls-563 {\n        fill: url(#linear-gradient-561);\n      }\n\n      .cls-564 {\n        fill: url(#linear-gradient-562);\n      }\n\n      .cls-565 {\n        fill: url(#linear-gradient-563);\n      }\n\n      .cls-566 {\n        fill: url(#linear-gradient-564);\n      }\n\n      .cls-567 {\n        fill: url(#linear-gradient-565);\n      }\n\n      .cls-568 {\n        fill: url(#linear-gradient-566);\n      }\n\n      .cls-569 {\n        fill: url(#linear-gradient-567);\n      }\n\n      .cls-570 {\n        fill: url(#linear-gradient-568);\n      }\n\n      .cls-571 {\n        fill: url(#linear-gradient-569);\n      }\n\n      .cls-572 {\n        fill: url(#linear-gradient-570);\n      }\n\n      .cls-573 {\n        fill: url(#linear-gradient-571);\n      }\n\n      .cls-574 {\n        fill: url(#linear-gradient-572);\n      }\n\n      .cls-575 {\n        fill: url(#linear-gradient-573);\n      }\n\n      .cls-576 {\n        fill: url(#linear-gradient-574);\n      }\n\n      .cls-577 {\n        fill: url(#linear-gradient-575);\n      }\n\n      .cls-578 {\n        fill: url(#linear-gradient-576);\n      }\n\n      .cls-579 {\n        fill: url(#linear-gradient-577);\n      }\n\n      .cls-580 {\n        fill: url(#linear-gradient-578);\n      }\n\n      .cls-581 {\n        fill: url(#linear-gradient-579);\n      }\n\n      .cls-582 {\n        fill: url(#linear-gradient-580);\n      }\n\n      .cls-583 {\n        fill: url(#linear-gradient-581);\n      }\n\n      .cls-584 {\n        fill: url(#linear-gradient-582);\n      }\n\n      .cls-585 {\n        fill: url(#linear-gradient-583);\n      }\n\n      .cls-586 {\n        fill: url(#linear-gradient-584);\n      }\n\n      .cls-587 {\n        fill: url(#linear-gradient-585);\n      }\n\n      .cls-588 {\n        fill: url(#linear-gradient-586);\n      }\n\n      .cls-589 {\n        fill: url(#linear-gradient-587);\n      }\n\n      .cls-590 {\n        fill: url(#linear-gradient-588);\n      }\n\n      .cls-591 {\n        fill: url(#linear-gradient-589);\n      }\n\n      .cls-592 {\n        fill: url(#linear-gradient-590);\n      }\n\n      .cls-593 {\n        fill: url(#linear-gradient-591);\n      }\n\n      .cls-594 {\n        fill: url(#linear-gradient-592);\n      }\n\n      .cls-595 {\n        fill: url(#linear-gradient-593);\n      }\n\n      .cls-596 {\n        fill: url(#linear-gradient-594);\n      }\n\n      .cls-597 {\n        fill: url(#linear-gradient-595);\n      }\n\n      .cls-598 {\n        fill: url(#linear-gradient-596);\n      }\n\n      .cls-599 {\n        fill: url(#linear-gradient-597);\n      }\n\n      .cls-600 {\n        fill: url(#linear-gradient-598);\n      }\n\n      .cls-601 {\n        fill: url(#linear-gradient-599);\n      }\n\n      .cls-602 {\n        fill: url(#linear-gradient-600);\n      }\n\n      .cls-603 {\n        fill: url(#linear-gradient-601);\n      }\n\n      .cls-604 {\n        fill: url(#linear-gradient-602);\n      }\n\n      .cls-605 {\n        fill: url(#linear-gradient-603);\n      }\n\n      .cls-606 {\n        fill: url(#linear-gradient-604);\n      }\n\n      .cls-607 {\n        fill: url(#linear-gradient-605);\n      }\n\n      .cls-608 {\n        fill: url(#linear-gradient-606);\n      }\n\n      .cls-609 {\n        fill: url(#linear-gradient-607);\n      }\n\n      .cls-610 {\n        fill: url(#linear-gradient-608);\n      }\n\n      .cls-611 {\n        fill: url(#linear-gradient-609);\n      }\n\n      .cls-612 {\n        fill: url(#linear-gradient-610);\n      }\n\n      .cls-613 {\n        fill: url(#linear-gradient-611);\n      }\n\n      .cls-614 {\n        fill: url(#linear-gradient-612);\n      }\n\n      .cls-615 {\n        fill: url(#linear-gradient-613);\n      }\n\n      .cls-616 {\n        fill: url(#linear-gradient-614);\n      }\n\n      .cls-617 {\n        fill: url(#linear-gradient-615);\n      }\n\n      .cls-618 {\n        fill: url(#linear-gradient-616);\n      }\n\n      .cls-619 {\n        fill: url(#linear-gradient-617);\n      }\n\n      .cls-620 {\n        fill: url(#linear-gradient-618);\n      }\n\n      .cls-621 {\n        fill: url(#linear-gradient-619);\n      }\n\n      .cls-622 {\n        fill: url(#linear-gradient-620);\n      }\n\n      .cls-623 {\n        fill: url(#linear-gradient-621);\n      }\n\n      .cls-624 {\n        fill: url(#linear-gradient-622);\n      }\n\n      .cls-625 {\n        fill: url(#linear-gradient-623);\n      }\n\n      .cls-626 {\n        fill: url(#linear-gradient-624);\n      }\n\n      .cls-627 {\n        fill: url(#linear-gradient-625);\n      }\n\n      .cls-628 {\n        fill: url(#linear-gradient-626);\n      }\n\n      .cls-629 {\n        fill: url(#linear-gradient-627);\n      }\n\n      .cls-630 {\n        fill: url(#linear-gradient-628);\n      }\n\n      .cls-631 {\n        fill: url(#linear-gradient-629);\n      }\n\n      .cls-632 {\n        fill: url(#linear-gradient-630);\n      }\n\n      .cls-633 {\n        fill: url(#linear-gradient-631);\n      }\n\n      .cls-634 {\n        fill: url(#linear-gradient-632);\n      }\n\n      .cls-635 {\n        fill: url(#linear-gradient-633);\n      }\n\n      .cls-636 {\n        fill: url(#linear-gradient-634);\n      }\n\n      .cls-637 {\n        fill: url(#linear-gradient-635);\n      }\n\n      .cls-638 {\n        fill: url(#linear-gradient-636);\n      }\n\n      .cls-639 {\n        fill: url(#linear-gradient-637);\n      }\n\n      .cls-640 {\n        fill: url(#linear-gradient-638);\n      }\n\n      .cls-641 {\n        fill: url(#linear-gradient-639);\n      }\n\n      .cls-642 {\n        fill: url(#linear-gradient-640);\n      }\n\n      .cls-643 {\n        fill: url(#linear-gradient-641);\n      }\n\n      .cls-644 {\n        fill: url(#linear-gradient-642);\n      }\n\n      .cls-645 {\n        fill: url(#linear-gradient-643);\n      }\n\n      .cls-646 {\n        fill: url(#linear-gradient-644);\n      }\n\n      .cls-647 {\n        fill: url(#linear-gradient-645);\n      }\n\n      .cls-648 {\n        fill: url(#linear-gradient-646);\n      }\n\n      .cls-649 {\n        fill: url(#linear-gradient-647);\n      }\n\n      .cls-650 {\n        fill: url(#linear-gradient-648);\n      }\n\n      .cls-651 {\n        fill: url(#linear-gradient-649);\n      }\n\n      .cls-652 {\n        fill: url(#linear-gradient-650);\n      }\n\n      .cls-653 {\n        fill: url(#linear-gradient-651);\n      }\n\n      .cls-654 {\n        fill: url(#linear-gradient-652);\n      }\n\n      .cls-655 {\n        fill: url(#linear-gradient-653);\n      }\n\n      .cls-656 {\n        fill: url(#linear-gradient-654);\n      }\n\n      .cls-657 {\n        fill: url(#linear-gradient-655);\n      }\n\n      .cls-658 {\n        fill: url(#linear-gradient-656);\n      }\n\n      .cls-659 {\n        fill: url(#linear-gradient-657);\n      }\n\n      .cls-660 {\n        fill: url(#linear-gradient-658);\n      }\n\n      .cls-661 {\n        fill: url(#linear-gradient-659);\n      }\n\n      .cls-662 {\n        fill: url(#linear-gradient-660);\n      }\n\n      .cls-663 {\n        fill: url(#linear-gradient-661);\n      }\n\n      .cls-664 {\n        fill: url(#linear-gradient-662);\n      }\n\n      .cls-665 {\n        fill: url(#linear-gradient-663);\n      }\n\n      .cls-666 {\n        fill: url(#linear-gradient-664);\n      }\n\n      .cls-667 {\n        fill: url(#linear-gradient-665);\n      }\n\n      .cls-668 {\n        fill: url(#linear-gradient-666);\n      }\n\n      .cls-669 {\n        fill: url(#linear-gradient-667);\n      }\n\n      .cls-670 {\n        fill: url(#linear-gradient-668);\n      }\n\n      .cls-671 {\n        fill: url(#linear-gradient-669);\n      }\n\n      .cls-672 {\n        fill: url(#linear-gradient-670);\n      }\n\n      .cls-673 {\n        fill: url(#linear-gradient-671);\n      }\n\n      .cls-674 {\n        fill: url(#linear-gradient-672);\n      }\n\n      .cls-675 {\n        fill: url(#linear-gradient-673);\n      }\n\n      .cls-676 {\n        fill: url(#linear-gradient-674);\n      }\n\n      .cls-677 {\n        fill: url(#linear-gradient-675);\n      }\n\n      .cls-678 {\n        fill: url(#linear-gradient-676);\n      }\n\n      .cls-679 {\n        fill: url(#linear-gradient-677);\n      }\n\n      .cls-680 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-8.47 -2.18)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.03,
    y: 2.69,
    width: 208,
    height: 208
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -12.95,
    y1: 216.9,
    x2: -16.23,
    y2: 213.75,
    gradientTransform: "matrix(0.97, 0, 0, -1.42, 29.19, 471.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de00ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4800f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 21.17,
    y1: 181.14,
    x2: 17.89,
    y2: 177.99,
    gradientTransform: "matrix(0.66, 0, 0, -1.16, -2.99, 389.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 18.59,
    y1: 157.25,
    x2: 15.31,
    y2: 154.09,
    gradientTransform: "matrix(0.68, 0, 0, -1, -0.78, 335.95)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 4.86,
    y1: 151.72,
    x2: 1.58,
    y2: 148.57,
    gradientTransform: "matrix(0.78, 0, 0, -0.96, 10.3, 318.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 50.76,
    y1: 178.19,
    x2: 47.47,
    y2: 175.04,
    gradientTransform: "matrix(0.54, 0, 0, -1.1, -13.64, 365.58)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 8.1,
    y1: 173.51,
    x2: 4.82,
    y2: 170.36,
    gradientTransform: "matrix(0.82, 0, 0, -0.71, 17.7, 205.36)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 52.51,
    y1: 196.18,
    x2: 49.23,
    y2: 193.03,
    gradientTransform: "matrix(0.59, 0, 0, -0.81, -5.28, 239.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 63.31,
    y1: 75.75,
    x2: 60.03,
    y2: 72.59,
    gradientTransform: "matrix(0.51, 0, 0, -0.65, -15.44, 212.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 183.32,
    y1: 209.54,
    x2: 180.03,
    y2: 206.39,
    gradientTransform: "matrix(0.53, 0, 0, -0.63, 18, 162.46)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 133.74,
    y1: 221.13,
    x2: 130.45,
    y2: 217.98,
    gradientTransform: "matrix(0.4, 0, 0, -0.86, -21.41, 248.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 35.74,
    y1: 85.43,
    x2: 32.45,
    y2: 82.28,
    gradientTransform: "matrix(0.77, 0, 0, -0.75, 20.36, 254.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 107.7,
    y1: 109.42,
    x2: 104.42,
    y2: 106.27,
    gradientTransform: "matrix(0.44, 0, 0, -0.5, -18.29, 133.64)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 118.22,
    y1: 61.87,
    x2: 114.94,
    y2: 58.72,
    gradientTransform: "matrix(0.39, 0, 0, -0.59, -24.99, 185.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 167.4,
    y1: 145.17,
    x2: 164.12,
    y2: 142.02,
    gradientTransform: "matrix(0.34, 0, 0, -0.6, -28.52, 170.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 186.18,
    y1: -11.91,
    x2: 182.89,
    y2: -15.06,
    gradientTransform: "matrix(0.28, 0, 0, -0.5, -37.87, 163.27)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 232.04,
    y1: 116.29,
    x2: 228.76,
    y2: 113.14,
    gradientTransform: "matrix(0.28, 0, 0, -0.46, -33.88, 115.68)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 129.18,
    y1: -76.98,
    x2: 125.9,
    y2: -80.13,
    gradientTransform: "matrix(0.34, 0, 0, -0.44, -33.1, 142.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 165.26,
    y1: -7.16,
    x2: 161.98,
    y2: -10.31,
    gradientTransform: "matrix(0.33, 0, 0, -0.47, -31.74, 143.74)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 208.24,
    y1: -55.06,
    x2: 204.96,
    y2: -58.21,
    gradientTransform: "matrix(0.4, 0, 0, -0.51, -6.78, 175.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 207.32,
    y1: 8.91,
    x2: 204.04,
    y2: 5.76,
    gradientTransform: "matrix(0.27, 0, 0, -0.51, -37.86, 163.41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 185.39,
    y1: 126.99,
    x2: 182.1,
    y2: 123.84,
    gradientTransform: "matrix(0.53, 0, 0, -0.39, 19.38, 81.37)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 168.58,
    y1: -210.43,
    x2: 165.3,
    y2: -213.59,
    gradientTransform: "matrix(0.51, 0, 0, -0.37, 8.75, 131.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 250.99,
    y1: 204.62,
    x2: 247.71,
    y2: 201.46,
    gradientTransform: "matrix(0.41, 0, 0, -0.64, 2.19, 167.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 249.12,
    y1: 141.69,
    x2: 245.83,
    y2: 138.54,
    gradientTransform: "matrix(0.28, 0, 0, -0.47, -29.9, 115.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 175.48,
    y1: 142.59,
    x2: 172.19,
    y2: 139.44,
    gradientTransform: "matrix(0.37, 0, 0, -0.46, -21.02, 110.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 123.6,
    y1: -110.08,
    x2: 120.32,
    y2: -113.24,
    gradientTransform: "matrix(0.36, 0, 0, -0.4, -31.73, 129.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 112.42,
    y1: -226.76,
    x2: 109.14,
    y2: -229.91,
    gradientTransform: "matrix(0.38, 0, 0, -0.32, -29.61, 104.41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 147.54,
    y1: -37.9,
    x2: 144.25,
    y2: -41.05,
    gradientTransform: "matrix(0.33, 0, 0, -0.47, -34.01, 154.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 182.26,
    y1: 80.62,
    x2: 178.97,
    y2: 77.46,
    gradientTransform: "matrix(0.32, 0, 0, -0.41, -30.7, 101.24)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 162.23,
    y1: 164.69,
    x2: 158.95,
    y2: 161.54,
    gradientTransform: "matrix(0.38, 0, 0, -0.53, -19.58, 133)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1110.17,
    y1: 49.74,
    x2: 1106.88,
    y2: 46.59,
    gradientTransform: "matrix(0.16, 0, 0, -0.63, 2.42, 210.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1292.76,
    y1: -108.88,
    x2: 1289.47,
    y2: -112.03,
    gradientTransform: "matrix(0.14, 0, 0, -0.42, -0.49, 138.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 265.4,
    y1: 105.53,
    x2: 262.12,
    y2: 102.38,
    gradientTransform: "matrix(0.42, 0, 0, -0.35, 7.92, 67.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 255.95,
    y1: -224.06,
    x2: 252.66,
    y2: -227.21,
    gradientTransform: "matrix(0.35, 0, 0, -0.34, -10.42, 116.77)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 274.65,
    y1: -573.32,
    x2: 271.36,
    y2: -576.47,
    gradientTransform: "matrix(0.55, 0, 0, -0.12, 44.23, 5.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 638.99,
    y1: 110.08,
    x2: 635.7,
    y2: 106.93,
    gradientTransform: "matrix(0.29, 0, 0, -0.54, 23.5, 153.16)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 135.24,
    y1: -131.55,
    x2: 131.95,
    y2: -134.7,
    gradientTransform: "matrix(0.39, 0, 0, -0.27, -22.94, 58.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 419.99,
    y1: -28.15,
    x2: 416.71,
    y2: -31.3,
    gradientTransform: "matrix(0.24, 0, 0, -0.52, -21.05, 175.79)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 419.93,
    y1: -266.68,
    x2: 416.65,
    y2: -269.84,
    gradientTransform: "matrix(0.38, 0, 0, -0.3, 24, 96.86)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1149.62,
    y1: -95.85,
    x2: 1146.33,
    y2: -99,
    gradientTransform: "matrix(0.16, 0, 0, -0.39, 5.21, 122.91)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 559.07,
    y1: -21.57,
    x2: 555.79,
    y2: -24.72,
    gradientTransform: "matrix(0.32, 0, 0, -0.26, 25.64, 41.91)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 221.7,
    y1: -167.01,
    x2: 218.42,
    y2: -170.16,
    gradientTransform: "matrix(0.45, 0, 0, -0.17, 6.53, 7.54)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 530.87,
    y1: 2.7,
    x2: 527.58,
    y2: -0.46,
    gradientTransform: "matrix(0.14, 0, 0, -0.4, -49.77, 109.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 271.62,
    y1: -37.17,
    x2: 268.34,
    y2: -40.32,
    gradientTransform: "matrix(0.22, 0, 0, -0.4, -43.52, 116.51)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 318.19,
    y1: -239.78,
    x2: 314.91,
    y2: -242.93,
    gradientTransform: "matrix(0.19, 0, 0, -0.32, -48.81, 105.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 242.14,
    y1: -58.82,
    x2: 238.86,
    y2: -61.97,
    gradientTransform: "matrix(0.25, 0, 0, -0.3, -38.42, 67.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 250.2,
    y1: -92.06,
    x2: 246.92,
    y2: -95.21,
    gradientTransform: "matrix(0.24, 0, 0, -0.39, -41.76, 122.64)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 143.1,
    y1: -287.83,
    x2: 139.81,
    y2: -290.98,
    gradientTransform: "matrix(0.34, 0, 0, -0.27, -31.15, 80.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 535.01,
    y1: -146.48,
    x2: 531.72,
    y2: -149.64,
    gradientTransform: "matrix(0.2, 0, 0, -0.39, -24.87, 131.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 141.15,
    y1: -104.63,
    x2: 137.87,
    y2: -107.78,
    gradientTransform: "matrix(0.37, 0, 0, -0.29, -26.03, 71.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 421.7,
    y1: -412.16,
    x2: 418.42,
    y2: -415.31,
    gradientTransform: "matrix(0.41, 0, 0, -0.23, 34.37, 66.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 945.09,
    y1: -26.84,
    x2: 941.8,
    y2: -30,
    gradientTransform: "matrix(0.2, 0, 0, -0.35, 13.11, 89.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 146.16,
    y1: -402.94,
    x2: 142.87,
    y2: -406.09,
    gradientTransform: "matrix(0.37, 0, 0, -0.16, -24.93, 17.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1177.29,
    y1: -292.21,
    x2: 1174.01,
    y2: -295.36,
    gradientTransform: "matrix(0.15, 0, 0, -0.28, 3.13, 88.32)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 820.69,
    y1: -26.1,
    x2: 817.41,
    y2: -29.25,
    gradientTransform: "matrix(0.23, 0, 0, -0.28, 17.4, 50.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 268.74,
    y1: -210.18,
    x2: 265.46,
    y2: -213.33,
    gradientTransform: "matrix(0.23, 0, 0, -0.26, -41.57, 65.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 531.87,
    y1: 53.16,
    x2: 528.59,
    y2: 50.01,
    gradientTransform: "matrix(0.14, 0, 0, -0.4, -48.98, 99.41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 207.98,
    y1: -156.05,
    x2: 204.69,
    y2: -159.2,
    gradientTransform: "matrix(0.3, 0, 0, -0.2, -30.76, 26.68)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 390.53,
    y1: -254.39,
    x2: 387.25,
    y2: -257.54,
    gradientTransform: "matrix(0.17, 0, 0, -0.24, -47.71, 60.59)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 160.74,
    y1: -158.35,
    x2: 157.45,
    y2: -161.5,
    gradientTransform: "matrix(0.32, 0, 0, -0.3, -33.11, 79.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 225.68,
    y1: -27.75,
    x2: 222.39,
    y2: -30.9,
    gradientTransform: "matrix(0.29, 0, 0, -0.27, -31.56, 48.66)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 566.53,
    y1: 35.27,
    x2: 563.24,
    y2: 32.12,
    gradientTransform: "matrix(0.23, 0, 0, -0.27, -10.17, 39.74)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 535.66,
    y1: -482.98,
    x2: 532.38,
    y2: -486.13,
    gradientTransform: "matrix(0.25, 0, 0, -0.24, -5.2, 80.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 232.45,
    y1: -291.77,
    x2: 229.16,
    y2: -294.92,
    gradientTransform: "matrix(0.36, 0, 0, -0.11, -13.35, -18.75)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 250.09,
    y1: -216.23,
    x2: 246.8,
    y2: -219.38,
    gradientTransform: "matrix(0.25, 0, 0, -0.33, -39.7, 108.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 394.83,
    y1: 147.76,
    x2: 391.55,
    y2: 144.61,
    gradientTransform: "matrix(0.34, 0, 0, -0.37, 7.47, 69.61)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 295.06,
    y1: -74.57,
    x2: 291.78,
    y2: -77.72,
    gradientTransform: "matrix(0.22, 0, 0, -0.28, -40.45, 61.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 769.33,
    y1: -516.1,
    x2: 766.04,
    y2: -519.25,
    gradientTransform: "matrix(0.23, 0, 0, -0.2, 11.93, 58.61)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 876.28,
    y1: -140.1,
    x2: 873,
    y2: -143.25,
    gradientTransform: "matrix(0.21, 0, 0, -0.21, 15.09, 30.77)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 395.44,
    y1: -334.38,
    x2: 392.15,
    y2: -337.53,
    gradientTransform: "matrix(0.39, 0, 0, -0.28, 24.57, 90.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 860.57,
    y1: 111.83,
    x2: 857.29,
    y2: 108.68,
    gradientTransform: "matrix(0.19, 0, 0, -0.31, -1.95, 47.51)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 312.78,
    y1: -297.46,
    x2: 309.5,
    y2: -300.61,
    gradientTransform: "matrix(0.21, 0, 0, -0.21, -42.78, 46.61)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 201.2,
    y1: -930.73,
    x2: 197.92,
    y2: -933.88,
    gradientTransform: "matrix(0.26, 0, 0, -0.15, -42.41, 47.04)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 590.49,
    y1: 71.26,
    x2: 587.21,
    y2: 68.11,
    gradientTransform: "matrix(0.24, 0, 0, -0.26, -1.63, 32.89)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 343.1,
    y1: -176.17,
    x2: 339.82,
    y2: -179.32,
    gradientTransform: "matrix(0.21, 0, 0, -0.22, -40.87, 39.59)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 1537.89,
    y1: -9.4,
    x2: 1534.61,
    y2: -12.55,
    gradientTransform: "matrix(0.13, 0, 0, -0.38, 7.51, 103.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 701.47,
    y1: 106.2,
    x2: 698.19,
    y2: 103.05,
    gradientTransform: "matrix(0.19, 0, 0, -0.31, -13.62, 48.82)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 594.64,
    y1: -585.02,
    x2: 591.36,
    y2: -588.17,
    gradientTransform: "matrix(0.18, 0, 0, -0.22, -28.56, 75.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 2187.11,
    y1: -179.08,
    x2: 2183.83,
    y2: -182.23,
    gradientTransform: "matrix(0.09, 0, 0, -0.18, 2.25, 17.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 664.57,
    y1: -280,
    x2: 661.29,
    y2: -283.15,
    gradientTransform: "matrix(0.24, 0, 0, -0.12, 5.69, -13.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 281.02,
    y1: -366.77,
    x2: 277.74,
    y2: -369.93,
    gradientTransform: "matrix(0.21, 0, 0, -0.22, -44.94, 60.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 941.36,
    y1: -185.05,
    x2: 938.08,
    y2: -188.2,
    gradientTransform: "matrix(0.19, 0, 0, -0.16, 7.73, 4.31)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 256.88,
    y1: -213.06,
    x2: 253.6,
    y2: -216.21,
    gradientTransform: "matrix(0.25, 0, 0, -0.24, -38.53, 53.72)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 762.48,
    y1: -632.81,
    x2: 759.19,
    y2: -635.97,
    gradientTransform: "matrix(0.18, 0, 0, -0.2, -12.19, 71.04)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 300.1,
    y1: -1010.81,
    x2: 296.81,
    y2: -1013.96,
    gradientTransform: "matrix(0.26, 0, 0, -0.14, -30.9, 46.72)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 546.21,
    y1: -29.38,
    x2: 542.92,
    y2: -32.53,
    gradientTransform: "matrix(0.24, 0, 0, -0.19, -6.74, 7.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 1515.48,
    y1: 10.56,
    x2: 1512.2,
    y2: 7.41,
    gradientTransform: "matrix(0.09, 0, 0, -0.22, -23.54, 18.74)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 211.75,
    y1: -406.39,
    x2: 208.46,
    y2: -409.54,
    gradientTransform: "matrix(0.26, 0, 0, -0.24, -40.68, 72.39)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 428.6,
    y1: -436.16,
    x2: 425.32,
    y2: -439.31,
    gradientTransform: "matrix(0.18, 0, 0, -0.23, -43.25, 72.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 1240.77,
    y1: -224.61,
    x2: 1237.49,
    y2: -227.76,
    gradientTransform: "matrix(0.07, 0, 0, -0.17, -52.1, 14.46)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 796.08,
    y1: -181.49,
    x2: 792.8,
    y2: -184.64,
    gradientTransform: "matrix(0.09, 0, 0, -0.29, -56.51, 81.46)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 477.13,
    y1: -141.3,
    x2: 473.84,
    y2: -144.45,
    gradientTransform: "matrix(0.16, 0, 0, -0.21, -43.39, 27.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 330.23,
    y1: -77.75,
    x2: 326.94,
    y2: -80.9,
    gradientTransform: "matrix(0.34, 0, 0, -0.2, -1.8, 14.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 332.5,
    y1: -144.67,
    x2: 329.21,
    y2: -147.82,
    gradientTransform: "matrix(0.19, 0, 0, -0.31, -46.15, 83.74)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 783.4,
    y1: -217.5,
    x2: 780.11,
    y2: -220.65,
    gradientTransform: "matrix(0.11, 0, 0, -0.16, -45.37, 7.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 480.98,
    y1: 55.71,
    x2: 477.7,
    y2: 52.56,
    gradientTransform: "matrix(0.23, 0, 0, -0.26, -17.78, 32.03)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 223.22,
    y1: -1452.23,
    x2: 219.94,
    y2: -1455.38,
    gradientTransform: "matrix(0.26, 0, 0, -0.08, -38.22, 2.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 688.77,
    y1: -6.42,
    x2: 685.49,
    y2: -9.57,
    gradientTransform: "matrix(0.11, 0, 0, -0.35, -50.88, 85.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 564.49,
    y1: -203.52,
    x2: 561.21,
    y2: -206.67,
    gradientTransform: "matrix(0.13, 0, 0, -0.22, -48.47, 37.66)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 966.31,
    y1: -129.25,
    x2: 963.02,
    y2: -132.4,
    gradientTransform: "matrix(0.14, 0, 0, -0.17, -20.59, 7.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 334.77,
    y1: -487.58,
    x2: 331.49,
    y2: -490.73,
    gradientTransform: "matrix(0.2, 0, 0, -0.14, -42.28, 13.15)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 2222.64,
    y1: 68.34,
    x2: 2219.36,
    y2: 65.19,
    gradientTransform: "matrix(0.09, 0, 0, -0.3, -0.83, 50.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 269.81,
    y1: -297.11,
    x2: 266.53,
    y2: -300.26,
    gradientTransform: "matrix(0.24, 0, 0, -0.19, -39.05, 29.21)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 445.13,
    y1: -599.4,
    x2: 441.84,
    y2: -602.55,
    gradientTransform: "matrix(0.17, 0, 0, -0.19, -42.34, 53.95)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 370.23,
    y1: -448.6,
    x2: 366.95,
    y2: -451.76,
    gradientTransform: "matrix(0.17, 0, 0, -0.22, -48.07, 66.32)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 527.21,
    y1: -478.05,
    x2: 523.92,
    y2: -481.2,
    gradientTransform: "matrix(0.15, 0, 0, -0.22, -45.76, 66.56)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 1457.53,
    y1: -7,
    x2: 1454.25,
    y2: -10.15,
    gradientTransform: "matrix(0.1, 0, 0, -0.21, -21.17, 13.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 1084.55,
    y1: -31.69,
    x2: 1081.27,
    y2: -34.84,
    gradientTransform: "matrix(0.13, 0, 0, -0.19, -19.71, 8.69)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 812.21,
    y1: -731.71,
    x2: 808.92,
    y2: -734.86,
    gradientTransform: "matrix(0.1, 0, 0, -0.17, -51.15, 53.58)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 1093.13,
    y1: -396.5,
    x2: 1089.85,
    y2: -399.65,
    gradientTransform: "matrix(0.16, 0, 0, -0.25, 2.27, 81.46)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 1078.46,
    y1: -171.38,
    x2: 1075.17,
    y2: -174.53,
    gradientTransform: "matrix(0.17, 0, 0, -0.17, 5.01, 6.72)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 1764.47,
    y1: -891.57,
    x2: 1761.19,
    y2: -894.72,
    gradientTransform: "matrix(0.08, 0, 0, -0.16, -25.19, 55.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 895.73,
    y1: -536.96,
    x2: 892.45,
    y2: -540.11,
    gradientTransform: "matrix(0.12, 0, 0, -0.23, -34.37, 82.89)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 895.88,
    y1: -893.93,
    x2: 892.6,
    y2: -897.08,
    gradientTransform: "matrix(0.21, 0, 0, -0.11, 13.21, 10.51)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 1021.3,
    y1: -0.29,
    x2: 1018.02,
    y2: -3.44,
    gradientTransform: "matrix(0.1, 0, 0, -0.23, -41.4, 23.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 1549.16,
    y1: -595.61,
    x2: 1545.87,
    y2: -598.76,
    gradientTransform: "matrix(0.12, 0, 0, -0.15, 3.31, 22.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 3185.94,
    y1: -323.85,
    x2: 3182.66,
    y2: -327,
    gradientTransform: "matrix(0.06, 0, 0, -0.16, -0.93, 12.71)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 722.28,
    y1: -621.17,
    x2: 718.99,
    y2: -624.32,
    gradientTransform: "matrix(0.1, 0, 0, -0.16, -55.33, 32.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 693.46,
    y1: -269.29,
    x2: 690.17,
    y2: -272.44,
    gradientTransform: "matrix(0.12, 0, 0, -0.16, -45.95, 8.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 237.38,
    y1: -311.09,
    x2: 234.1,
    y2: -314.24,
    gradientTransform: "matrix(0.25, 0, 0, -0.25, -39.15, 71.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 182.94,
    y1: -1700.64,
    x2: 179.66,
    y2: -1703.79,
    gradientTransform: "matrix(0.29, 0, 0, -0.08, -36.4, 18.51)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 1904.25,
    y1: -279.94,
    x2: 1900.97,
    y2: -283.1,
    gradientTransform: "matrix(0.1, 0, 0, -0.27, -0.44, 82.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 970.77,
    y1: -362.34,
    x2: 967.48,
    y2: -365.49,
    gradientTransform: "matrix(0.2, 0, 0, -0.24, 13.3, 72.21)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 1688.66,
    y1: -556.01,
    x2: 1685.38,
    y2: -559.16,
    gradientTransform: "matrix(0.11, 0, 0, -0.19, 1.68, 54.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 1534.22,
    y1: -551.06,
    x2: 1530.93,
    y2: -554.21,
    gradientTransform: "matrix(0.12, 0, 0, -0.1, -0.15, -16.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 2366.43,
    y1: -434.69,
    x2: 2363.15,
    y2: -437.85,
    gradientTransform: "matrix(0.09, 0, 0, -0.12, 3.31, -5.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 2251.46,
    y1: -648.39,
    x2: 2248.18,
    y2: -651.54,
    gradientTransform: "matrix(0.09, 0, 0, -0.1, 2.79, -13.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 646.6,
    y1: -682.94,
    x2: 643.32,
    y2: -686.09,
    gradientTransform: "matrix(0.21, 0, 0, -0.07, -10.93, -32.61)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 686.87,
    y1: -41.71,
    x2: 683.59,
    y2: -44.86,
    gradientTransform: "matrix(0.2, 0, 0, -0.19, -12.57, 8.04)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 287,
    y1: -1200.62,
    x2: 283.72,
    y2: -1203.77,
    gradientTransform: "matrix(0.25, 0, 0, -0.11, -34.94, 28.62)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 1382.44,
    y1: -701.42,
    x2: 1379.16,
    y2: -704.58,
    gradientTransform: "matrix(0.14, 0, 0, -0.17, 6.78, 46.24)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 1667.19,
    y1: -660.73,
    x2: 1663.91,
    y2: -663.88,
    gradientTransform: "matrix(0.11, 0, 0, -0.17, 2.34, 47.15)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 307.08,
    y1: -2085.44,
    x2: 303.8,
    y2: -2088.59,
    gradientTransform: "matrix(0.2, 0, 0, -0.06, -45.99, 4.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 387.19,
    y1: -250.33,
    x2: 383.91,
    y2: -253.48,
    gradientTransform: "matrix(0.17, 0, 0, -0.25, -48, 63.76)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 255.55,
    y1: -820.15,
    x2: 252.27,
    y2: -823.3,
    gradientTransform: "matrix(0.24, 0, 0, -0.13, -41.45, 21.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 1679.22,
    y1: -976.91,
    x2: 1675.94,
    y2: -980.07,
    gradientTransform: "matrix(0.08, 0, 0, -0.15, -25.58, 54.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 613.08,
    y1: -1011.87,
    x2: 609.8,
    y2: -1015.03,
    gradientTransform: "matrix(0.14, 0, 0, -0.14, -42.08, 47.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 859.79,
    y1: -764.2,
    x2: 856.51,
    y2: -767.35,
    gradientTransform: "matrix(0.13, 0, 0, -0.17, -31.09, 56.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 819.69,
    y1: -139.92,
    x2: 816.41,
    y2: -143.07,
    gradientTransform: "matrix(0.17, 0, 0, -0.14, -13.58, -8.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 911.69,
    y1: -1476.44,
    x2: 908.41,
    y2: -1479.59,
    gradientTransform: "matrix(0.11, 0, 0, -0.1, -42.54, 32.31)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 944.01,
    y1: -749.48,
    x2: 940.73,
    y2: -752.63,
    gradientTransform: "matrix(0.09, 0, 0, -0.17, -52.58, 55.01)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 484.06,
    y1: -973.88,
    x2: 480.78,
    y2: -977.03,
    gradientTransform: "matrix(0.16, 0, 0, -0.14, -45.45, 44.29)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 709.75,
    y1: 38.54,
    x2: 706.47,
    y2: 35.39,
    gradientTransform: "matrix(0.23, 0, 0, -0.24, 7.42, 23.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 1112.27,
    y1: -713.04,
    x2: 1108.99,
    y2: -716.19,
    gradientTransform: "matrix(0.18, 0, 0, -0.12, 13.59, 7.31)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 421.72,
    y1: -251.2,
    x2: 418.44,
    y2: -254.35,
    gradientTransform: "matrix(0.18, 0, 0, -0.21, -43.86, 36.89)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 2056.17,
    y1: -123.4,
    x2: 2052.89,
    y2: -126.55,
    gradientTransform: "matrix(0.1, 0, 0, -0.26, 6.67, 55.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 2944.97,
    y1: -469.66,
    x2: 2941.68,
    y2: -472.81,
    gradientTransform: "matrix(0.07, 0, 0, -0.16, -0.4, 25.61)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 630.68,
    y1: -942.97,
    x2: 627.39,
    y2: -946.12,
    gradientTransform: "matrix(0.12, 0, 0, -0.1, -50.87, 6.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 359.18,
    y1: -1200.43,
    x2: 355.9,
    y2: -1203.58,
    gradientTransform: "matrix(0.19, 0, 0, -0.08, -44.61, -9.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 1477.85,
    y1: -270.19,
    x2: 1474.56,
    y2: -273.34,
    gradientTransform: "matrix(0.13, 0, 0, -0.22, 4.7, 46.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 1612.59,
    y1: -133.72,
    x2: 1609.3,
    y2: -136.87,
    gradientTransform: "matrix(0.12, 0, 0, -0.24, 2.15, 45.77)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 581.72,
    y1: -1416.69,
    x2: 578.44,
    y2: -1419.84,
    gradientTransform: "matrix(0.3, 0, 0, -0.08, 20.83, -0.62)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 527.14,
    y1: -865.09,
    x2: 523.86,
    y2: -868.24,
    gradientTransform: "matrix(0.13, 0, 0, -0.15, -53.92, 46.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 2725.32,
    y1: -269.52,
    x2: 2722.03,
    y2: -272.67,
    gradientTransform: "matrix(0.08, 0, 0, -0.2, 4.03, 34.95)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 1298.47,
    y1: -3258.9,
    x2: 1295.19,
    y2: -3262.06,
    gradientTransform: "matrix(0.1, 0, 0, -0.06, -31.51, 25.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 1954.87,
    y1: -1863.12,
    x2: 1951.58,
    y2: -1866.27,
    gradientTransform: "matrix(0.05, 0, 0, -0.08, -46.96, 23.53)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 411.15,
    y1: -1458.77,
    x2: 407.87,
    y2: -1461.93,
    gradientTransform: "matrix(0.24, 0, 0, -0.11, -22.63, 42.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 1341.05,
    y1: -829.66,
    x2: 1337.77,
    y2: -832.81,
    gradientTransform: "matrix(0.12, 0, 0, -0.16, -9.76, 48.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 661.41,
    y1: -945.03,
    x2: 658.13,
    y2: -948.18,
    gradientTransform: "matrix(0.11, 0, 0, -0.14, -52.92, 44.25)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 743.81,
    y1: -791.47,
    x2: 740.53,
    y2: -794.62,
    gradientTransform: "matrix(0.1, 0, 0, -0.16, -54.32, 51.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 206.28,
    y1: -10540.77,
    x2: 202.99,
    y2: -10543.92,
    gradientTransform: "matrix(0.3, 0, 0, -0.02, -31.55, 1.91)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 768.2,
    y1: -390.49,
    x2: 764.92,
    y2: -393.64,
    gradientTransform: "matrix(0.1, 0, 0, -0.17, -52.18, 22.41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 532.91,
    y1: -718.99,
    x2: 529.62,
    y2: -722.14,
    gradientTransform: "matrix(0.14, 0, 0, -0.11, -48.1, 4.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 529.91,
    y1: -414.14,
    x2: 526.63,
    y2: -417.29,
    gradientTransform: "matrix(0.14, 0, 0, -0.16, -49.07, 20.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 463.76,
    y1: -559.94,
    x2: 460.47,
    y2: -563.09,
    gradientTransform: "matrix(0.15, 0, 0, -0.13, -47.64, 11.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 860.69,
    y1: -203.81,
    x2: 857.41,
    y2: -206.96,
    gradientTransform: "matrix(0.15, 0, 0, -0.16, -22.29, 4.53)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 498.12,
    y1: -303.47,
    x2: 494.83,
    y2: -306.62,
    gradientTransform: "matrix(0.14, 0, 0, -0.17, -49.26, 22.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 461.48,
    y1: -532.82,
    x2: 458.19,
    y2: -535.97,
    gradientTransform: "matrix(0.15, 0, 0, -0.13, -49.59, 10.16)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 673.73,
    y1: -3455.05,
    x2: 670.45,
    y2: -3458.2,
    gradientTransform: "matrix(0.2, 0, 0, -0.05, -14.27, 19.72)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 1010.75,
    y1: -329.79,
    x2: 1007.47,
    y2: -332.95,
    gradientTransform: "matrix(0.11, 0, 0, -0.29, -34.63, 101.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 1359.21,
    y1: -497.32,
    x2: 1355.93,
    y2: -500.47,
    gradientTransform: "matrix(0.14, 0, 0, -0.16, 8.41, 26.92)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 22598.69,
    y1: -6013.07,
    x2: 22595.41,
    y2: -6016.23,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -5.72, -19.93)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 518.07,
    y1: -6648.09,
    x2: 514.79,
    y2: -6651.25,
    gradientTransform: "matrix(0.16, 0, 0, -0.02, -43.31, -3.39)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 279.38,
    y1: -2107.61,
    x2: 276.09,
    y2: -2110.76,
    gradientTransform: "matrix(0.23, 0, 0, -0.07, -41.02, 7.88)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 950.22,
    y1: -731.47,
    x2: 946.93,
    y2: -734.62,
    gradientTransform: "matrix(0.09, 0, 0, -0.09, -48.82, -15.64)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 1194,
    y1: -1703.34,
    x2: 1190.72,
    y2: -1706.5,
    gradientTransform: "matrix(0.17, 0, 0, -0.08, 14.04, 10.91)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 1992.04,
    y1: -1813.09,
    x2: 1988.76,
    y2: -1816.24,
    gradientTransform: "matrix(0.1, 0, 0, -0.07, 7.97, 8.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 1366.36,
    y1: -301.1,
    x2: 1363.08,
    y2: -304.25,
    gradientTransform: "matrix(0.07, 0, 0, -0.15, -52.62, 8.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 399.27,
    y1: -340.21,
    x2: 395.99,
    y2: -343.36,
    gradientTransform: "matrix(0.16, 0, 0, -0.22, -49.31, 57.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 675.2,
    y1: -857.58,
    x2: 671.92,
    y2: -860.73,
    gradientTransform: "matrix(0.27, 0, 0, -0.08, 21.46, -14.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 2733.15,
    y1: -481.77,
    x2: 2729.86,
    y2: -484.92,
    gradientTransform: "matrix(0.07, 0, 0, -0.17, -1.43, 29.35)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 1460.97,
    y1: -780.38,
    x2: 1457.68,
    y2: -783.53,
    gradientTransform: "matrix(0.13, 0, 0, -0.12, 3.65, 15.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 912.68,
    y1: -652.61,
    x2: 909.4,
    y2: -655.76,
    gradientTransform: "matrix(0.21, 0, 0, -0.12, 17.62, 8.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 1501.51,
    y1: -852.23,
    x2: 1498.22,
    y2: -855.38,
    gradientTransform: "matrix(0.11, 0, 0, -0.15, -8.96, 43.54)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 619.42,
    y1: -780.16,
    x2: 616.13,
    y2: -783.32,
    gradientTransform: "matrix(0.12, 0, 0, -0.12, -49.76, 9.35)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 2226.6,
    y1: -1327.15,
    x2: 2223.31,
    y2: -1330.3,
    gradientTransform: "matrix(0.08, 0, 0, -0.11, -3.12, 28.41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 1074.06,
    y1: -1808.41,
    x2: 1070.78,
    y2: -1811.56,
    gradientTransform: "matrix(0.07, 0, 0, -0.08, -58.87, 17.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 1342.52,
    y1: -969.61,
    x2: 1339.23,
    y2: -972.76,
    gradientTransform: "matrix(0.14, 0, 0, -0.13, 7.3, 34.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 1095.35,
    y1: -885.65,
    x2: 1092.07,
    y2: -888.8,
    gradientTransform: "matrix(0.17, 0, 0, -0.14, 8.33, 36.75)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 467.54,
    y1: -365.86,
    x2: 464.26,
    y2: -369.01,
    gradientTransform: "matrix(0.15, 0, 0, -0.16, -47.35, 13.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 765.24,
    y1: -536.7,
    x2: 761.96,
    y2: -539.85,
    gradientTransform: "matrix(0.11, 0, 0, -0.19, -47.85, 54.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 694.43,
    y1: -1848.77,
    x2: 691.15,
    y2: -1851.92,
    gradientTransform: "matrix(0.24, 0, 0, -0.03, 7.23, -44.89)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 1121.07,
    y1: -56.34,
    x2: 1117.79,
    y2: -59.49,
    gradientTransform: "matrix(0.14, 0, 0, -0.18, -12.89, 5.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 938.74,
    y1: -196.97,
    x2: 935.45,
    y2: -200.12,
    gradientTransform: "matrix(0.18, 0, 0, -0.13, 2.29, -11.27)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 2035.86,
    y1: -205.31,
    x2: 2032.58,
    y2: -208.46,
    gradientTransform: "matrix(0.06, 0, 0, -0.13, -33.46, -11.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 1308.58,
    y1: -223.15,
    x2: 1305.3,
    y2: -226.3,
    gradientTransform: "matrix(0.08, 0, 0, -0.13, -42.35, -9.69)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 2663.53,
    y1: -180.92,
    x2: 2660.25,
    y2: -184.07,
    gradientTransform: "matrix(0.07, 0, 0, -0.16, -2.39, 2.24)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 1126.86,
    y1: -433.17,
    x2: 1123.58,
    y2: -436.32,
    gradientTransform: "matrix(0.12, 0, 0, -0.11, -21.96, -16.27)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 3938.16,
    y1: -2815.49,
    x2: 3934.88,
    y2: -2818.64,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -47.91, -46.31)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 824.19,
    y1: -991.8,
    x2: 820.91,
    y2: -994.96,
    gradientTransform: "matrix(0.17, 0, 0, -0.06, -11.71, -35.04)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 2951.66,
    y1: -270.28,
    x2: 2948.37,
    y2: -273.43,
    gradientTransform: "matrix(0.07, 0, 0, -0.13, -3.16, -9.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 1673.94,
    y1: -1274.85,
    x2: 1670.66,
    y2: -1278,
    gradientTransform: "matrix(0.1, 0, 0, -0.11, -9.43, 29.17)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 5419.04,
    y1: -1985.98,
    x2: 5415.75,
    y2: -1989.14,
    gradientTransform: "matrix(0.04, 0, 0, -0.06, -4.74, -7.29)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 1702.74,
    y1: -1049.86,
    x2: 1699.45,
    y2: -1053.01,
    gradientTransform: "matrix(0.11, 0, 0, -0.13, -0.43, 34.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 4829.12,
    y1: -2839.97,
    x2: 4825.83,
    y2: -2843.12,
    gradientTransform: "matrix(0.02, 0, 0, -0.06, -57.73, 10.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 914.14,
    y1: -524.22,
    x2: 910.85,
    y2: -527.37,
    gradientTransform: "matrix(0.09, 0, 0, -0.12, -50.94, -2.82)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 2310.87,
    y1: -5197.12,
    x2: 2307.58,
    y2: -5200.27,
    gradientTransform: "matrix(0.08, 0, 0, -0.03, -3.51, 3.51)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 1221.83,
    y1: -842.11,
    x2: 1218.55,
    y2: -845.27,
    gradientTransform: "matrix(0.16, 0, 0, -0.09, 9.87, -13.21)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 1417.74,
    y1: -1367.85,
    x2: 1414.45,
    y2: -1371.01,
    gradientTransform: "matrix(0.12, 0, 0, -0.1, -8.94, 29.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 383.74,
    y1: -1288.72,
    x2: 380.45,
    y2: -1291.87,
    gradientTransform: "matrix(0.16, 0, 0, -0.11, -50.54, 31.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 8212.42,
    y1: -2549,
    x2: 8209.14,
    y2: -2552.15,
    gradientTransform: "matrix(0.03, 0, 0, -0.05, -4.1, -13.89)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 362.03,
    y1: -508.34,
    x2: 358.75,
    y2: -511.49,
    gradientTransform: "matrix(0.19, 0, 0, -0.15, -42.84, 21.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 2156.93,
    y1: -933.09,
    x2: 2153.65,
    y2: -936.25,
    gradientTransform: "matrix(0.1, 0, 0, -0.1, 5.73, 0.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 7225.57,
    y1: -294.27,
    x2: 7222.28,
    y2: -297.42,
    gradientTransform: "matrix(0.03, 0, 0, -0.13, -8.73, -4.62)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 604.79,
    y1: -3256.33,
    x2: 601.5,
    y2: -3259.48,
    gradientTransform: "matrix(0.13, 0, 0, -0.05, -48.09, 12.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 3284.22,
    y1: -375.92,
    x2: 3280.93,
    y2: -379.07,
    gradientTransform: "matrix(0.05, 0, 0, -0.1, -26.37, -23.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 1710.34,
    y1: -462.48,
    x2: 1707.05,
    y2: -465.63,
    gradientTransform: "matrix(0.09, 0, 0, -0.09, -23.44, -26.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 3832.58,
    y1: -6184.69,
    x2: 3829.29,
    y2: -6187.84,
    gradientTransform: "matrix(0.06, 0, 0, -0.02, 2.75, -6.92)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 3106.7,
    y1: -1510.19,
    x2: 3103.42,
    y2: -1513.35,
    gradientTransform: "matrix(0.07, 0, 0, -0.09, 3.74, 14.73)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 1681.62,
    y1: -487.26,
    x2: 1678.34,
    y2: -490.41,
    gradientTransform: "matrix(0.05, 0, 0, -0.19, -58.81, 51.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 2139.29,
    y1: -2171.36,
    x2: 2136.01,
    y2: -2174.51,
    gradientTransform: "matrix(0.1, 0, 0, -0.06, 7.17, 3.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 3404,
    y1: -3488.84,
    x2: 3400.72,
    y2: -3491.99,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -47.98, -47.27)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 1870.16,
    y1: -1775.44,
    x2: 1866.87,
    y2: -1778.59,
    gradientTransform: "matrix(0.11, 0, 0, -0.08, 7.15, 14.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 418.32,
    y1: -646.61,
    x2: 415.04,
    y2: -649.76,
    gradientTransform: "matrix(0.19, 0, 0, -0.17, -40.1, 46.04)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 1350.95,
    y1: -2893.06,
    x2: 1347.66,
    y2: -2896.21,
    gradientTransform: "matrix(0.06, 0, 0, -0.05, -59.26, 6.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 6121.77,
    y1: -3515.89,
    x2: 6118.49,
    y2: -3519.04,
    gradientTransform: "matrix(0.03, 0, 0, -0.04, -7.62, 6.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 8684.12,
    y1: -5366.19,
    x2: 8680.84,
    y2: -5369.34,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -6.78, -17.9)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 2024.23,
    y1: -178.09,
    x2: 2020.95,
    y2: -181.24,
    gradientTransform: "matrix(0.07, 0, 0, -0.14, -26.25, -7.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 998.45,
    y1: -1112.01,
    x2: 995.17,
    y2: -1115.16,
    gradientTransform: "matrix(0.09, 0, 0, -0.07, -50.98, -20.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 3375.1,
    y1: -887.64,
    x2: 3371.82,
    y2: -890.79,
    gradientTransform: "matrix(0.06, 0, 0, -0.14, 1.28, 36.88)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 1429.1,
    y1: -1091.89,
    x2: 1425.81,
    y2: -1095.04,
    gradientTransform: "matrix(0.13, 0, 0, -0.12, 4.23, 29.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 958.3,
    y1: -568.67,
    x2: 955.02,
    y2: -571.82,
    gradientTransform: "matrix(0.13, 0, 0, -0.08, -28.45, -27.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 636.63,
    y1: -1388.03,
    x2: 633.35,
    y2: -1391.18,
    gradientTransform: "matrix(0.21, 0, 0, -0.05, -12.39, -33.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 1162.37,
    y1: -919.96,
    x2: 1159.08,
    y2: -923.11,
    gradientTransform: "matrix(0.08, 0, 0, -0.08, -51.18, -18.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 7519.89,
    y1: -631.49,
    x2: 7516.6,
    y2: -634.64,
    gradientTransform: "matrix(0.03, 0, 0, -0.08, -8.6, -23.21)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 1465.4,
    y1: -339.54,
    x2: 1462.12,
    y2: -342.69,
    gradientTransform: "matrix(0.11, 0, 0, -0.1, -14.18, -22.82)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 970.37,
    y1: -2452.25,
    x2: 967.09,
    y2: -2455.4,
    gradientTransform: "matrix(0.1, 0, 0, -0.07, -43.21, 21.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 1075.74,
    y1: -576.41,
    x2: 1072.45,
    y2: -579.56,
    gradientTransform: "matrix(0.12, 0, 0, -0.1, -25.42, -16.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 2042.36,
    y1: -886.9,
    x2: 2039.07,
    y2: -890.05,
    gradientTransform: "matrix(0.07, 0, 0, -0.06, -23.45, -30.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 4839.7,
    y1: -7226.46,
    x2: 4836.42,
    y2: -7229.61,
    gradientTransform: "matrix(0.02, 0, 0, -0.03, -43.48, 10.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 1576.59,
    y1: -443.05,
    x2: 1573.3,
    y2: -446.2,
    gradientTransform: "matrix(0.09, 0, 0, -0.09, -20.87, -27.74)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 1278.17,
    y1: -1838.68,
    x2: 1274.89,
    y2: -1841.83,
    gradientTransform: "matrix(0.15, 0, 0, -0.05, 5.89, -22.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 1258.38,
    y1: -824.42,
    x2: 1255.09,
    y2: -827.57,
    gradientTransform: "matrix(0.12, 0, 0, -0.06, -12.92, -37.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 1505.67,
    y1: -465.73,
    x2: 1502.39,
    y2: -468.88,
    gradientTransform: "matrix(0.1, 0, 0, -0.1, -21.75, -18.24)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: 3109.45,
    y1: -1294.51,
    x2: 3106.17,
    y2: -1297.66,
    gradientTransform: "matrix(0.06, 0, 0, -0.07, -2.37, -15.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: 1185.98,
    y1: -528.89,
    x2: 1182.69,
    y2: -532.04,
    gradientTransform: "matrix(0.11, 0, 0, -0.1, -25.74, -16.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: 602.67,
    y1: -1040.12,
    x2: 599.38,
    y2: -1043.27,
    gradientTransform: "matrix(0.3, 0, 0, -0.08, 21.66, -15.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: 3277.35,
    y1: -1400.35,
    x2: 3274.07,
    y2: -1403.5,
    gradientTransform: "matrix(0.06, 0, 0, -0.06, -1.7, -19.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 2291.05,
    y1: -482.1,
    x2: 2287.77,
    y2: -485.25,
    gradientTransform: "matrix(0.04, 0, 0, -0.15, -58.5, 14.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 887.58,
    y1: -1615.64,
    x2: 884.29,
    y2: -1618.79,
    gradientTransform: "matrix(0.14, 0, 0, -0.1, -27.64, 40.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: 1436.36,
    y1: -1155.87,
    x2: 1433.07,
    y2: -1159.02,
    gradientTransform: "matrix(0.13, 0, 0, -0.12, -1.37, 38.68)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 1974.77,
    y1: -889.77,
    x2: 1971.48,
    y2: -892.92,
    gradientTransform: "matrix(0.07, 0, 0, -0.06, -25.75, -30.88)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 5466.09,
    y1: -1628.61,
    x2: 5462.8,
    y2: -1631.77,
    gradientTransform: "matrix(0.03, 0, 0, -0.04, -17.37, -38.23)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 1684.65,
    y1: -1654.83,
    x2: 1681.36,
    y2: -1657.98,
    gradientTransform: "matrix(0.09, 0, 0, -0.04, -23.56, -37.73)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: 1130.69,
    y1: -1720.32,
    x2: 1127.41,
    y2: -1723.47,
    gradientTransform: "matrix(0.07, 0, 0, -0.07, -59.07, 7.56)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 5610.44,
    y1: -647.02,
    x2: 5607.15,
    y2: -650.17,
    gradientTransform: "matrix(0.03, 0, 0, -0.08, -26.13, -28.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: 8082.5,
    y1: -1343.47,
    x2: 8079.21,
    y2: -1346.62,
    gradientTransform: "matrix(0.01, 0, 0, -0.09, -64.19, 11.27)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: 5199.58,
    y1: -3656.78,
    x2: 5196.3,
    y2: -3659.93,
    gradientTransform: "matrix(0.04, 0, 0, -0.03, -5.71, -28.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: 2928.73,
    y1: -7559.38,
    x2: 2925.45,
    y2: -7562.53,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -62.57, -13.27)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: 3524.28,
    y1: -3552.34,
    x2: 3520.99,
    y2: -3555.5,
    gradientTransform: "matrix(0.05, 0, 0, -0.02, -14.05, -46.68)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: 913.9,
    y1: -2078.98,
    x2: 910.62,
    y2: -2082.13,
    gradientTransform: "matrix(0.09, 0, 0, -0.05, -54.36, -17.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: 3232.94,
    y1: -2928.03,
    x2: 3229.66,
    y2: -2931.18,
    gradientTransform: "matrix(0.03, 0, 0, -0.04, -60.41, -13.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: 1201.63,
    y1: -1666.39,
    x2: 1198.34,
    y2: -1669.54,
    gradientTransform: "matrix(0.07, 0, 0, -0.07, -55.89, -5.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: 829.83,
    y1: -509.39,
    x2: 826.54,
    y2: -512.54,
    gradientTransform: "matrix(0.1, 0, 0, -0.15, -52.97, 23.42)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: 3524.36,
    y1: -1391.84,
    x2: 3521.08,
    y2: -1394.99,
    gradientTransform: "matrix(0.06, 0, 0, -0.08, -1.23, -3.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: 909.87,
    y1: -2062.18,
    x2: 906.58,
    y2: -2065.33,
    gradientTransform: "matrix(0.09, 0, 0, -0.05, -53.96, -16.79)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: 2038.87,
    y1: -1895.64,
    x2: 2035.58,
    y2: -1898.79,
    gradientTransform: "matrix(0.04, 0, 0, -0.06, -57.39, -12.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: 3862.41,
    y1: -2762.96,
    x2: 3859.12,
    y2: -2766.11,
    gradientTransform: "matrix(0.02, 0, 0, -0.04, -61.48, -20.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: 256.09,
    y1: -2788.41,
    x2: 252.81,
    y2: -2791.56,
    gradientTransform: "matrix(0.24, 0, 0, -0.04, -40.32, -8.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: 1044.45,
    y1: -2416.6,
    x2: 1041.16,
    y2: -2419.75,
    gradientTransform: "matrix(0.07, 0, 0, -0.05, -56.7, -6.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: 1106.77,
    y1: -1897.42,
    x2: 1103.48,
    y2: -1900.57,
    gradientTransform: "matrix(0.07, 0, 0, -0.05, -56.87, -18.93)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: 2863.79,
    y1: -689.88,
    x2: 2860.51,
    y2: -693.03,
    gradientTransform: "matrix(0.05, 0, 0, -0.08, -26.54, -25.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: 2784.63,
    y1: -855.34,
    x2: 2781.35,
    y2: -858.49,
    gradientTransform: "matrix(0.06, 0, 0, -0.07, -14.08, -29.71)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    x1: 5494.21,
    y1: -2199.75,
    x2: 5490.93,
    y2: -2202.91,
    gradientTransform: "matrix(0.04, 0, 0, -0.05, -0.82, -9.04)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    x1: 5042.26,
    y1: -2393.98,
    x2: 5038.97,
    y2: -2397.13,
    gradientTransform: "matrix(0.04, 0, 0, -0.05, -1.21, -10.74)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    x1: 7856.58,
    y1: -5937.85,
    x2: 7853.3,
    y2: -5941,
    gradientTransform: "matrix(0.02, 0, 0, -0.03, -11.94, 8.16)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    x1: 3835.45,
    y1: -1953.63,
    x2: 3832.16,
    y2: -1956.78,
    gradientTransform: "matrix(0.03, 0, 0, -0.08, -41.49, 25.64)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    x1: 2998.23,
    y1: -7864.22,
    x2: 2994.95,
    y2: -7867.38,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -58.63, 5.64)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    x1: 1867.49,
    y1: -2096.53,
    x2: 1864.21,
    y2: -2099.68,
    gradientTransform: "matrix(0.05, 0, 0, -0.08, -56.62, 23.72)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    x1: 1387.92,
    y1: -2899.22,
    x2: 1384.63,
    y2: -2902.38,
    gradientTransform: "matrix(0.06, 0, 0, -0.06, -55.12, 15.52)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    x1: 14539.83,
    y1: -3401.59,
    x2: 14536.55,
    y2: -3404.74,
    gradientTransform: "matrix(0.01, 0, 0, -0.05, -60.23, 12.86)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    x1: 4151.25,
    y1: -8130.97,
    x2: 4147.97,
    y2: -8134.12,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -30.71, 12.66)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    x1: 4458.9,
    y1: -5669.88,
    x2: 4455.62,
    y2: -5673.03,
    gradientTransform: "matrix(0.03, 0, 0, -0.03, -43.43, 13.59)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    x1: 1151.37,
    y1: -4229.16,
    x2: 1148.09,
    y2: -4232.31,
    gradientTransform: "matrix(0.08, 0, 0, -0.04, -45.56, 16.78)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    x1: 15383.98,
    y1: -949.91,
    x2: 15380.7,
    y2: -953.06,
    gradientTransform: "matrix(0.01, 0, 0, -0.15, -44.88, 53.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    x1: 1228.74,
    y1: -3906.65,
    x2: 1225.46,
    y2: -3909.8,
    gradientTransform: "matrix(0.09, 0, 0, -0.05, -36.07, 16.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-287",
    x1: 6222.37,
    y1: -11117.01,
    x2: 6219.09,
    y2: -11120.17,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -30.39, 6.46)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-288",
    x1: 2778.43,
    y1: -3124.44,
    x2: 2775.14,
    y2: -3127.59,
    gradientTransform: "matrix(0.04, 0, 0, -0.06, -41.56, 19.58)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-289",
    x1: 3973.05,
    y1: -5327.9,
    x2: 3969.77,
    y2: -5331.05,
    gradientTransform: "matrix(0.04, 0, 0, -0.03, -25.6, 11.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-290",
    x1: 4552.67,
    y1: -881.8,
    x2: 4549.39,
    y2: -884.95,
    gradientTransform: "matrix(0.03, 0, 0, -0.06, -26.4, -38.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-291",
    x1: 1288.99,
    y1: -3634.86,
    x2: 1285.71,
    y2: -3638.01,
    gradientTransform: "matrix(0.09, 0, 0, -0.05, -35.66, 15.52)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-292",
    x1: 1601.76,
    y1: -3642.81,
    x2: 1598.48,
    y2: -3645.96,
    gradientTransform: "matrix(0.07, 0, 0, -0.05, -37.55, 15.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-293",
    x1: 1761.36,
    y1: -976.96,
    x2: 1758.07,
    y2: -980.11,
    gradientTransform: "matrix(0.09, 0, 0, -0.05, -15.62, -40.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-294",
    x1: 4225.93,
    y1: -7761.06,
    x2: 4222.64,
    y2: -7764.21,
    gradientTransform: "matrix(0.05, 0, 0, -0.02, -1.85, -2.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-295",
    x1: 4139.23,
    y1: -7896.99,
    x2: 4135.95,
    y2: -7900.14,
    gradientTransform: "matrix(0.05, 0, 0, -0.02, 0.25, -3.17)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-296",
    x1: 4691.4,
    y1: -3366.07,
    x2: 4688.12,
    y2: -3369.22,
    gradientTransform: "matrix(0.02, 0, 0, -0.05, -63.69, 5.24)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-297",
    x1: 3198.33,
    y1: -1949.9,
    x2: 3195.04,
    y2: -1953.05,
    gradientTransform: "matrix(0.05, 0, 0, -0.03, -23.42, -43.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-298",
    x1: 1791.16,
    y1: -2922.98,
    x2: 1787.88,
    y2: -2926.13,
    gradientTransform: "matrix(0.04, 0, 0, -0.05, -61.25, 1.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-299",
    x1: 5461.75,
    y1: -5728.48,
    x2: 5458.46,
    y2: -5731.63,
    gradientTransform: "matrix(0.04, 0, 0, -0.03, 1.55, -7.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-300",
    x1: 1440.93,
    y1: -2319.22,
    x2: 1437.64,
    y2: -2322.37,
    gradientTransform: "matrix(0.06, 0, 0, -0.07, -58.16, 18.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-301",
    x1: 3225.47,
    y1: -2517.05,
    x2: 3222.18,
    y2: -2520.21,
    gradientTransform: "matrix(0.05, 0, 0, -0.06, -16.4, 17.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-302",
    x1: 2826.17,
    y1: -2203.64,
    x2: 2822.89,
    y2: -2206.79,
    gradientTransform: "matrix(0.04, 0, 0, -0.03, -44.92, -47.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-303",
    x1: 5688.12,
    y1: -646.42,
    x2: 5684.83,
    y2: -649.57,
    gradientTransform: "matrix(0.03, 0, 0, -0.07, -28.01, -32.21)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-304",
    x1: 5906.46,
    y1: -426.31,
    x2: 5903.17,
    y2: -429.46,
    gradientTransform: "matrix(0.03, 0, 0, -0.09, -22.46, -24.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-305",
    x1: 8010.11,
    y1: -10359.48,
    x2: 8006.82,
    y2: -10362.63,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -10.23, 0.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-306",
    x1: 11409.94,
    y1: -3354.62,
    x2: 11406.66,
    y2: -3357.77,
    gradientTransform: "matrix(0.02, 0, 0, -0.05, -10.78, 11.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-307",
    x1: 1801.88,
    y1: -4411,
    x2: 1798.59,
    y2: -4414.15,
    gradientTransform: "matrix(0.04, 0, 0, -0.04, -62.22, 5.82)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-308",
    x1: 3275.18,
    y1: -1766.98,
    x2: 3271.9,
    y2: -1770.14,
    gradientTransform: "matrix(0.05, 0, 0, -0.08, -14.77, 21.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-309",
    x1: 1703.97,
    y1: -1160.77,
    x2: 1700.69,
    y2: -1163.92,
    gradientTransform: "matrix(0.09, 0, 0, -0.05, -22.78, -39.82)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-310",
    x1: 6077.94,
    y1: -4783.36,
    x2: 6074.66,
    y2: -4786.51,
    gradientTransform: "matrix(0.02, 0, 0, -0.03, -58.31, 3.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-311",
    x1: 3503.78,
    y1: -1917.42,
    x2: 3500.5,
    y2: -1920.57,
    gradientTransform: "matrix(0.05, 0, 0, -0.03, -11.07, -45.22)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-312",
    x1: 4852.1,
    y1: -4043.09,
    x2: 4848.82,
    y2: -4046.24,
    gradientTransform: "matrix(0.04, 0, 0, -0.04, -7.17, 5.21)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-313",
    x1: 1349.33,
    y1: -2271.45,
    x2: 1346.05,
    y2: -2274.6,
    gradientTransform: "matrix(0.06, 0, 0, -0.07, -59.48, 14.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-314",
    x1: 4596.01,
    y1: -1005.21,
    x2: 4592.72,
    y2: -1008.36,
    gradientTransform: "matrix(0.04, 0, 0, -0.05, -12.22, -37.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-315",
    x1: 3637.33,
    y1: -1731.26,
    x2: 3634.04,
    y2: -1734.41,
    gradientTransform: "matrix(0.04, 0, 0, -0.04, -27.99, -37.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-316",
    x1: 2748.8,
    y1: -736.54,
    x2: 2745.51,
    y2: -739.69,
    gradientTransform: "matrix(0.05, 0, 0, -0.08, -30.71, -24.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-317",
    x1: 1927.17,
    y1: -1462.35,
    x2: 1923.89,
    y2: -1465.5,
    gradientTransform: "matrix(0.1, 0, 0, -0.06, 3.7, -22.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-318",
    x1: 5514.81,
    y1: -1019.3,
    x2: 5511.53,
    y2: -1022.45,
    gradientTransform: "matrix(0.04, 0, 0, -0.08, -3.09, -14.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-319",
    x1: 2186.32,
    y1: -1453.77,
    x2: 2183.04,
    y2: -1456.92,
    gradientTransform: "matrix(0.06, 0, 0, -0.05, -29.6, -35.77)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-320",
    x1: 6685.14,
    y1: -987.52,
    x2: 6681.85,
    y2: -990.67,
    gradientTransform: "matrix(0.03, 0, 0, -0.08, -5.59, -11.26)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-321",
    x1: 7693.39,
    y1: -1631.09,
    x2: 7690.1,
    y2: -1634.24,
    gradientTransform: "matrix(0.03, 0, 0, -0.04, -9.68, -34.37)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-322",
    x1: 2786.9,
    y1: -685.93,
    x2: 2783.62,
    y2: -689.08,
    gradientTransform: "matrix(0.05, 0, 0, -0.08, -30.94, -22.72)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-323",
    x1: 4608.72,
    y1: -3958.47,
    x2: 4605.43,
    y2: -3961.62,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -57.49, -35.88)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-324",
    x1: 5088.73,
    y1: -3788.91,
    x2: 5085.45,
    y2: -3792.06,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -58.07, -35.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-325",
    x1: 4087.47,
    y1: -2544.12,
    x2: 4084.19,
    y2: -2547.27,
    gradientTransform: "matrix(0.05, 0, 0, -0.03, 1.03, -37.58)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-326",
    x1: 4129.76,
    y1: -1032.01,
    x2: 4126.47,
    y2: -1035.16,
    gradientTransform: "matrix(0.02, 0, 0, -0.07, -53.72, -26.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-327",
    x1: 1362.95,
    y1: -1202.17,
    x2: 1359.66,
    y2: -1205.32,
    gradientTransform: "matrix(0.1, 0, 0, -0.05, -25.14, -32.64)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-328",
    x1: 3035.21,
    y1: -845.03,
    x2: 3031.92,
    y2: -848.18,
    gradientTransform: "matrix(0.04, 0, 0, -0.08, -33.3, -22.88)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-329",
    x1: 2113.62,
    y1: -2832.5,
    x2: 2110.33,
    y2: -2835.65,
    gradientTransform: "matrix(0.04, 0, 0, -0.04, -59.3, -26.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-330",
    x1: 5187.02,
    y1: -2690.16,
    x2: 5183.74,
    y2: -2693.31,
    gradientTransform: "matrix(0.04, 0, 0, -0.03, -5.93, -42.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-331",
    x1: 6008.01,
    y1: -437.83,
    x2: 6004.73,
    y2: -440.99,
    gradientTransform: "matrix(0.04, 0, 0, -0.12, -0.36, -8.36)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-332",
    x1: 3380.33,
    y1: -2590.13,
    x2: 3377.05,
    y2: -2593.28,
    gradientTransform: "matrix(0.06, 0, 0, -0.03, -7.16, -40.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-333",
    x1: 3365.68,
    y1: -10134.32,
    x2: 3362.4,
    y2: -10137.47,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -63.93, -1.29)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-334",
    x1: 3351.26,
    y1: -9581.19,
    x2: 3347.98,
    y2: -9584.34,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -64.08, -0.82)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-335",
    x1: 43.9,
    y1: 254.77,
    x2: 43.9,
    y2: 254.77,
    gradientTransform: "matrix(1, 0, 0, -1, 61.68, 289.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-336",
    x1: 5360.34,
    y1: -3261.7,
    x2: 5357.05,
    y2: -3264.85,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -34.7, -41.37)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-337",
    x1: 14804.42,
    y1: -8115.88,
    x2: 14801.14,
    y2: -8119.04,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -40.17, 13.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-338",
    x1: 1787.78,
    y1: -1210.05,
    x2: 1784.49,
    y2: -1213.21,
    gradientTransform: "matrix(0.11, 0, 0, -0.11, -0.83, 30.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-339",
    x1: 2503.92,
    y1: -9459.4,
    x2: 2500.64,
    y2: -9462.55,
    gradientTransform: "matrix(0.04, 0, 0, -0.02, -56.15, -1.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-340",
    x1: 616.79,
    y1: -1228.66,
    x2: 613.51,
    y2: -1231.81,
    gradientTransform: "matrix(0.13, 0, 0, -0.11, -46.89, 30.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-341",
    x1: 4349.74,
    y1: -10665.55,
    x2: 4346.45,
    y2: -10668.7,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -57.74, -2.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-342",
    x1: 7553.07,
    y1: -3766.73,
    x2: 7549.79,
    y2: -3769.88,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -1.06, -40.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-343",
    x1: 11766.97,
    y1: -3769.27,
    x2: 11763.69,
    y2: -3772.42,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -2.48, -40.16)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-344",
    x1: 6885.38,
    y1: -508.97,
    x2: 6882.09,
    y2: -512.12,
    gradientTransform: "matrix(0.03, 0, 0, -0.08, -13, -27.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-345",
    x1: 2378.98,
    y1: -5121.35,
    x2: 2375.69,
    y2: -5124.5,
    gradientTransform: "matrix(0.05, 0, 0, -0.04, -45.38, 17.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-346",
    x1: 4961.57,
    y1: -3626.92,
    x2: 4958.28,
    y2: -3630.07,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -37.12, -50.37)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-347",
    x1: 1328.56,
    y1: -1079.31,
    x2: 1325.27,
    y2: -1082.46,
    gradientTransform: "matrix(0.06, 0, 0, -0.13, -61.37, 38.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-348",
    x1: 5008.17,
    y1: -3627.09,
    x2: 5004.89,
    y2: -3630.25,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -46.34, -50.36)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-349",
    x1: 7482.99,
    y1: -5141.28,
    x2: 7479.71,
    y2: -5144.43,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -23.63, -52.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-350",
    x1: 2773.21,
    y1: -1742.3,
    x2: 2769.92,
    y2: -1745.45,
    gradientTransform: "matrix(0.05, 0, 0, -0.04, -33.01, -33.44)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-351",
    x1: 10130.56,
    y1: -3202.45,
    x2: 10127.27,
    y2: -3205.6,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -10.81, -42.03)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-352",
    x1: 6878.38,
    y1: -3081.11,
    x2: 6875.09,
    y2: -3084.27,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -29.81, -49.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-353",
    x1: 2644.1,
    y1: -8583.39,
    x2: 2640.82,
    y2: -8586.55,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -63.41, 0.16)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-354",
    x1: 9583.22,
    y1: -4162.56,
    x2: 9579.94,
    y2: -4165.71,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -1.62, -40.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-355",
    x1: 6082.7,
    y1: -2914.87,
    x2: 6079.42,
    y2: -2918.02,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -37.93, -48.9)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-356",
    x1: 5038.36,
    y1: -3355.14,
    x2: 5035.08,
    y2: -3358.29,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -33.59, -42.33)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-357",
    x1: 6536.64,
    y1: -3066.43,
    x2: 6533.36,
    y2: -3069.58,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -23.59, -49.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-358",
    x1: 3295.15,
    y1: -9127.33,
    x2: 3291.87,
    y2: -9130.49,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -64.68, 0.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-359",
    x1: -17.4,
    y1: -829.98,
    x2: -20.68,
    y2: -833.14,
    gradientTransform: "matrix(1, 0, 0, -0.15, 32.03, 46.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-360",
    x1: 38.94,
    y1: -2858.48,
    x2: 35.66,
    y2: -2861.63,
    gradientTransform: "matrix(1, 0, 0, -0.02, 58.22, -47.66)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-361",
    x1: 20695.15,
    y1: -3036.72,
    x2: 20691.87,
    y2: -3039.87,
    gradientTransform: "matrix(0.01, 0, 0, -0.03, -5.48, -38.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-362",
    x1: -8391.41,
    y1: -19723.59,
    x2: -8391.43,
    y2: -19723.61,
    gradientTransform: "matrix(0.01, 0, 0, -0.01, -3.64, -7.66)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-363",
    x1: 985.26,
    y1: -601.3,
    x2: 981.98,
    y2: -604.45,
    gradientTransform: "matrix(0.13, 0, 0, -0.08, -28.08, -29.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-364",
    x1: 9429.79,
    y1: -9179.45,
    x2: 9426.51,
    y2: -9182.6,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -8.17, -4.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-365",
    x1: 9115.95,
    y1: -9179.58,
    x2: 9112.67,
    y2: -9182.74,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -2.68, -4.17)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-366",
    x1: 3806.13,
    y1: -18591.79,
    x2: 3802.85,
    y2: -18594.94,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -63.03, -7.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-367",
    x1: 4747.83,
    y1: -3476.93,
    x2: 4744.55,
    y2: -3480.08,
    gradientTransform: "matrix(0.04, 0, 0, -0.02, 0.06, -38.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-368",
    x1: 5252.49,
    y1: -25125.5,
    x2: 5249.21,
    y2: -25128.65,
    gradientTransform: "matrix(0.03, 0, 0, -0.01, -38.53, 8.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-369",
    x1: 3351.92,
    y1: -9571.64,
    x2: 3348.64,
    y2: -9574.8,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -62.37, -5.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-370",
    x1: 4689.82,
    y1: -10261.06,
    x2: 4686.54,
    y2: -10264.22,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -56.73, -5.44)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-371",
    x1: 8756.81,
    y1: -7392.44,
    x2: 8753.53,
    y2: -7395.59,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -6.51, -3.24)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-372",
    x1: 12450.58,
    y1: -3322.18,
    x2: 12447.29,
    y2: -3325.33,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -2.57, -38.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-373",
    x1: 1911.79,
    y1: 255.62,
    x2: 1908.5,
    y2: 252.47,
    gradientTransform: "matrix(0.07, 0, 0, -1, -29.94, 289.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-374",
    x1: 8449.39,
    y1: -2907.97,
    x2: 8446.11,
    y2: -2911.12,
    gradientTransform: "matrix(0.02, 0, 0, -0.05, -5.31, 8.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-375",
    x1: 2523.93,
    y1: -858.2,
    x2: 2520.64,
    y2: -861.35,
    gradientTransform: "matrix(0.03, 0, 0, -0.15, -62.4, 40.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-376",
    x1: 491.38,
    y1: -1707.13,
    x2: 488.1,
    y2: -1710.28,
    gradientTransform: "matrix(0.14, 0, 0, -0.08, -51.97, 20)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-377",
    x1: 9452.39,
    y1: -8965.46,
    x2: 9449.11,
    y2: -8968.61,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -39.79, 12.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-378",
    x1: 6998.86,
    y1: -6769.61,
    x2: 6995.57,
    y2: -6772.76,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -4.54, -2.03)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-379",
    x1: 5433.53,
    y1: -3642.84,
    x2: 5430.25,
    y2: -3645.99,
    gradientTransform: "matrix(0.04, 0, 0, -0.04, -4.5, 4.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-380",
    x1: 8764.03,
    y1: -4000.97,
    x2: 8760.75,
    y2: -4004.12,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -1.8, -40.17)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-381",
    x1: -8389.88,
    y1: -19723.48,
    x2: -8389.89,
    y2: -19723.5,
    gradientTransform: "matrix(0.01, 0, 0, -0.01, -4.22, -7.72)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-382",
    x1: 25286.44,
    y1: -6004.57,
    x2: 25283.15,
    y2: -6007.72,
    gradientTransform: "matrix(0.01, 0, 0, -0.03, -7.35, -0.95)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-383",
    x1: 13128.27,
    y1: -7120.61,
    x2: 13124.99,
    y2: -7123.76,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -3.33, -2.29)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-384",
    x1: 8734.63,
    y1: -6795.15,
    x2: 8731.35,
    y2: -6798.3,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -6.75, -1.75)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-385",
    x1: 8916.89,
    y1: -3523.79,
    x2: 8913.61,
    y2: -3526.94,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -38.82, -49.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-386",
    x1: 10012.9,
    y1: -8686.36,
    x2: 10009.62,
    y2: -8689.51,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -2.48, -3.31)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-387",
    x1: 5661.92,
    y1: -9203.99,
    x2: 5658.64,
    y2: -9207.14,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -47.74, 10.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-388",
    x1: 7900.35,
    y1: -3700.1,
    x2: 7897.07,
    y2: -3703.25,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -23.09, -51.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-389",
    x1: 6203.14,
    y1: -2312.86,
    x2: 6199.85,
    y2: -2316.01,
    gradientTransform: "matrix(0.03, 0, 0, -0.03, -21.55, -50.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-390",
    x1: 10081.27,
    y1: -4105.78,
    x2: 10077.99,
    y2: -4108.93,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -21.26, -53.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-391",
    x1: -8402.63,
    y1: -19562.05,
    x2: -8402.64,
    y2: -19562.06,
    gradientTransform: "matrix(0.01, 0, 0, -0.01, -36.77, -46.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-392",
    x1: 3486.36,
    y1: -4099.06,
    x2: 3483.08,
    y2: -4102.21,
    gradientTransform: "matrix(0.04, 0, 0, -0.04, -25.48, 16.22)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-393",
    x1: 13722.33,
    y1: -9024.01,
    x2: 13719.05,
    y2: -9027.16,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -44.69, 8.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-394",
    x1: 8493.11,
    y1: -2230.54,
    x2: 8489.83,
    y2: -2233.69,
    gradientTransform: "matrix(0.02, 0, 0, -0.03, -17.31, -49.77)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-395",
    x1: 8500.01,
    y1: -3378.95,
    x2: 8496.73,
    y2: -3382.1,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -21.24, -52.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-396",
    x1: 5248.88,
    y1: -11360.46,
    x2: 5245.59,
    y2: -11363.61,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -30.84, 8.37)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-397",
    x1: 8853.97,
    y1: -3680.06,
    x2: 8850.68,
    y2: -3683.21,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -22.11, -52.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-398",
    x1: 7455.42,
    y1: -9279.08,
    x2: 7452.14,
    y2: -9282.23,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -27.44, 6.64)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-399",
    x1: 3842.35,
    y1: -9813,
    x2: 3839.06,
    y2: -9816.15,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -51.1, 6.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-400",
    x1: 8401.25,
    y1: -3045.82,
    x2: 8397.97,
    y2: -3048.97,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -22.16, -51.41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-401",
    x1: 4309.81,
    y1: -7781.74,
    x2: 4306.53,
    y2: -7784.89,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -51.72, 9.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-402",
    x1: 4674.39,
    y1: -2718.05,
    x2: 4671.1,
    y2: -2721.2,
    gradientTransform: "matrix(0.04, 0, 0, -0.02, -22.07, -49.16)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-403",
    x1: 7593.1,
    y1: -6798.8,
    x2: 7589.82,
    y2: -6801.95,
    gradientTransform: "matrix(0.03, 0, 0, -0.03, -11.3, 5.44)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-404",
    x1: 1111.33,
    y1: -1008.77,
    x2: 1108.04,
    y2: -1011.92,
    gradientTransform: "matrix(0.12, 0, 0, -0.07, -26.66, -25.86)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-405",
    x1: 11955.08,
    y1: -8951.99,
    x2: 11951.8,
    y2: -8955.14,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -12.05, 3.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-406",
    x1: 6582.62,
    y1: 270.16,
    x2: 6579.34,
    y2: 267.01,
    gradientTransform: "matrix(0.03, 0, 0, -1, -23.04, 282.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-407",
    x1: 5515.68,
    y1: -2854.17,
    x2: 5512.4,
    y2: -2857.33,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -46.36, -49.52)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-408",
    x1: 5901.33,
    y1: -3353.65,
    x2: 5898.05,
    y2: -3356.8,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -28.16, -50.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-409",
    x1: 7591.91,
    y1: -3353.82,
    x2: 7588.63,
    y2: -3356.97,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -29.69, -50.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-410",
    x1: 873.07,
    y1: -1094.61,
    x2: 869.79,
    y2: -1097.76,
    gradientTransform: "matrix(0.08, 0, 0, -0.13, -59.84, 41.16)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-411",
    x1: 7273.67,
    y1: -3345.6,
    x2: 7270.39,
    y2: -3348.75,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -29.21, -50.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-412",
    x1: 9273.64,
    y1: -3242.01,
    x2: 9270.35,
    y2: -3245.16,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -36.33, -39.56)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-413",
    x1: 6903.41,
    y1: -4096.92,
    x2: 6900.13,
    y2: -4100.07,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -12.78, -51.24)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-414",
    x1: 7658.63,
    y1: -4360.93,
    x2: 7655.35,
    y2: -4364.08,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -36.53, -41.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-415",
    x1: 7004.4,
    y1: -4730.19,
    x2: 7001.11,
    y2: -4733.34,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -28.52, -51.92)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-416",
    x1: 9359.24,
    y1: -3199.24,
    x2: 9355.96,
    y2: -3202.4,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -13.25, -49.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-417",
    x1: 5838.09,
    y1: -5000.16,
    x2: 5834.81,
    y2: -5003.31,
    gradientTransform: "matrix(0.03, 0, 0, -0.01, -22.65, -52.27)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-418",
    x1: 4576.02,
    y1: -1943.94,
    x2: 4572.74,
    y2: -1947.09,
    gradientTransform: "matrix(0.03, 0, 0, -0.04, -35.03, -35.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-419",
    x1: 6340.76,
    y1: -9753.72,
    x2: 6337.47,
    y2: -9756.87,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -44.53, 11.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-420",
    x1: 5869.26,
    y1: -3907.9,
    x2: 5865.98,
    y2: -3911.05,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -54.4, -41.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-421",
    x1: 7825.44,
    y1: -3191.62,
    x2: 7822.16,
    y2: -3194.77,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -23.83, -50.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-422",
    x1: 7731.85,
    y1: -3022.56,
    x2: 7728.57,
    y2: -3025.71,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -28.38, -49.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-423",
    x1: 4010.97,
    y1: -14272.1,
    x2: 4007.68,
    y2: -14275.25,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -59.03, 2.61)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-424",
    x1: 7522.13,
    y1: -4700.86,
    x2: 7518.85,
    y2: -4704.01,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -34.11, -44.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-425",
    x1: 1297.51,
    y1: -3235.6,
    x2: 1294.22,
    y2: -3238.75,
    gradientTransform: "matrix(0.09, 0, 0, -0.05, -36.03, 16.37)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-426",
    x1: 6479.09,
    y1: -3107.56,
    x2: 6475.81,
    y2: -3110.72,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -27.53, -50.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-427",
    x1: 5519.93,
    y1: -3202.8,
    x2: 5516.65,
    y2: -3205.95,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -35.42, -40.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-428",
    x1: 7040.12,
    y1: -2537.33,
    x2: 7036.83,
    y2: -2540.48,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -21.07, -51.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-429",
    x1: 3749.01,
    y1: -4016.78,
    x2: 3745.73,
    y2: -4019.93,
    gradientTransform: "matrix(0.05, 0, 0, -0.02, -1.46, -32.94)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-430",
    x1: 4534.53,
    y1: -2702.85,
    x2: 4531.25,
    y2: -2706,
    gradientTransform: "matrix(0.05, 0, 0, -0.03, -1.82, -30.04)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-431",
    x1: 899.07,
    y1: -17588.48,
    x2: 895.78,
    y2: -17591.63,
    gradientTransform: "matrix(0.09, 0, 0, -0.01, -52.69, -28.79)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-432",
    x1: 7371.98,
    y1: -1195.65,
    x2: 7368.7,
    y2: -1198.8,
    gradientTransform: "matrix(0.01, 0, 0, -0.08, -60.38, -3.32)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-433",
    x1: 10322.65,
    y1: -16951.23,
    x2: 10319.36,
    y2: -16954.38,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -4.28, -39.56)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-434",
    x1: 1126.65,
    y1: -4152.21,
    x2: 1123.37,
    y2: -4155.36,
    gradientTransform: "matrix(0.17, 0, 0, -0.02, 10.05, -33.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-435",
    x1: 3323.62,
    y1: -3417.43,
    x2: 3320.34,
    y2: -3420.58,
    gradientTransform: "matrix(0.03, 0, 0, -0.03, -59.31, -18.74)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-436",
    x1: 903.53,
    y1: -699.34,
    x2: 900.25,
    y2: -702.49,
    gradientTransform: "matrix(0.09, 0, 0, -0.12, -53.1, 11.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-437",
    x1: 12156.95,
    y1: -3967.83,
    x2: 12153.67,
    y2: -3970.98,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -4.89, -33.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-438",
    x1: 3934.97,
    y1: -756.48,
    x2: 3931.69,
    y2: -759.63,
    gradientTransform: "matrix(0.02, 0, 0, -0.12, -59.81, 9.69)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-439",
    x1: 3762.35,
    y1: -8252.44,
    x2: 3759.07,
    y2: -8255.59,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -59.69, -24.86)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-440",
    x1: 3579.62,
    y1: -3062.19,
    x2: 3576.33,
    y2: -3065.35,
    gradientTransform: "matrix(0.02, 0, 0, -0.04, -59.83, -16.62)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-441",
    x1: 4996.97,
    y1: -2832.41,
    x2: 4993.68,
    y2: -2835.56,
    gradientTransform: "matrix(0.02, 0, 0, -0.04, -61.29, -20.69)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-442",
    x1: 3667.54,
    y1: -7697.21,
    x2: 3664.26,
    y2: -7700.36,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -60.69, -28.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-443",
    x1: 26750.57,
    y1: -6016.62,
    x2: 26747.28,
    y2: -6019.77,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -1.87, -27.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-444",
    x1: 3474.3,
    y1: -4919.44,
    x2: 3471.02,
    y2: -4922.59,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -61.01, -25.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-445",
    x1: 5659.97,
    y1: -4527.27,
    x2: 5656.69,
    y2: -4530.42,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -31.07, -45.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-446",
    x1: 6393.55,
    y1: -531.5,
    x2: 6390.26,
    y2: -534.66,
    gradientTransform: "matrix(0.03, 0, 0, -0.12, -3.58, -0.32)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-447",
    x1: 5753.8,
    y1: -3600.14,
    x2: 5750.52,
    y2: -3603.3,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -29.95, -44.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-448",
    x1: 9959.75,
    y1: -2805.35,
    x2: 9956.46,
    y2: -2808.5,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -7.66, -44.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-449",
    x1: 1778.82,
    y1: -847.99,
    x2: 1775.54,
    y2: -851.14,
    gradientTransform: "matrix(0.11, 0, 0, -0.11, 6.31, 4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-450",
    x1: 767.68,
    y1: -1098.91,
    x2: 764.4,
    y2: -1102.07,
    gradientTransform: "matrix(0.1, 0, 0, -0.09, -51.24, -1.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-451",
    x1: 7119.7,
    y1: -1121.72,
    x2: 7116.42,
    y2: -1124.87,
    gradientTransform: "matrix(0.01, 0, 0, -0.09, -61.76, 4.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-452",
    x1: 7486.76,
    y1: -3122.15,
    x2: 7483.47,
    y2: -3125.3,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -30.67, -42.92)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-453",
    x1: 2102.39,
    y1: -1938.01,
    x2: 2099.1,
    y2: -1941.16,
    gradientTransform: "matrix(0.04, 0, 0, -0.04, -56.09, -27.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-454",
    x1: 111.47,
    y1: 204.51,
    x2: 111.47,
    y2: 204.51,
    gradientTransform: "matrix(1, 0, 0, -1, 93.09, 312.79)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-455",
    x1: 598.91,
    y1: -1270.78,
    x2: 595.63,
    y2: -1273.93,
    gradientTransform: "matrix(0.12, 0, 0, -0.08, -50.98, 1.71)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-456",
    x1: 7057.56,
    y1: -6417.76,
    x2: 7054.27,
    y2: -6420.91,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -3.74, -19.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-457",
    x1: 4432.08,
    y1: -4865.51,
    x2: 4428.8,
    y2: -4868.66,
    gradientTransform: "matrix(0.02, 0, 0, -0.03, -61.34, -17.93)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-458",
    x1: 9302.82,
    y1: -10962.8,
    x2: 9299.54,
    y2: -10965.95,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -5.05, -22.41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-459",
    x1: 744.83,
    y1: -846.9,
    x2: 741.55,
    y2: -850.05,
    gradientTransform: "matrix(0.1, 0, 0, -0.11, -51.83, 7.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-460",
    x1: 3048.73,
    y1: -5573.16,
    x2: 3045.45,
    y2: -5576.32,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -59.52, -21.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-461",
    x1: 3941.14,
    y1: -6060.57,
    x2: 3937.86,
    y2: -6063.72,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -57.78, -36.66)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-462",
    x1: 1190.75,
    y1: -1083.98,
    x2: 1187.47,
    y2: -1087.13,
    gradientTransform: "matrix(0.09, 0, 0, -0.05, -42.62, -34.61)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-463",
    x1: 4072.74,
    y1: -7865.23,
    x2: 4069.46,
    y2: -7868.38,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -60.45, -23.25)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-464",
    x1: 13620.07,
    y1: -4722.12,
    x2: 13616.78,
    y2: -4725.28,
    gradientTransform: "matrix(0.02, 0, 0, -0.03, -5.99, -19.65)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-465",
    x1: 7786.78,
    y1: -527.26,
    x2: 7783.5,
    y2: -530.41,
    gradientTransform: "matrix(0.02, 0, 0, -0.09, -16.85, -22.82)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-466",
    x1: 1332.25,
    y1: -1522.17,
    x2: 1328.97,
    y2: -1525.32,
    gradientTransform: "matrix(0.14, 0, 0, -0.07, 6.59, -4.12)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-467",
    x1: 13601.09,
    y1: -5961.55,
    x2: 13597.81,
    y2: -5964.7,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -6.13, -21.04)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-468",
    x1: 3681.61,
    y1: -18585.15,
    x2: 3678.33,
    y2: -18588.3,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -60.56, -25.54)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-469",
    x1: 1291.58,
    y1: -2043.32,
    x2: 1288.3,
    y2: -2046.47,
    gradientTransform: "matrix(0.1, 0, 0, -0.03, -28.83, -42.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-470",
    x1: 9459.75,
    y1: -2025.46,
    x2: 9456.46,
    y2: -2028.61,
    gradientTransform: "matrix(0.02, 0, 0, -0.04, -3.45, -27.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-471",
    x1: 3702.58,
    y1: -4807.18,
    x2: 3699.3,
    y2: -4810.33,
    gradientTransform: "matrix(0.02, 0, 0, -0.03, -60.33, -18.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-472",
    x1: 2045.29,
    y1: -513.47,
    x2: 2042,
    y2: -516.62,
    gradientTransform: "matrix(0.1, 0, 0, -0.12, 3.99, -2.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-473",
    x1: -9.61,
    y1: -603.43,
    x2: -12.89,
    y2: -606.58,
    gradientTransform: "matrix(1, 0, 0, -0.14, 35.65, 20.89)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-474",
    x1: 12506.29,
    y1: -4584.04,
    x2: 12503.01,
    y2: -4587.19,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -7.96, -29.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-475",
    x1: 8176.24,
    y1: -1418.66,
    x2: 8172.96,
    y2: -1421.81,
    gradientTransform: "matrix(0.02, 0, 0, -0.05, -8.36, -36.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-476",
    x1: 6810.96,
    y1: -3711.01,
    x2: 6807.67,
    y2: -3714.17,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -30.49, -45.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-477",
    x1: 3155.42,
    y1: -2038.94,
    x2: 3152.13,
    y2: -2042.09,
    gradientTransform: "matrix(0.05, 0, 0, -0.03, -29.12, -40.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-478",
    x1: 10349.75,
    y1: -8648.04,
    x2: 10346.47,
    y2: -8651.19,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -8.87, -49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-479",
    x1: 9870.68,
    y1: -3705.02,
    x2: 9867.4,
    y2: -3708.17,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -32.16, -45.26)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-480",
    x1: 6727.89,
    y1: -3230.4,
    x2: 6724.6,
    y2: -3233.55,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -31.34, -43.69)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-481",
    x1: 4073.98,
    y1: -8122.74,
    x2: 4070.7,
    y2: -8125.89,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -60.43, -34.11)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-482",
    x1: 7313.32,
    y1: -3901.14,
    x2: 7310.04,
    y2: -3904.29,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -28.82, -45.76)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-483",
    x1: 29506.09,
    y1: -3562.76,
    x2: 29502.8,
    y2: -3565.91,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -20.31, -44.45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-484",
    x1: 3838.71,
    y1: -8949.17,
    x2: 3835.42,
    y2: -8952.32,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -60.79, -33.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-485",
    x1: 6689.44,
    y1: -780.58,
    x2: 6686.15,
    y2: -783.73,
    gradientTransform: "matrix(0.02, 0, 0, -0.07, -31.73, -26.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-486",
    x1: 3671.69,
    y1: -4473.62,
    x2: 3668.41,
    y2: -4476.78,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -60.64, -30.36)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-487",
    x1: 8713.13,
    y1: -4328.62,
    x2: 8709.85,
    y2: -4331.77,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -6.98, -29.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-488",
    x1: 2128.1,
    y1: -8761.32,
    x2: 2124.82,
    y2: -8764.47,
    gradientTransform: "matrix(0.07, 0, 0, -0.01, -27.35, -48.52)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-489",
    x1: 8347.49,
    y1: -545.44,
    x2: 8344.21,
    y2: -548.59,
    gradientTransform: "matrix(0.02, 0, 0, -0.09, -18.73, -20.58)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-490",
    x1: 1896.95,
    y1: -5921.84,
    x2: 1893.67,
    y2: -5924.99,
    gradientTransform: "matrix(0.09, 0, 0, -0.01, -12.01, -47.41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-491",
    x1: 15083.08,
    y1: -3185.9,
    x2: 15079.8,
    y2: -3189.05,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -9.76, -44.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-492",
    x1: 3845.16,
    y1: -14553.91,
    x2: 3841.88,
    y2: -14557.06,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -62.65, -31.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-493",
    x1: 3398.09,
    y1: -3400.01,
    x2: 3394.8,
    y2: -3403.16,
    gradientTransform: "matrix(0.04, 0, 0, -0.02, -27.41, -43.95)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-494",
    x1: 6974.76,
    y1: -3837.68,
    x2: 6971.47,
    y2: -3840.83,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -32.13, -46.33)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-495",
    x1: 5457.04,
    y1: -7177.21,
    x2: 5453.76,
    y2: -7180.36,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -63, -28.36)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-496",
    x1: 3745.39,
    y1: -5666.74,
    x2: 3742.11,
    y2: -5669.89,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -61.74, -26.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-497",
    x1: 3187.94,
    y1: -8911.25,
    x2: 3184.65,
    y2: -8914.4,
    gradientTransform: "matrix(0.03, 0, 0, -0.01, -60.95, -29.35)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-498",
    x1: 918.78,
    y1: -1263.6,
    x2: 915.5,
    y2: -1266.75,
    gradientTransform: "matrix(0.08, 0, 0, -0.08, -55.31, -8.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-499",
    x1: 5945.68,
    y1: -11563.82,
    x2: 5942.39,
    y2: -11566.97,
    gradientTransform: "matrix(0.03, 0, 0, -0.01, -29.22, -49.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-500",
    x1: 18471.59,
    y1: -4131.83,
    x2: 18468.31,
    y2: -4134.98,
    gradientTransform: "matrix(0.01, 0, 0, -0.03, -4.1, -26.78)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-501",
    x1: 10434.7,
    y1: -2624.39,
    x2: 10431.42,
    y2: -2627.54,
    gradientTransform: "matrix(0.02, 0, 0, -0.03, -18.47, -43.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-502",
    x1: 6650.36,
    y1: -3656.95,
    x2: 6647.08,
    y2: -3660.1,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -28.78, -45.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-503",
    x1: 3802.7,
    y1: -4558.63,
    x2: 3799.42,
    y2: -4561.78,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -59.27, -26.91)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-504",
    x1: 2271.75,
    y1: -1651.79,
    x2: 2268.46,
    y2: -1654.94,
    gradientTransform: "matrix(0.09, 0, 0, -0.06, 4.67, -14.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-505",
    x1: 2765.84,
    y1: -6589.66,
    x2: 2762.55,
    y2: -6592.81,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -63.2, -7.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-506",
    x1: 11297.83,
    y1: -6287.11,
    x2: 11294.55,
    y2: -6290.27,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -0.48, -7.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-507",
    x1: 5095.19,
    y1: -3659.13,
    x2: 5091.9,
    y2: -3662.28,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -30.39, -43.51)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-508",
    x1: 10749.35,
    y1: -3434.64,
    x2: 10746.06,
    y2: -3437.8,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -15.99, -47.77)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-509",
    x1: 1162.4,
    y1: -2290.67,
    x2: 1159.12,
    y2: -2293.83,
    gradientTransform: "matrix(0.07, 0, 0, -0.06, -56.73, 5.69)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-510",
    x1: 450.67,
    y1: -10362.03,
    x2: 447.39,
    y2: -10365.19,
    gradientTransform: "matrix(0.16, 0, 0, -0.02, -48.21, -9.88)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-511",
    x1: -8267.09,
    y1: -19584.33,
    x2: -8267.1,
    y2: -19584.34,
    gradientTransform: "matrix(0, 0, 0, -0.01, -63.1, -13.26)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-512",
    x1: 3431.07,
    y1: -4744.68,
    x2: 3427.78,
    y2: -4747.83,
    gradientTransform: "matrix(0.06, 0, 0, -0.03, 2.85, -3.23)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-513",
    x1: 9699.21,
    y1: -5914.84,
    x2: 9695.93,
    y2: -5917.99,
    gradientTransform: "matrix(0.02, 0, 0, -0.03, -1, -5.24)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-514",
    x1: 4604.84,
    y1: -9769.49,
    x2: 4601.56,
    y2: -9772.65,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -62.08, -8.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-515",
    x1: 1130.76,
    y1: -1049.79,
    x2: 1127.48,
    y2: -1052.94,
    gradientTransform: "matrix(0.07, 0, 0, -0.11, -59.07, 19.69)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-516",
    x1: 5211.27,
    y1: -10094.36,
    x2: 5207.98,
    y2: -10097.51,
    gradientTransform: "matrix(0.03, 0, 0, -0.01, -31.33, -48.17)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-517",
    x1: 1094.47,
    y1: -1321.74,
    x2: 1091.18,
    y2: -1324.89,
    gradientTransform: "matrix(0.07, 0, 0, -0.09, -58.88, 13.76)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-518",
    x1: 6555.26,
    y1: -4305.65,
    x2: 6551.97,
    y2: -4308.8,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -33.11, -44.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-519",
    x1: 3423.1,
    y1: -10782,
    x2: 3419.82,
    y2: -10785.15,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -63.31, -12.33)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-520",
    x1: 113.16,
    y1: -3747.43,
    x2: 109.87,
    y2: -3750.58,
    gradientTransform: "matrix(1, 0, 0, -0.02, 92.72, -38.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-521",
    x1: 52.98,
    y1: 255.98,
    x2: 52.98,
    y2: 255.98,
    gradientTransform: "matrix(1, 0, 0, -1, 65.9, 288.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-522",
    x1: 2666.9,
    y1: -6870.06,
    x2: 2663.62,
    y2: -6873.22,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -63.11, -8.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-523",
    x1: 4460.95,
    y1: -1019.33,
    x2: 4457.67,
    y2: -1022.48,
    gradientTransform: "matrix(0.03, 0, 0, -0.06, -30.01, -29.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-524",
    x1: 539.75,
    y1: -1710.17,
    x2: 536.46,
    y2: -1713.32,
    gradientTransform: "matrix(0.13, 0, 0, -0.08, -52.01, 16.35)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-525",
    x1: 5075.52,
    y1: -7690.93,
    x2: 5072.23,
    y2: -7694.08,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -63.17, -4.16)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-526",
    x1: 2941.22,
    y1: -13772.78,
    x2: 2937.94,
    y2: -13775.94,
    gradientTransform: "matrix(0.03, 0, 0, -0.01, -62.42, -7.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-527",
    x1: 30822.56,
    y1: -3561.26,
    x2: 30819.27,
    y2: -3564.41,
    gradientTransform: "matrix(0.01, 0, 0, -0.04, -2.52, 0.74)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-528",
    x1: 16529.56,
    y1: -8791.89,
    x2: 16526.27,
    y2: -8795.04,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -1.93, -7.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-529",
    x1: 4126.42,
    y1: -2948.86,
    x2: 4123.14,
    y2: -2952.01,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, 1.97, 3.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-530",
    x1: 7612.08,
    y1: -6835.08,
    x2: 7608.8,
    y2: -6838.23,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -0.29, -5.33)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-531",
    x1: 3724.23,
    y1: -2300.2,
    x2: 3720.94,
    y2: -2303.35,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -3.92, -8.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-532",
    x1: 4009.71,
    y1: -4171.14,
    x2: 4006.42,
    y2: -4174.29,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -57.05, -36.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-533",
    x1: 5599.82,
    y1: -1310.3,
    x2: 5596.53,
    y2: -1313.45,
    gradientTransform: "matrix(0.01, 0, 0, -0.08, -62.01, 3.27)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-534",
    x1: -8287.27,
    y1: -19563.36,
    x2: -8287.29,
    y2: -19563.37,
    gradientTransform: "matrix(0.01, 0, 0, -0.01, -62.69, -21.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-535",
    x1: 9556.04,
    y1: -5858.17,
    x2: 9552.76,
    y2: -5861.33,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -6.94, -18.91)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-536",
    x1: 25280.01,
    y1: 257.46,
    x2: 25276.73,
    y2: 254.31,
    gradientTransform: "matrix(0.01, 0, 0, -1, -32.05, 288.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-537",
    x1: 17513.96,
    y1: -741.56,
    x2: 17510.67,
    y2: -744.72,
    gradientTransform: "matrix(0.01, 0, 0, -0.09, -4.1, -12.17)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-538",
    x1: 922.68,
    y1: -721.76,
    x2: 919.4,
    y2: -724.91,
    gradientTransform: "matrix(0.08, 0, 0, -0.13, -55.15, 17.83)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-539",
    x1: 7405.72,
    y1: -5907.46,
    x2: 7402.44,
    y2: -5910.61,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -6.48, -18.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-540",
    x1: 881.42,
    y1: -974.09,
    x2: 878.13,
    y2: -977.25,
    gradientTransform: "matrix(0.08, 0, 0, -0.11, -56.77, 17.75)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-541",
    x1: 6794.79,
    y1: -3836.72,
    x2: 6791.51,
    y2: -3839.88,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -33.89, -44.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-542",
    x1: 22949.41,
    y1: -4941.27,
    x2: 22946.12,
    y2: -4944.42,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -5.55, -39.35)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-543",
    x1: 649.74,
    y1: -1513.37,
    x2: 646.46,
    y2: -1516.52,
    gradientTransform: "matrix(0.11, 0, 0, -0.08, -54.25, 7.68)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-544",
    x1: 5334.2,
    y1: -4417.33,
    x2: 5330.91,
    y2: -4420.48,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -55.97, -38.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-545",
    x1: 10599.23,
    y1: -3680.48,
    x2: 10595.95,
    y2: -3683.63,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -16.56, -47.71)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-546",
    x1: 4732.66,
    y1: -6232.55,
    x2: 4729.38,
    y2: -6235.7,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -63.37, -11.77)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-547",
    x1: 5353.68,
    y1: -6272.54,
    x2: 5350.4,
    y2: -6275.69,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -63.71, -11.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-548",
    x1: 7279.68,
    y1: -14926.64,
    x2: 7276.4,
    y2: -14929.79,
    gradientTransform: "matrix(0.01, 0, 0, -0.01, -64.4, -15.24)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-549",
    x1: 837.24,
    y1: -1525.99,
    x2: 833.96,
    y2: -1529.14,
    gradientTransform: "matrix(0.09, 0, 0, -0.08, -56.9, 9.18)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-550",
    x1: 10046.34,
    y1: -1437.41,
    x2: 10043.06,
    y2: -1440.56,
    gradientTransform: "matrix(0.01, 0, 0, -0.09, -64.7, 10.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-551",
    x1: 1383,
    y1: -4785.1,
    x2: 1379.71,
    y2: -4788.25,
    gradientTransform: "matrix(0.06, 0, 0, -0.03, -59.98, -7.93)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-552",
    x1: 5306.64,
    y1: -6070.15,
    x2: 5303.36,
    y2: -6073.3,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -64.05, -9.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-553",
    x1: 6885.42,
    y1: -1303.35,
    x2: 6882.14,
    y2: -1306.5,
    gradientTransform: "matrix(0.01, 0, 0, -0.09, -63.07, 6.37)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-554",
    x1: 6885.37,
    y1: -1292.14,
    x2: 6882.09,
    y2: -1295.29,
    gradientTransform: "matrix(0.01, 0, 0, -0.09, -63.07, 6.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-555",
    x1: 8275.09,
    y1: -6530.45,
    x2: 8271.8,
    y2: -6533.6,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -63.3, -15.49)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-556",
    x1: 4096.77,
    y1: -20446.17,
    x2: 4093.49,
    y2: -20449.32,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -62.26, -20.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-557",
    x1: 677.21,
    y1: 194.41,
    x2: 673.93,
    y2: 191.26,
    gradientTransform: "matrix(0.11, 0, 0, -1, -54.18, 317.88)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-558",
    x1: 4772.64,
    y1: -1357.73,
    x2: 4769.35,
    y2: -1360.88,
    gradientTransform: "matrix(0.02, 0, 0, -0.09, -63.06, 7.46)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-559",
    x1: 7399.45,
    y1: -1379.04,
    x2: 7396.17,
    y2: -1382.19,
    gradientTransform: "matrix(0.01, 0, 0, -0.09, -63.78, 8.32)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-560",
    x1: 3328.71,
    y1: -5371.03,
    x2: 3325.43,
    y2: -5374.18,
    gradientTransform: "matrix(0.02, 0, 0, -0.03, -62.63, -11.82)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-561",
    x1: 809.32,
    y1: -200.98,
    x2: 806.03,
    y2: -204.13,
    gradientTransform: "matrix(0.17, 0, 0, -0.15, -17.01, 1.34)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-562",
    x1: 38.36,
    y1: -551.59,
    x2: 35.08,
    y2: -554.75,
    gradientTransform: "matrix(1, 0, 0, -0.23, 57.95, 83.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-563",
    x1: 794.62,
    y1: -5138.53,
    x2: 791.34,
    y2: -5141.68,
    gradientTransform: "matrix(0.1, 0, 0, -0.03, -54.53, -14.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-564",
    x1: 1179.25,
    y1: -1453.84,
    x2: 1175.96,
    y2: -1457,
    gradientTransform: "matrix(0.06, 0, 0, -0.09, -58.92, 12.46)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-565",
    x1: 8597.51,
    y1: -2060.11,
    x2: 8594.23,
    y2: -2063.27,
    gradientTransform: "matrix(0.02, 0, 0, -0.05, -3.15, -13.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-566",
    x1: 968.6,
    y1: -1169.93,
    x2: 965.32,
    y2: -1173.08,
    gradientTransform: "matrix(0.1, 0, 0, -0.05, -40.91, -35.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-567",
    x1: 737.75,
    y1: -2065.42,
    x2: 734.46,
    y2: -2068.57,
    gradientTransform: "matrix(0.1, 0, 0, -0.06, -53.63, -3.73)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-568",
    x1: 388.59,
    y1: -1309.01,
    x2: 385.31,
    y2: -1312.16,
    gradientTransform: "matrix(0.18, 0, 0, -0.08, -45.55, 1.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-569",
    x1: 1246.9,
    y1: -1766.24,
    x2: 1243.62,
    y2: -1769.39,
    gradientTransform: "matrix(0.06, 0, 0, -0.09, -58.35, 26.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-570",
    x1: 1326.9,
    y1: -949.12,
    x2: 1323.62,
    y2: -952.28,
    gradientTransform: "matrix(0.09, 0, 0, -0.15, -37.09, 53.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-571",
    x1: 4035.29,
    y1: -5995.22,
    x2: 4032,
    y2: -5998.37,
    gradientTransform: "matrix(0.04, 0, 0, -0.03, -30.01, 12.16)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-572",
    x1: 1245.69,
    y1: -1473.85,
    x2: 1242.4,
    y2: -1477,
    gradientTransform: "matrix(0.08, 0, 0, -0.1, -43.26, 28.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-573",
    x1: 2785.62,
    y1: -2678.69,
    x2: 2782.34,
    y2: -2681.84,
    gradientTransform: "matrix(0.05, 0, 0, -0.03, -28.42, -40.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-574",
    x1: 1933.31,
    y1: -5153.22,
    x2: 1930.03,
    y2: -5156.37,
    gradientTransform: "matrix(0.1, 0, 0, -0.02, 0.94, -31.75)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-575",
    x1: 19993.79,
    y1: -6633.75,
    x2: 19990.5,
    y2: -6636.91,
    gradientTransform: "matrix(0.01, 0, 0, -0.03, -17.95, -0.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-576",
    x1: 1713.36,
    y1: -1222.99,
    x2: 1710.07,
    y2: -1226.14,
    gradientTransform: "matrix(0.08, 0, 0, -0.06, -30.83, -27.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-577",
    x1: 5759.91,
    y1: -12576.11,
    x2: 5756.62,
    y2: -12579.26,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -49.57, -0.62)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-578",
    x1: 9616.93,
    y1: -10999.71,
    x2: 9613.65,
    y2: -11002.86,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -10.85, 0.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-579",
    x1: 3928.77,
    y1: -1885.43,
    x2: 3925.49,
    y2: -1888.58,
    gradientTransform: "matrix(0.04, 0, 0, -0.03, -28.32, -44.31)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-580",
    x1: 1696.08,
    y1: -4739.01,
    x2: 1692.8,
    y2: -4742.16,
    gradientTransform: "matrix(0.08, 0, 0, -0.02, -30.56, -40.96)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-581",
    x1: 1459.88,
    y1: -3188.85,
    x2: 1456.6,
    y2: -3192,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -58.83, 5.55)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-582",
    x1: 3645.48,
    y1: 267.62,
    x2: 3642.2,
    y2: 264.47,
    gradientTransform: "matrix(0.03, 0, 0, -1, -46.21, 283.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-583",
    x1: 2862.7,
    y1: -1206.76,
    x2: 2859.41,
    y2: -1209.91,
    gradientTransform: "matrix(0.06, 0, 0, -0.05, -20.64, -39.92)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-584",
    x1: 1705.07,
    y1: -3196.1,
    x2: 1701.79,
    y2: -3199.25,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -60.16, 7.41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-585",
    x1: 2088.45,
    y1: -2718.98,
    x2: 2085.17,
    y2: -2722.14,
    gradientTransform: "matrix(0.07, 0, 0, -0.02, -25.22, -47.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-586",
    x1: 1112.26,
    y1: -5027.75,
    x2: 1108.97,
    y2: -5030.9,
    gradientTransform: "matrix(0.07, 0, 0, -0.03, -58.32, 0.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-587",
    x1: 3282.57,
    y1: -1285.02,
    x2: 3279.29,
    y2: -1288.17,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -21.31, -40.35)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-588",
    x1: 4181.44,
    y1: -2257.22,
    x2: 4178.15,
    y2: -2260.37,
    gradientTransform: "matrix(0.03, 0, 0, -0.07, -42.7, 24.75)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-589",
    x1: 3253.17,
    y1: -1232.55,
    x2: 3249.89,
    y2: -1235.71,
    gradientTransform: "matrix(0.06, 0, 0, -0.05, -5.61, -30.79)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-590",
    x1: 5628.54,
    y1: -17808.99,
    x2: 5625.25,
    y2: -17812.14,
    gradientTransform: "matrix(0.03, 0, 0, -0.01, -31.45, 6.75)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-591",
    x1: 3962.75,
    y1: 138.67,
    x2: 3959.47,
    y2: 135.52,
    gradientTransform: "matrix(0.03, 0, 0, -1, -37.64, 343.79)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-592",
    x1: 3232.18,
    y1: -3651.49,
    x2: 3228.9,
    y2: -3654.64,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -17.64, 11.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-593",
    x1: 8012.08,
    y1: -2950.99,
    x2: 8008.8,
    y2: -2954.14,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -41.36, -52.28)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-594",
    x1: 3520.13,
    y1: -16895.9,
    x2: 3516.84,
    y2: -16899.05,
    gradientTransform: "matrix(0.03, 0, 0, -0.01, -55.15, 2.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-595",
    x1: 1298.02,
    y1: -2087.39,
    x2: 1294.74,
    y2: -2090.54,
    gradientTransform: "matrix(0.09, 0, 0, -0.08, -36.03, 24.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-596",
    x1: 2438.15,
    y1: -4240.37,
    x2: 2434.87,
    y2: -4243.52,
    gradientTransform: "matrix(0.05, 0, 0, -0.04, -35.51, 18.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-597",
    x1: 2173.79,
    y1: -2712.63,
    x2: 2170.51,
    y2: -2715.78,
    gradientTransform: "matrix(0.06, 0, 0, -0.07, -36.31, 26.47)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-598",
    x1: 903.4,
    y1: -1221.83,
    x2: 900.11,
    y2: -1224.98,
    gradientTransform: "matrix(0.09, 0, 0, -0.08, -53.1, -2.33)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-599",
    x1: 1681.25,
    y1: -874.79,
    x2: 1677.96,
    y2: -877.94,
    gradientTransform: "matrix(0.08, 0, 0, -0.07, -30.19, -30.89)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-600",
    x1: 3685.52,
    y1: -5211.73,
    x2: 3682.24,
    y2: -5214.88,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -58.65, -34.24)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-601",
    x1: 1152.21,
    y1: -2762.28,
    x2: 1148.93,
    y2: -2765.43,
    gradientTransform: "matrix(0.07, 0, 0, -0.04, -54.34, -20.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-602",
    x1: 971.86,
    y1: -1185.3,
    x2: 968.57,
    y2: -1188.45,
    gradientTransform: "matrix(0.09, 0, 0, -0.08, -52.64, -5.77)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-603",
    x1: 7114.29,
    y1: -6811.12,
    x2: 7111.01,
    y2: -6814.27,
    gradientTransform: "matrix(0.03, 0, 0, -0.01, -16.87, -49.36)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-604",
    x1: 1259.38,
    y1: -1450.03,
    x2: 1256.1,
    y2: -1453.18,
    gradientTransform: "matrix(0.07, 0, 0, -0.07, -54.4, -8.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-605",
    x1: 7219.76,
    y1: -1404.04,
    x2: 7216.48,
    y2: -1407.19,
    gradientTransform: "matrix(0.03, 0, 0, -0.07, -1.55, -8.02)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-606",
    x1: 7779.87,
    y1: -4565.68,
    x2: 7776.59,
    y2: -4568.83,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -16.92, -47.73)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-607",
    x1: -9.54,
    y1: -1120.93,
    x2: -12.83,
    y2: -1124.08,
    gradientTransform: "matrix(1, 0, 0, -0.09, 35.69, 4.06)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-608",
    x1: 1257.21,
    y1: -1942.92,
    x2: 1253.92,
    y2: -1946.07,
    gradientTransform: "matrix(0.06, 0, 0, -0.06, -56.63, -6.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-609",
    x1: -8294.43,
    y1: -19558.83,
    x2: -8294.46,
    y2: -19558.85,
    gradientTransform: "matrix(0.01, 0, 0, -0.01, -62.05, -23.76)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-610",
    x1: 2666.69,
    y1: -1657.77,
    x2: 2663.4,
    y2: -1660.92,
    gradientTransform: "matrix(0.07, 0, 0, -0.07, 0.41, -3.46)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-611",
    x1: 2040.67,
    y1: -3820.81,
    x2: 2037.39,
    y2: -3823.97,
    gradientTransform: "matrix(0.07, 0, 0, -0.02, -32.25, -46.92)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-612",
    x1: 84.79,
    y1: -526.67,
    x2: 81.51,
    y2: -529.83,
    gradientTransform: "matrix(1, 0, 0, -0.09, 79.53, -22.82)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-613",
    x1: 2572.1,
    y1: -2577.5,
    x2: 2568.82,
    y2: -2580.66,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -37.59, -13.29)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-614",
    x1: 3479.28,
    y1: -1757.55,
    x2: 3475.99,
    y2: -1760.7,
    gradientTransform: "matrix(0.06, 0, 0, -0.05, -2.85, -18.66)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-615",
    x1: 1622.07,
    y1: -1991.17,
    x2: 1618.79,
    y2: -1994.33,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -58.3, -19.92)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-616",
    x1: 16069.64,
    y1: -3917.39,
    x2: 16066.36,
    y2: -3920.54,
    gradientTransform: "matrix(0.01, 0, 0, -0.03, -4.7, -26.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-617",
    x1: 3017.35,
    y1: -15639.54,
    x2: 3014.07,
    y2: -15642.7,
    gradientTransform: "matrix(0.03, 0, 0, -0.01, -59.92, -35.15)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-618",
    x1: 5032.05,
    y1: -5262.79,
    x2: 5028.76,
    y2: -5265.94,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -61.01, -30.73)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-619",
    x1: 1896.1,
    y1: -640.53,
    x2: 1892.82,
    y2: -643.68,
    gradientTransform: "matrix(0.09, 0, 0, -0.08, -12.01, -23.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-620",
    x1: 20305.98,
    y1: -2784.66,
    x2: 20302.69,
    y2: -2787.81,
    gradientTransform: "matrix(0.01, 0, 0, -0.03, -7.29, -43.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-621",
    x1: 1661.6,
    y1: -1952.47,
    x2: 1658.31,
    y2: -1955.62,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -56.52, -22.17)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-622",
    x1: 2246.17,
    y1: -1758.59,
    x2: 2242.89,
    y2: -1761.75,
    gradientTransform: "matrix(0.09, 0, 0, -0.06, 4.76, -15.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-623",
    x1: 9264.91,
    y1: -2959.87,
    x2: 9261.63,
    y2: -2963.02,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -36.39, -44.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-624",
    x1: 4467.48,
    y1: -7723.81,
    x2: 4464.2,
    y2: -7726.97,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -49.96, -48.81)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-625",
    x1: 1483.58,
    y1: -2244.33,
    x2: 1480.3,
    y2: -2247.48,
    gradientTransform: "matrix(0.06, 0, 0, -0.04, -56.57, -20.36)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-626",
    x1: 3692.7,
    y1: -2690.71,
    x2: 3689.42,
    y2: -2693.86,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -47.42, -45.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-627",
    x1: 1244.03,
    y1: -2941.94,
    x2: 1240.75,
    y2: -2945.09,
    gradientTransform: "matrix(0.06, 0, 0, -0.05, -57.03, 1.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-628",
    x1: 13887.01,
    y1: -4306.44,
    x2: 13883.72,
    y2: -4309.59,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -4.14, -39.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-629",
    x1: 3648.24,
    y1: -3340.78,
    x2: 3644.96,
    y2: -3343.93,
    gradientTransform: "matrix(0.05, 0, 0, -0.04, -7.58, 0.44)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-630",
    x1: 1057.74,
    y1: -1591.54,
    x2: 1054.46,
    y2: -1594.69,
    gradientTransform: "matrix(0.07, 0, 0, -0.08, -56.25, 14.23)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-631",
    x1: 1352.41,
    y1: -1570.47,
    x2: 1349.12,
    y2: -1573.62,
    gradientTransform: "matrix(0.06, 0, 0, -0.08, -57.67, 14.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-632",
    x1: 4233.99,
    y1: -1584.95,
    x2: 4230.71,
    y2: -1588.1,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -1.67, -29.17)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-633",
    x1: 3928.05,
    y1: -17209.42,
    x2: 3924.77,
    y2: -17212.57,
    gradientTransform: "matrix(0.02, 0, 0, -0.01, -63.82, -12.91)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-634",
    x1: 1051.49,
    y1: -3767.93,
    x2: 1048.2,
    y2: -3771.09,
    gradientTransform: "matrix(0.07, 0, 0, -0.04, -57.09, 2.57)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-635",
    x1: 850.15,
    y1: -1648.31,
    x2: 846.86,
    y2: -1651.46,
    gradientTransform: "matrix(0.09, 0, 0, -0.08, -54.77, 14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-636",
    x1: 4222.37,
    y1: -2742.56,
    x2: 4219.09,
    y2: -2745.71,
    gradientTransform: "matrix(0.03, 0, 0, -0.02, -48.45, -45.37)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-637",
    x1: 25473.01,
    y1: -3618.56,
    x2: 25469.72,
    y2: -3621.71,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -6.65, -43.9)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-638",
    x1: 1485.25,
    y1: -2498.3,
    x2: 1481.97,
    y2: -2501.45,
    gradientTransform: "matrix(0.06, 0, 0, -0.05, -57.35, -10.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-639",
    x1: 3726.34,
    y1: -2233.8,
    x2: 3723.06,
    y2: -2236.95,
    gradientTransform: "matrix(0.06, 0, 0, -0.05, 0.02, -8.3)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-640",
    x1: 2236.1,
    y1: -16761.41,
    x2: 2232.81,
    y2: -16764.56,
    gradientTransform: "matrix(0.09, 0, 0, -0.01, 0.87, -23.39)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-641",
    x1: 2407.53,
    y1: -1368.63,
    x2: 2404.25,
    y2: -1371.79,
    gradientTransform: "matrix(0.08, 0, 0, -0.08, 0.35, 1.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-642",
    x1: 114.55,
    y1: -740.8,
    x2: 111.26,
    y2: -743.95,
    gradientTransform: "matrix(1, 0, 0, -0.09, 93.36, -12.17)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-643",
    x1: 816.11,
    y1: -1426.93,
    x2: 812.83,
    y2: -1430.08,
    gradientTransform: "matrix(0.09, 0, 0, -0.08, -55.66, 7.82)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-644",
    x1: 3655.71,
    y1: -3420.44,
    x2: 3652.43,
    y2: -3423.6,
    gradientTransform: "matrix(0.02, 0, 0, -0.04, -62.66, -6.08)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-645",
    x1: 839.1,
    y1: -1571.56,
    x2: 835.82,
    y2: -1574.71,
    gradientTransform: "matrix(0.09, 0, 0, -0.08, -56.82, 8.52)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-646",
    x1: 3054.53,
    y1: -2701.04,
    x2: 3051.25,
    y2: -2704.2,
    gradientTransform: "matrix(0.04, 0, 0, -0.02, -35.95, -45.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-647",
    x1: 10211.08,
    y1: -4732.61,
    x2: 10207.79,
    y2: -4735.76,
    gradientTransform: "matrix(0.01, 0, 0, -0.01, -39.63, -49.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-648",
    x1: -12.36,
    y1: -1291.31,
    x2: -15.64,
    y2: -1294.46,
    gradientTransform: "matrix(1, 0, 0, -0.09, 34.38, 6.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-649",
    x1: 9676.84,
    y1: -3705.34,
    x2: 9673.56,
    y2: -3708.49,
    gradientTransform: "matrix(0.01, 0, 0, -0.02, -38.33, -47.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-650",
    x1: 4279.9,
    y1: -4107.49,
    x2: 4276.61,
    y2: -4110.64,
    gradientTransform: "matrix(0.02, 0, 0, -0.03, -62.69, -10.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-651",
    x1: 830.92,
    y1: -2201.27,
    x2: 827.64,
    y2: -2204.43,
    gradientTransform: "matrix(0.09, 0, 0, -0.06, -55.59, -1.5)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-652",
    x1: 3357.99,
    y1: -1286,
    x2: 3354.71,
    y2: -1289.15,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -23.12, -38.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-653",
    x1: 473.25,
    y1: -408.27,
    x2: 469.97,
    y2: -411.42,
    gradientTransform: "matrix(0.14, 0, 0, -0.23, -51.62, 71.15)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-654",
    x1: 1552.86,
    y1: -3303.11,
    x2: 1549.58,
    y2: -3306.26,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -60.78, 7.86)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-655",
    x1: 1456.14,
    y1: -3487.78,
    x2: 1452.86,
    y2: -3490.93,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -60.57, 7.84)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-656",
    x1: 294.11,
    y1: -662.4,
    x2: 290.83,
    y2: -665.55,
    gradientTransform: "matrix(0.2, 0, 0, -0.18, -47.29, 57.69)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-657",
    x1: 1519.17,
    y1: -3434.06,
    x2: 1515.89,
    y2: -3437.22,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -61.55, 10.78)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-658",
    x1: 1068.21,
    y1: -6849.96,
    x2: 1064.93,
    y2: -6853.11,
    gradientTransform: "matrix(0.07, 0, 0, -0.02, -58.44, -1.13)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-659",
    x1: 1569.47,
    y1: -3271.26,
    x2: 1566.19,
    y2: -3274.41,
    gradientTransform: "matrix(0.05, 0, 0, -0.05, -60.39, 7.15)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-660",
    x1: 853.39,
    y1: -700.09,
    x2: 850.11,
    y2: -703.25,
    gradientTransform: "matrix(0.09, 0, 0, -0.16, -55.17, 39.52)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-661",
    x1: 1363.1,
    y1: -1560.27,
    x2: 1359.81,
    y2: -1563.42,
    gradientTransform: "matrix(0.06, 0, 0, -0.09, -58.15, 15.58)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-662",
    x1: 7091.28,
    y1: -4042.26,
    x2: 7088,
    y2: -4045.42,
    gradientTransform: "matrix(0.02, 0, 0, -0.02, -30.99, -44.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-663",
    x1: 3734.77,
    y1: -4728.26,
    x2: 3731.48,
    y2: -4731.41,
    gradientTransform: "matrix(0.05, 0, 0, -0.04, -9.16, 10.03)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-664",
    x1: -6.23,
    y1: -1097.55,
    x2: -9.51,
    y2: -1100.7,
    gradientTransform: "matrix(1, 0, 0, -0.09, 37.23, -1.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-665",
    x1: 3497.22,
    y1: -8432.04,
    x2: 3493.94,
    y2: -8435.19,
    gradientTransform: "matrix(0.03, 0, 0, -0.01, -58.83, -26.58)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-666",
    x1: -16.81,
    y1: 188.22,
    x2: -16.81,
    y2: 188.22,
    gradientTransform: "matrix(1, 0, 0, -1, 33.47, 320.36)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-667",
    x1: 2246.17,
    y1: -857.37,
    x2: 2242.89,
    y2: -860.52,
    gradientTransform: "matrix(0.09, 0, 0, -0.08, 3.59, -14.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-668",
    x1: -12.35,
    y1: -1284.34,
    x2: -15.64,
    y2: -1287.49,
    gradientTransform: "matrix(1, 0, 0, -0.09, 34.38, 6.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-669",
    x1: 386.06,
    y1: -1378.19,
    x2: 382.78,
    y2: -1381.34,
    gradientTransform: "matrix(0.17, 0, 0, -0.09, -48, 8.31)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-670",
    x1: 5257.18,
    y1: -4547.49,
    x2: 5253.89,
    y2: -4550.64,
    gradientTransform: "matrix(0.02, 0, 0, -0.03, -61.81, -16.51)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-671",
    x1: 2908.54,
    y1: -3191.71,
    x2: 2905.26,
    y2: -3194.86,
    gradientTransform: "matrix(0.07, 0, 0, -0.02, -4.47, -42.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-672",
    x1: 796.17,
    y1: -1464.31,
    x2: 792.89,
    y2: -1467.46,
    gradientTransform: "matrix(0.09, 0, 0, -0.08, -56.51, 10.43)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-673",
    x1: 803.7,
    y1: -1356.87,
    x2: 800.42,
    y2: -1360.02,
    gradientTransform: "matrix(0.09, 0, 0, -0.09, -55.64, 7.46)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-674",
    x1: 1032.55,
    y1: -509.21,
    x2: 1029.27,
    y2: -512.36,
    gradientTransform: "matrix(0.17, 0, 0, -0.08, 0.82, -27.99)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-675",
    x1: 836.46,
    y1: -1436.99,
    x2: 833.18,
    y2: -1440.14,
    gradientTransform: "matrix(0.09, 0, 0, -0.09, -56.9, 10.67)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-676",
    x1: 2236.22,
    y1: -1369.11,
    x2: 2232.93,
    y2: -1372.26,
    gradientTransform: "matrix(0.09, 0, 0, -0.08, 0.87, 1.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-677",
    x1: -94.19,
    y1: 338.73,
    x2: -97.48,
    y2: 335.58,
    gradientTransform: "matrix(66.39, 0, 0, -66.33, 6482.05, 22466.8)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kadenai_-_negative_gradient",
    "data-name": "kadenai - negative gradient"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4525",
    "data-name": "Group 4525"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4518",
    "data-name": "Group 4518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3170",
    "data-name": "Path 3170",
    className: "cls-3",
    d: "M15.35,165.26a2.28,2.28,0,0,0,.26.84,4.25,4.25,0,0,0,.82.63l0,0c-.19.14-.51.25-.56.43-.16.65-.23,1.32-.35,2.06l-.94-.05,0,0a4.78,4.78,0,0,0-.49-1.08c-.18-.24-.54-.37-.75-.69l1.62.72c.1-.24.17-.43.25-.63a4.68,4.68,0,0,1,.37-.63l-.45-.09.11.72-.75-.2c.57-.51.43-1.31-.45-1.71l.94-.85.26.51h0m0,1.14-.08-.08s-.08.05-.08.07,0,.06.07.08l.09-.07m-.32,1.94-.08.07s0,.07.08.07,0,0,.08-.06l-.08-.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3171",
    "data-name": "Path 3171",
    className: "cls-4",
    d: "M9.12,183.49a3.85,3.85,0,0,1,.31-3.65h0c.19.46-.4,1.39.9,1.23.13,0,.37.72.54,1.05l-.73.75,0,0-.65-.13-.39.77v0m.29-2.23-.38.3.71.66L10,182l-.58-.75",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3172",
    "data-name": "Path 3172",
    className: "cls-5",
    d: "M11.46,179.43l-.59.48.44,1.21-.2.06-1.68-1.35h0c.17-.14.5-.31.47-.42-.22-.73.22-1.09.81-1.39v.31l.81.07,0,0c0,.34-.08.68-.13,1l-.38-.58-.22.27.63.31",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3173",
    "data-name": "Path 3173",
    className: "cls-6",
    d: "M11.68,176.48a.69.69,0,0,1,.13-1.21l0,0,.13.69.25,0,.13-.67v0c1,.06.39-1,.93-1.23.17-.08.28-.25.62-.58-.27,2.39-.75,3-2.16,3h0M13,175.6l-.07-.08s-.08,0-.08.07,0,0,.07.08l.08-.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3174",
    "data-name": "Path 3174",
    className: "cls-7",
    d: "M13,173.19l-1.19-.36c.32-1.05.61-2.08.95-3.1a4.8,4.8,0,0,1,.75.09c-1.84,1-.56,2.23-.5,3.37",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3175",
    "data-name": "Path 3175",
    className: "cls-8",
    d: "M24.53,83.88c-.8.35-1.35-.26-2.28-.69l.91,1.89c-.69-.13-1.43-1.2-1.17-1.83s.76-.29,1.15-.11.84.45,1.39.75",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3176",
    "data-name": "Path 3176",
    className: "cls-9",
    d: "M24.38,80.37l1,1.42h-.94c.09,1-.08,1.23-.9,1.08l.81-2.5",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3177",
    "data-name": "Path 3177",
    className: "cls-10",
    d: "M16.1,163.63l.28-.69h.37a5.65,5.65,0,0,1,0,1.48c-.06.23-.27.89-.87.4h0l-.63-1.72,1,.5.19.08-.22-.05m.49.54-.08-.08s-.07,0-.08.08,0,.05.07.08l.08-.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3178",
    "data-name": "Path 3178",
    className: "cls-11",
    d: "M114.6,32.54l-.92-1.81.34-.17L115.35,32l-.78.5Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3179",
    "data-name": "Path 3179",
    className: "cls-12",
    d: "M31.37,59.22c-1.58,1,.66.75.46,1.33l-.66.37.51,1,0,0c-1.2,0-1-1-1.11-1.58-.06-.34-.09-1.11.8-1.05Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3180",
    "data-name": "Path 3180",
    className: "cls-13",
    d: "M48,192l-.41,1a6.82,6.82,0,0,1-1.4-.93,3.17,3.17,0,0,1-.6-1.44c.56.52,1.1,1.06,1.71,1.53.12.1.48-.06.73-.1l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3181",
    "data-name": "Path 3181",
    className: "cls-14",
    d: "M28.61,78.89l.4,1.57c-.43,0-1-1-1.39,0V79.12l1-.22h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3182",
    "data-name": "Path 3182",
    className: "cls-15",
    d: "M20.77,150.81v-.68l0,0,.18-.09-.18-.18,0,.05-.28-.5,0,0,.29-.46,0,0,.71.29,0,0,.28.26,0,0c-.43.38.1,1.36-1,1.35Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3183",
    "data-name": "Path 3183",
    className: "cls-16",
    d: "M28,84.4A12.52,12.52,0,0,1,27,83.14c-.07-.11.21-.41.33-.63l.35,0L28,84.41l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3184",
    "data-name": "Path 3184",
    className: "cls-17",
    d: "M14.61,169.14l.43,1.57c-.77-.43-1.36-.9-.39-1.55l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3185",
    "data-name": "Path 3185",
    className: "cls-18",
    d: "M30.12,61.74a4.89,4.89,0,0,1,.05,1.08c0,.16-.38.41-.46.37a.72.72,0,0,1-.4-.67l.57.25-.13-1,.37,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3186",
    "data-name": "Path 3186",
    className: "cls-19",
    d: "M11.51,176.84l-.81.61-.24-1.37,1.08.79Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3187",
    "data-name": "Path 3187",
    className: "cls-20",
    d: "M22,148.33l-.94.31L21,147.17l1,.74v0l-.23.13.23.13,0,0v.27Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3188",
    "data-name": "Path 3188",
    className: "cls-21",
    d: "M77,203.22l-1.07,1.39-.2-.09.82-1.5.45.2",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    "data-name": "Path 3189",
    className: "cls-22",
    d: "M17.85,160.36l.43-1.51.43.1-.42,1.52-.44-.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3190",
    "data-name": "Path 3190",
    className: "cls-23",
    d: "M117.87,32.44l.63.63-1.2-.33,0,0-.53-.48,0,0v-.49l0,0,1.11.55-.06,0h0l0,.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    "data-name": "Path 3191",
    className: "cls-24",
    d: "M92.28,209.85l.58-.72,1,.47,0,0v.73l0,0-1.58-.44Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3192",
    "data-name": "Path 3192",
    className: "cls-25",
    d: "M104,36.92l-.91,1.94-.37-.17c.37-.63.73-1.23,1.1-1.84l.18.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3193",
    "data-name": "Path 3193",
    className: "cls-26",
    d: "M40.09,49.67l-.25-1.47.89.44-.68,1.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3194",
    "data-name": "Path 3194",
    className: "cls-27",
    d: "M43.17,44.49l-.86,1.26-.3-.16.87-1.31.28.19",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3195",
    "data-name": "Path 3195",
    className: "cls-28",
    d: "M11.11,174.46l.75-1.05.32.15c0,.3,0,.6,0,.91h-1Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3196",
    "data-name": "Path 3196",
    className: "cls-29",
    d: "M11.53,178.38l.75-1,.44.46-1.15.55Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3197",
    "data-name": "Path 3197",
    className: "cls-30",
    d: "M13.19,172l.75.1,0,0,.32,1.32-.32.11L13.24,172Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3198",
    "data-name": "Path 3198",
    className: "cls-31",
    d: "M26.6,68.53l.17.57c-.24-.2-.5-.36-.48-.4a10.57,10.57,0,0,1,.56-.91l.44.25-.68.49",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3199",
    "data-name": "Path 3199",
    className: "cls-32",
    d: "M42.46,47.5c-.19-.21-.38-.43-.56-.65s-.43-.52-.63-.78l.39-.23.81,1.67h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3200",
    "data-name": "Path 3200",
    className: "cls-33",
    d: "M180.07,178.71c.27.66.52,1.32-.24,2,.09-.73.17-1.36.24-2h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3201",
    "data-name": "Path 3201",
    className: "cls-34",
    d: "M177.76,185l-.15-1.3,0,0,.34,0h0c.05.31.08.61.1.93,0,.12-.17.24-.28.37l-.06-.08a.09.09,0,0,0-.07,0l.16.12",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    "data-name": "Path 3202",
    className: "cls-35",
    d: "M117.36,30.89l1.32.63-.54.47-.77-1.1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    "data-name": "Path 3203",
    className: "cls-36",
    d: "M79.14,194.53l0-.6c.14.07.32.24.4.21s.27-.25.4-.39l.28.26-.69.82-.43-.31",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    "data-name": "Path 3204",
    className: "cls-37",
    d: "M192,76.33l1.72-.19v.39L192,76.29Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    "data-name": "Path 3205",
    className: "cls-38",
    d: "M207.11,93.29c.8.71.14,1.09-.54,1.72l.53-1.69v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3206",
    "data-name": "Path 3206",
    className: "cls-39",
    d: "M28.53,93.57c.88-.46.78.48,1.18.71l0,0H29l.06,0-.2-.44h0l-.1.13-.19-.18,0,0v-.28Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3207",
    "data-name": "Path 3207",
    className: "cls-40",
    d: "M80.9,190.3l-.45,1.64-.31-.09.72-1.53Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    "data-name": "Path 3208",
    className: "cls-41",
    d: "M180.79,177.18l.41.77.52-.95.26.19-.69.7-.49-.73h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3209",
    "data-name": "Path 3209",
    className: "cls-42",
    d: "M189.19,160.61l-.27,1.18-.23,0,.18-1.19.32.05",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3210",
    "data-name": "Path 3210",
    className: "cls-43",
    d: "M203.36,48.14l1-.72c-.26.32-.16,1.11-1,.7Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3211",
    "data-name": "Path 3211",
    className: "cls-44",
    d: "M104,35.85l1.39-.08-.08.53L104,35.82Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    "data-name": "Path 3212",
    className: "cls-45",
    d: "M22.7,110.4l-.1-1.26.43,0-.37,1.18,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3213",
    "data-name": "Path 3213",
    className: "cls-46",
    d: "M16.63,132.43a1.42,1.42,0,0,0,0,.2h0c-1.13,0-.43-.61-.55-1.26l.56.78h0v.28Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    "data-name": "Path 3214",
    className: "cls-47",
    d: "M10.14,182.85l.53.9-.59.07c0-.33.06-.67.1-1l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    "data-name": "Path 3215",
    className: "cls-48",
    d: "M22.62,86.55l-.44-1c1,.09,1,.09.44,1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    "data-name": "Path 3216",
    className: "cls-49",
    d: "M16.75,159.89l.48-1.1.27.07L17.1,160l-.35-.15",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3217",
    "data-name": "Path 3217",
    className: "cls-50",
    d: "M17,157.63l1.05.82,0,0c-.52-.1-1.25,0-1.06-.83Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3218",
    "data-name": "Path 3218",
    className: "cls-51",
    d: "M82.1,190l-.63-1.09.44-.14c.06.42.12.83.17,1.23h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3219",
    "data-name": "Path 3219",
    className: "cls-52",
    d: "M25.86,103.26l-.87-.72v0l.59-.23,0,0c.45.2,1,.39.25.89Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3220",
    "data-name": "Path 3220",
    className: "cls-53",
    d: "M204.65,159.13l.78.63h-1.28l0,0,.49-.71Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    "data-name": "Path 3221",
    className: "cls-54",
    d: "M201.25,99c1,0,.57.59.38,1.06l-.32-1.1,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3222",
    "data-name": "Path 3222",
    className: "cls-55",
    d: "M29.28,81.5l-1.14.13,0-.5,1.13.4,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3223",
    "data-name": "Path 3223",
    className: "cls-56",
    d: "M184,170.6l.48-.14c0,.21-.06.44-.12.89-.17-.4-.25-.59-.32-.78l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3224",
    "data-name": "Path 3224",
    className: "cls-57",
    d: "M205.65,57.68a7.13,7.13,0,0,1,.45.67l-.24.18-.43-.63-.05,0,.28-.26Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3225",
    "data-name": "Path 3225",
    className: "cls-58",
    d: "M20.14,120.62l-.58-.55h0v-.27l0,0,.68.05-.11.74h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3226",
    "data-name": "Path 3226",
    className: "cls-59",
    d: "M24.66,78l.24,1.21-.44,0c.07-.42.15-.85.22-1.26l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3227",
    "data-name": "Path 3227",
    className: "cls-60",
    d: "M31.41,59.26l-.21-.55.83-.1.12.2-.78.41,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3228",
    "data-name": "Path 3228",
    className: "cls-61",
    d: "M18.73,122.67l.32.7-.15.07-.39-.68.21-.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3229",
    "data-name": "Path 3229",
    className: "cls-62",
    d: "M18.35,127.92l-.73-.67h0l.54-.26,0,0,.49.67v0l-.28.26Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3230",
    "data-name": "Path 3230",
    className: "cls-63",
    d: "M33.36,57l-.65-.62.28-.24.63.63-.26.22",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3231",
    "data-name": "Path 3231",
    className: "cls-64",
    d: "M118.79,30.83l.57-.61.15.07-.4.78-.31-.24",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3232",
    "data-name": "Path 3232",
    className: "cls-65",
    d: "M127.92,195.35l.46-.51.32.27-.54.47-.25-.23",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3233",
    "data-name": "Path 3233",
    className: "cls-66",
    d: "M69.81,14.27H68.68l.11-.35,1,.35h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3234",
    "data-name": "Path 3234",
    className: "cls-67",
    d: "M20.75,180.73l.54-.88.23.1-.43,1-.34-.16",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3235",
    "data-name": "Path 3235",
    className: "cls-68",
    d: "M140.75,14.71l.51.11,0,0c-.29.39.1,1.36-1,1h0l.59-1.1Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3236",
    "data-name": "Path 3236",
    className: "cls-69",
    d: "M25.26,84.15l-.35-.77.29-.13.41.79-.35.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3237",
    "data-name": "Path 3237",
    className: "cls-70",
    d: "M188.27,162.4l.6.29-.24.35-.48-.41.12-.23",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3238",
    "data-name": "Path 3238",
    className: "cls-71",
    d: "M202.75,61.22l.53-.46.15.12-.45.55-.22-.22",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3239",
    "data-name": "Path 3239",
    className: "cls-72",
    d: "M179.14,182.85l-1.23.87h0l1.2-.83Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3240",
    "data-name": "Path 3240",
    className: "cls-73",
    d: "M158.19,13c.08.32.17.65.26,1l0,0c-1-.08-.46-.52-.24-.89Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3241",
    "data-name": "Path 3241",
    className: "cls-74",
    d: "M22.28,111c-.57-.63.16-.46.42-.58l0,0c.11.43.17.81-.54.63l0,0a.76.76,0,0,0,.2-.06l-.05-.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3242",
    "data-name": "Path 3242",
    className: "cls-75",
    d: "M8.9,183.85l.38.31-.08.15-.73-.44h.41Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3243",
    "data-name": "Path 3243",
    className: "cls-76",
    d: "M141.89,14c.27.63-.08.79-.68.79l0,0,.63-.83Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3244",
    "data-name": "Path 3244",
    className: "cls-77",
    d: "M29.2,79l.65.37-.32.3L29.25,79l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3245",
    "data-name": "Path 3245",
    className: "cls-78",
    d: "M205.58,108.66c0-.4,0-.81.07-1.21l.34,0-.29,1.08-.11.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    "data-name": "Path 3246",
    className: "cls-79",
    d: "M119.73,16.83l.32-.81.28.09L120,17l-.26-.17",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3247",
    "data-name": "Path 3247",
    className: "cls-80",
    d: "M76.94,202.35l-.24-.57.24-.11.32.57-.32.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3248",
    "data-name": "Path 3248",
    className: "cls-81",
    d: "M200.85,50.7c0-.19,0-.38,0-.58h.22c0,.19,0,.39,0,.58h-.29",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3249",
    "data-name": "Path 3249",
    className: "cls-82",
    d: "M165.82,21.24l-.69.23-.06-.19.68-.2.07.16",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3250",
    "data-name": "Path 3250",
    className: "cls-83",
    d: "M14.82,143.07l0,.71-.63-.49-.05,0,.67-.2h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3251",
    "data-name": "Path 3251",
    className: "cls-84",
    d: "M187.6,34.48l-.4.19-.2-.51.6.34a.9.9,0,0,0-.21-.08l.2.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3252",
    "data-name": "Path 3252",
    className: "cls-85",
    d: "M24,104.93l.72.75h0c-.58,0-.92-.14-.71-.76Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    className: "cls-86",
    d: "M126.73,200l.34-.51.24.12-.32.52-.26-.13",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3254",
    "data-name": "Path 3254",
    className: "cls-87",
    d: "M45.19,189.24l.7.23-.07.21-.74-.13.11-.31",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3255",
    "data-name": "Path 3255",
    className: "cls-88",
    d: "M125.24,13.12l.77.22-.24.38-.48-.59Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3256",
    "data-name": "Path 3256",
    className: "cls-89",
    d: "M118.92,16.48l-.08.68h-.22v-.69h.3",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3257",
    "data-name": "Path 3257",
    className: "cls-90",
    d: "M14.13,168.67l-.63.41-.18-.16c.15-.2.31-.39.49-.59l.31.34",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3258",
    "data-name": "Path 3258",
    className: "cls-91",
    d: "M31.83,173.22l-.32.37c-.08-.07-.24-.15-.24-.21a2.21,2.21,0,0,1,.18-.51l.38.35",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3259",
    "data-name": "Path 3259",
    className: "cls-92",
    d: "M35.75,53.84l.09-.53H36l-.06.54-.17,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3260",
    "data-name": "Path 3260",
    className: "cls-93",
    d: "M15.89,135.09v.69l0,0-.24-.87,0,0,.29.27Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3261",
    "data-name": "Path 3261",
    className: "cls-94",
    d: "M34.33,57.47l.13-.65h.22l.1.65,0,0h-.51Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3262",
    "data-name": "Path 3262",
    className: "cls-95",
    d: "M110.15,30.17l.95.49-.06.13-1-.36.12-.26",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3263",
    "data-name": "Path 3263",
    className: "cls-96",
    d: "M17.5,129.16l-.51-.95v0c.66.09.7.47.5,1h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3264",
    "data-name": "Path 3264",
    className: "cls-97",
    d: "M44,42.68l-.18.43-.18,0,.11-.47.25.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3265",
    "data-name": "Path 3265",
    className: "cls-98",
    d: "M94.3,18l-.66.52-.08-.1.44-.71.3.29",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3266",
    "data-name": "Path 3266",
    className: "cls-99",
    d: "M20.65,117.74l-.79.24,0-.25h.81",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3267",
    "data-name": "Path 3267",
    className: "cls-100",
    d: "M26.7,87.61l.22,1.1-.36,0c.05-.36.1-.71.14-1.07h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3268",
    "data-name": "Path 3268",
    className: "cls-101",
    d: "M27.45,81.46l.27.58-.27.08-.15-.63.16,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3269",
    "data-name": "Path 3269",
    className: "cls-102",
    d: "M114,29.54a2.22,2.22,0,0,1,.25.42s-.17.15-.22.13a.45.45,0,0,1-.22-.23c0-.06.09-.15.19-.32",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3270",
    "data-name": "Path 3270",
    className: "cls-103",
    d: "M25.5,82.38l.5.32a2.42,2.42,0,0,1-.48.13s-.11-.17-.16-.26l.14-.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3271",
    "data-name": "Path 3271",
    className: "cls-104",
    d: "M192.57,30.55c-.07-.29-.15-.58-.22-.87l.28,0-.09.94,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3272",
    "data-name": "Path 3272",
    className: "cls-105",
    d: "M25.4,85.05l-.57.31-.17-.14.43-.45.32.27",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3273",
    "data-name": "Path 3273",
    className: "cls-106",
    d: "M35.06,165.42l-.54-.44.17-.12.35.58,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3274",
    "data-name": "Path 3274",
    className: "cls-107",
    d: "M16.67,165.46l-.31.64-.24-.1.43-.59.11,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3275",
    "data-name": "Path 3275",
    className: "cls-108",
    d: "M32.11,171l-.32-.68.47.61-.17.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3276",
    "data-name": "Path 3276",
    className: "cls-109",
    d: "M124.53,15v.63h-.19l-.11-.64h.31",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3277",
    "data-name": "Path 3277",
    className: "cls-110",
    d: "M119.8,15.31l.27-.54.14.05-.24.55-.17-.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3278",
    "data-name": "Path 3278",
    className: "cls-111",
    d: "M30.05,179.23l-.31-.44.17-.09.13.53Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3279",
    "data-name": "Path 3279",
    className: "cls-112",
    d: "M178.82,181l.51.71-.22.05c-.09-.26-.18-.52-.28-.79v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3280",
    "data-name": "Path 3280",
    className: "cls-113",
    d: "M186.14,35.34l-.39.52-.14-.13.52-.39Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3281",
    "data-name": "Path 3281",
    className: "cls-114",
    d: "M117.61,197.68l-.16-.44.21-.06c0,.17,0,.33,0,.5h-.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3282",
    "data-name": "Path 3282",
    className: "cls-115",
    d: "M75.64,207.64l-.19-.69.12,0,.26.68-.19,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3283",
    "data-name": "Path 3283",
    className: "cls-116",
    d: "M199.67,108.66,199,109a2.19,2.19,0,0,1,.1-.34,3.5,3.5,0,0,1,.56,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3284",
    "data-name": "Path 3284",
    className: "cls-117",
    d: "M60.54,24.81l-.06-.72h.31l-.25.7h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3285",
    "data-name": "Path 3285",
    className: "cls-118",
    d: "M194.3,109c.08.12.18.2.17.26s-.12.13-.19.2-.19-.13-.2-.2.11-.14.22-.26",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3286",
    "data-name": "Path 3286",
    className: "cls-119",
    d: "M199.51,64.1l.2-.29v.5h-.1a1.63,1.63,0,0,1-.09-.19h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3287",
    "data-name": "Path 3287",
    className: "cls-120",
    d: "M16.87,130.35l-.32-.37.26-.11c0,.16,0,.31,0,.49h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3288",
    "data-name": "Path 3288",
    className: "cls-121",
    d: "M39.36,50.54l-.25.41L39,50.9c0-.15.09-.3.14-.45l.25.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3289",
    "data-name": "Path 3289",
    className: "cls-122",
    d: "M20.78,150.12l-.8.1.55-.77,0,0,.28.5,0-.05v.27Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3290",
    "data-name": "Path 3290",
    className: "cls-123",
    d: "M17.15,161.57h-.92v-.21h.93l-.05,0v.27Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3291",
    "data-name": "Path 3291",
    className: "cls-124",
    d: "M189.78,158.77l.11.86-.32,0,.19-.82Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3292",
    "data-name": "Path 3292",
    className: "cls-125",
    d: "M203.63,160.48l-.42.6L203,161l.3-.67.31.16",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3293",
    "data-name": "Path 3293",
    className: "cls-126",
    d: "M192.17,161.31l.2-.54.16,0-.12.56-.24-.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3294",
    "data-name": "Path 3294",
    className: "cls-127",
    d: "M184.5,37l-.08.21a1,1,0,0,1-.29-.13s0-.11.05-.17l.31.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3295",
    "data-name": "Path 3295",
    className: "cls-128",
    d: "M205.82,46.85a1.31,1.31,0,0,1,0-.28s.12-.06.18-.1a1.67,1.67,0,0,1,.08.3l-.27.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3296",
    "data-name": "Path 3296",
    className: "cls-129",
    d: "M203.31,49c0,.05.08.1.08.13a.23.23,0,0,1-.11.16s-.11,0-.17,0l.19-.26",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3297",
    "data-name": "Path 3297",
    className: "cls-130",
    d: "M122.94,15.21h.63v.18l-.66,0v-.22",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3298",
    "data-name": "Path 3298",
    className: "cls-131",
    d: "M122.07,16.08l-.45.46-.17-.13.41-.47.21.14",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3299",
    "data-name": "Path 3299",
    className: "cls-132",
    d: "M35.9,163.5l-.78-.07.08-.27.68.35h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    "data-name": "Path 3300",
    className: "cls-133",
    d: "M200.26,162l-.16.52-.24-.18.44-.32Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    "data-name": "Path 3301",
    className: "cls-134",
    d: "M194,160l-.36-.36.32-.14V160Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    "data-name": "Path 3302",
    className: "cls-135",
    d: "M15.53,137.63l-.56.2-.06-.2h.63",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    "data-name": "Path 3303",
    className: "cls-136",
    d: "M17.62,127l.26-.76.22.79,0,0h-.5Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    "data-name": "Path 3304",
    className: "cls-137",
    d: "M18.36,124.32l.41.22-.07.17-.67-.15,0,0,.28-.27Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3305",
    "data-name": "Path 3305",
    className: "cls-138",
    d: "M115.55,203.47c0,.15,0,.31,0,.46h-.21l0-.48.24,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    "data-name": "Path 3306",
    className: "cls-139",
    d: "M45.16,191.18l.3.21c-.08.08-.14.19-.23.23s-.2-.09-.22-.16.08-.16.15-.28",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    "data-name": "Path 3307",
    className: "cls-140",
    d: "M82.91,187.44c-.09-.18-.19-.32-.16-.32a1.69,1.69,0,0,1,.31-.21c0,.06.12.13.1.16a2,2,0,0,1-.26.38",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3308",
    "data-name": "Path 3308",
    className: "cls-141",
    d: "M126.6,12.2l-.27.34-.27-.26c.08-.07.15-.18.24-.19s.19.07.29.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3309",
    "data-name": "Path 3309",
    className: "cls-142",
    d: "M54.82,184.78l-.13-.31.34.19-.21.13",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3310",
    "data-name": "Path 3310",
    className: "cls-143",
    d: "M29.26,183.73l0-.52.24,0-.06.52h-.21",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3311",
    "data-name": "Path 3311",
    className: "cls-144",
    d: "M30.49,182l-.49-.23.24-.18.21.44,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3312",
    "data-name": "Path 3312",
    className: "cls-145",
    d: "M172.66,14.81l.73-.51,0,0-.15.68,0,0-.52-.26Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3313",
    "data-name": "Path 3313",
    className: "cls-146",
    d: "M209.84,91l.44-.24.12.26-.51.11,0-.12",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3314",
    "data-name": "Path 3314",
    className: "cls-147",
    d: "M29.72,89.31l-.31-.52.23-.1.3.41,0,0-.27.25Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3315",
    "data-name": "Path 3315",
    className: "cls-148",
    d: "M212,89.12v-.81l.29.08-.31.71,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3316",
    "data-name": "Path 3316",
    className: "cls-149",
    d: "M199.83,101.26a1.48,1.48,0,0,1,0,.42s-.13.06-.2.08v-.5h.21",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3317",
    "data-name": "Path 3317",
    className: "cls-150",
    d: "M24.57,104l.21.25c-.06,0-.14.09-.16.07a1.3,1.3,0,0,1-.22-.19l.17-.13",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3318",
    "data-name": "Path 3318",
    className: "cls-151",
    d: "M23.22,82l-.55-.14v-.1h.6L23.2,82",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3319",
    "data-name": "Path 3319",
    className: "cls-152",
    d: "M196.42,106l.41.59-.25.1-.16-.69",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3320",
    "data-name": "Path 3320",
    className: "cls-153",
    d: "M192.49,78.87l-.38-.66.37-.08v.74",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3321",
    "data-name": "Path 3321",
    className: "cls-154",
    d: "M194.4,108.51l.94.24h0l-.94-.24Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3322",
    "data-name": "Path 3322",
    className: "cls-155",
    d: "M13,176.92l-.24.37-.16-.09.24-.39.16.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3323",
    "data-name": "Path 3323",
    className: "cls-156",
    d: "M211.32,89.21l-.19.39c0-.2,0-.41,0-.63h0l.24.23Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3324",
    "data-name": "Path 3324",
    className: "cls-157",
    d: "M92.86,210.85l.21.18.09-.13-.26,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3325",
    "data-name": "Path 3325",
    className: "cls-158",
    d: "M57.4,178.46a.74.74,0,0,1,0-.21s.06,0,.1-.05.07.12.06.15a1,1,0,0,1-.17.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3326",
    "data-name": "Path 3326",
    className: "cls-159",
    d: "M76.55,205.63l-.69.34-.06-.23.76-.12h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3327",
    "data-name": "Path 3327",
    className: "cls-160",
    d: "M153.35,179.48l.39-.31-.14.49-.25-.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3328",
    "data-name": "Path 3328",
    className: "cls-161",
    d: "M20.73,179.8c-.09-.14-.19-.23-.17-.29s.13-.12.22-.14.13.09.13.13a2,2,0,0,1-.18.32",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3329",
    "data-name": "Path 3329",
    className: "cls-162",
    d: "M19.76,180.44l.31.31-.28.16v-.51Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3330",
    "data-name": "Path 3330",
    className: "cls-163",
    d: "M30.27,180.76l-.9,0,0,0,.94,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3331",
    "data-name": "Path 3331",
    className: "cls-164",
    d: "M26,86.89a2.93,2.93,0,0,1,.19.4,2.06,2.06,0,0,1-.26.12l-.06-.49.13,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3332",
    "data-name": "Path 3332",
    className: "cls-165",
    d: "M27.05,86.43l-.32.15a1.23,1.23,0,0,1-.12-.26s.12-.11.15-.1a1.54,1.54,0,0,1,.29.21",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3333",
    "data-name": "Path 3333",
    className: "cls-166",
    d: "M24.16,86l.43.34-.24.13-.16-.51Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3334",
    "data-name": "Path 3334",
    className: "cls-167",
    d: "M24.19,85.94l-.49-.19.18-.2.28.42,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3335",
    "data-name": "Path 3335",
    className: "cls-168",
    d: "M105.75,37.45l-.28-.4.15-.1.32.37-.2.13",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3336",
    "data-name": "Path 3336",
    className: "cls-169",
    d: "M22.46,75.35l-.32.41L22,75.69l.27-.48.18.14",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3337",
    "data-name": "Path 3337",
    className: "cls-170",
    d: "M19.58,81.89l-.47-.19.19-.19.24.42,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3338",
    "data-name": "Path 3338",
    className: "cls-171",
    d: "M116.44,199.42l.62,0v.16l-.61-.12h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3339",
    "data-name": "Path 3339",
    className: "cls-172",
    d: "M78.44,198.36c0,.31-.06.62-.1.93l0,0h-.27l0,0,.29-.89Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3340",
    "data-name": "Path 3340",
    className: "cls-173",
    d: "M204.19,106.66l-.33.34-.12-.06.26-.44.19.16",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3341",
    "data-name": "Path 3341",
    className: "cls-174",
    d: "M201.15,107.42c0,.12,0,.06,0,0h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3342",
    "data-name": "Path 3342",
    className: "cls-175",
    d: "M37.52,156.54l-.49,0v-.08l.47.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3343",
    "data-name": "Path 3343",
    className: "cls-176",
    d: "M21.87,147.13l.72-.08v.21l-.72-.14Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3344",
    "data-name": "Path 3344",
    className: "cls-177",
    d: "M39.56,49.18l-.16.12-.14-.2c.07,0,.14-.09.2-.08s.06.1.1.16",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3345",
    "data-name": "Path 3345",
    className: "cls-178",
    d: "M214.6,143.81l-.5.22,0-.06.53-.19Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3346",
    "data-name": "Path 3346",
    className: "cls-179",
    d: "M215,140.76l-.16-.13.24-.1s.06.08.09.12l-.17.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3347",
    "data-name": "Path 3347",
    className: "cls-180",
    d: "M36.17,55.34,36,54.88h0l.16.48h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3348",
    "data-name": "Path 3348",
    className: "cls-181",
    d: "M16.14,134.4l-.25.69,0,0-.28-.26,0,0,0-.22h0l.27-.27,0,0h.27Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3349",
    "data-name": "Path 3349",
    className: "cls-182",
    d: "M205.43,57.89l-.63-.08h0l.86-.14v0l-.29.26Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3350",
    "data-name": "Path 3350",
    className: "cls-183",
    d: "M195.36,108.74v.52l-.23-.05.23-.47Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3351",
    "data-name": "Path 3351",
    className: "cls-184",
    d: "M193.53,110.81l-.41-.1.2-.26.18.39Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3352",
    "data-name": "Path 3352",
    className: "cls-185",
    d: "M211.33,89.21l.67-.09,0,0c0,.13-.09.26-.14.39l-.49-.27Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3353",
    "data-name": "Path 3353",
    className: "cls-186",
    d: "M158.94,171l.15-.42.21,0-.2.42-.16-.05",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3354",
    "data-name": "Path 3354",
    className: "cls-187",
    d: "M27,99.21l-.14.31-.25-.21c.06,0,.1-.12.16-.15s.13,0,.23,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3355",
    "data-name": "Path 3355",
    className: "cls-188",
    d: "M185.93,169.37l-.15-.28.12-.05.14.28-.11.05",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3356",
    "data-name": "Path 3356",
    className: "cls-189",
    d: "M15.25,162.45l-.13.14a1.29,1.29,0,0,1-.09-.16.16.16,0,0,1,.05-.09l.17.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3357",
    "data-name": "Path 3357",
    className: "cls-190",
    d: "M200.3,162c0-.13,0-.27.07-.41l.34.16-.45.22,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3358",
    "data-name": "Path 3358",
    className: "cls-191",
    d: "M195.63,159.91l-.29.44-.22-.24.54-.17,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3359",
    "data-name": "Path 3359",
    className: "cls-192",
    d: "M25,71l-.35-.37.15-.12.34.38L25,71",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3360",
    "data-name": "Path 3360",
    className: "cls-193",
    d: "M37.07,158.65l-.34-.57.35.61Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3361",
    "data-name": "Path 3361",
    className: "cls-194",
    d: "M171.13,16.19l.69-.05,0,0-.75.11Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3362",
    "data-name": "Path 3362",
    className: "cls-195",
    d: "M139.56,15.5l-.26.42-.17-.07.22-.5.2.15",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3363",
    "data-name": "Path 3363",
    className: "cls-196",
    d: "M173.22,15l-.47.42-.09-.4.05,0h.53Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3364",
    "data-name": "Path 3364",
    className: "cls-197",
    d: "M96.68,14.91l.21.41h0l-.18-.39Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3365",
    "data-name": "Path 3365",
    className: "cls-198",
    d: "M63.64,20.05l-.1.38-.15,0,0-.39.2,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3366",
    "data-name": "Path 3366",
    className: "cls-199",
    d: "M192,31.31l-.2-.48h0c.08.16.15.33.22.5h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3367",
    "data-name": "Path 3367",
    className: "cls-200",
    d: "M115.32,29.35l-.14.21a1,1,0,0,1-.25-.16.37.37,0,0,1,.1-.17,1.78,1.78,0,0,1,.29.12",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3368",
    "data-name": "Path 3368",
    className: "cls-201",
    d: "M62.43,21.33l-.09,0,.06.07,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3369",
    "data-name": "Path 3369",
    className: "cls-202",
    d: "M131,21.64l.51-.18,0,.17H131Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3370",
    "data-name": "Path 3370",
    className: "cls-203",
    d: "M191.74,25.53l-.08.4-.13-.08.19-.28Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3371",
    "data-name": "Path 3371",
    className: "cls-204",
    d: "M161,168.3l-.23.18s-.1-.12-.09-.15a1.07,1.07,0,0,1,.18-.19l.14.16",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3372",
    "data-name": "Path 3372",
    className: "cls-205",
    d: "M195.69,108l-.05.08-.06-.14.08,0,0,.1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3373",
    "data-name": "Path 3373",
    className: "cls-206",
    d: "M186.82,167l-.26.4-.08-.06.31-.34Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3374",
    "data-name": "Path 3374",
    className: "cls-207",
    d: "M34.2,166.75s0,.07,0,.1,0,.05-.06.08l0-.17",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3375",
    "data-name": "Path 3375",
    className: "cls-208",
    d: "M33,58.6l.17.32c-.07,0-.16.07-.21,0s-.07-.12-.07-.19,0-.09.11-.17",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3376",
    "data-name": "Path 3376",
    className: "cls-209",
    d: "M185.76,169.79a.57.57,0,0,1-.18,0s-.06,0-.08-.06l.19,0s0,0,.07.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3377",
    "data-name": "Path 3377",
    className: "cls-210",
    d: "M204.15,59.21l-.45.25,0,0,.47-.24Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3378",
    "data-name": "Path 3378",
    className: "cls-211",
    d: "M157.69,173.12a1.52,1.52,0,0,1-.28.09.34.34,0,0,1-.09-.15,1.51,1.51,0,0,1,.26-.18l.11.24",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3379",
    "data-name": "Path 3379",
    className: "cls-212",
    d: "M12.13,174.93l.17.35v0h-.52l0,0,.32-.32Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3380",
    "data-name": "Path 3380",
    className: "cls-213",
    d: "M201.41,101l-.08,0V101s0,0,.07-.07V101",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3381",
    "data-name": "Path 3381",
    className: "cls-214",
    d: "M26.7,98.23l.35-.36,0,0,.28.26,0,0v.25l0,0-.6-.07v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3382",
    "data-name": "Path 3382",
    className: "cls-215",
    d: "M210.66,90c.09.06.18.11.17.13a.26.26,0,0,1-.13.16s-.11,0-.17,0l.13-.25",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3383",
    "data-name": "Path 3383",
    className: "cls-216",
    d: "M186.13,35.34v-.42h.09c0,.14-.05.28-.08.41Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3384",
    "data-name": "Path 3384",
    className: "cls-217",
    d: "M30.05,179.23l.37-.16,0,.12-.41,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3385",
    "data-name": "Path 3385",
    className: "cls-218",
    d: "M124.76,14.12v.28c-.05,0-.14,0-.14,0s0-.18,0-.28l.12,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3386",
    "data-name": "Path 3386",
    className: "cls-219",
    d: "M122,14.11l-.14.15-.12-.21s.12-.08.17-.07.06.08.09.13",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3387",
    "data-name": "Path 3387",
    className: "cls-220",
    d: "M213.68,144.83l.06.07h-.1s0-.05-.07-.07h.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3388",
    "data-name": "Path 3388",
    className: "cls-221",
    d: "M213,146.17c0,.07.06.13.05.19s-.1,0-.16.08-.06-.12-.05-.16.11-.07.17-.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3389",
    "data-name": "Path 3389",
    className: "cls-222",
    d: "M21.87,147.13l-.12-.6h.15a6.08,6.08,0,0,1,0,.61h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3390",
    "data-name": "Path 3390",
    className: "cls-223",
    d: "M214.76,138.88c0,.07-.07.16-.12.18s-.12,0-.19-.05a1.07,1.07,0,0,1,.16-.14s.09,0,.15,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3391",
    "data-name": "Path 3391",
    className: "cls-224",
    d: "M61,22.51l0,.06-.1,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3392",
    "data-name": "Path 3392",
    className: "cls-225",
    d: "M210.67,155.08l.34.14-.08.07-.23-.25,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3393",
    "data-name": "Path 3393",
    className: "cls-226",
    d: "M38.09,156l-.58.51h0l.59-.54h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3394",
    "data-name": "Path 3394",
    className: "cls-227",
    d: "M17.72,156.71l-.07-.16-.11.13.17,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3395",
    "data-name": "Path 3395",
    className: "cls-228",
    d: "M188.15,164.07v.1s-.08,0-.09-.06,0-.05,0-.08l.07,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3396",
    "data-name": "Path 3396",
    className: "cls-229",
    d: "M193.5,110.83l.07,0,0-.07,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3397",
    "data-name": "Path 3397",
    className: "cls-230",
    d: "M117.35,17.8l-.12-.45h.23l-.14.41,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3398",
    "data-name": "Path 3398",
    className: "cls-231",
    d: "M34.89,56.22a1,1,0,0,1-.13.16s-.09,0-.14,0,0-.15.07-.17a.64.64,0,0,1,.2,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3399",
    "data-name": "Path 3399",
    className: "cls-232",
    d: "M207.27,160.71c-.06-.13-.12-.26-.19-.39l.13,0c0,.14,0,.29,0,.43Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3400",
    "data-name": "Path 3400",
    className: "cls-233",
    d: "M194,160l.42.12-.22.22L194,160l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3401",
    "data-name": "Path 3401",
    className: "cls-234",
    d: "M92.88,19.5l.4,0-.13.24-.24-.25,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3402",
    "data-name": "Path 3402",
    className: "cls-235",
    d: "M118.62,34.42l.66-.07v.15l-.63-.09h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3403",
    "data-name": "Path 3403",
    className: "cls-236",
    d: "M37.14,52.41l.16.15a.65.65,0,0,1-.16.09s-.09,0-.08-.06a.51.51,0,0,1,.09-.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3404",
    "data-name": "Path 3404",
    className: "cls-237",
    d: "M186.84,30.1a1.23,1.23,0,0,1,0-.27h.06a2.44,2.44,0,0,1,0,.27h-.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3405",
    "data-name": "Path 3405",
    className: "cls-238",
    d: "M144,12.12l-.2-.12.24-.2s.11.08.1.1a1.64,1.64,0,0,1-.14.22",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3406",
    "data-name": "Path 3406",
    className: "cls-239",
    d: "M54.77,187.08c-.08,0-.17.06-.23,0s-.06-.11-.09-.17.14-.05.17,0a.8.8,0,0,1,.15.17",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3407",
    "data-name": "Path 3407",
    className: "cls-240",
    d: "M104.7,39.3a1,1,0,0,1-.23.17s-.1-.06-.15-.09l.23-.22.15.14",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3408",
    "data-name": "Path 3408",
    className: "cls-241",
    d: "M125.44,26.72a1.13,1.13,0,0,1,0-.18.2.2,0,0,1,.11,0,.68.68,0,0,1,.12.12l-.2.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3409",
    "data-name": "Path 3409",
    className: "cls-242",
    d: "M77.24,198.56l.06-.08,0,.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3410",
    "data-name": "Path 3410",
    className: "cls-243",
    d: "M127.33,11.4l-.16.15-.13-.21a.44.44,0,0,1,.19-.07s.07.08.11.13",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3411",
    "data-name": "Path 3411",
    className: "cls-244",
    d: "M195.08,69.92l-.47.13v-.16l.46,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3412",
    "data-name": "Path 3412",
    className: "cls-245",
    d: "M142.76,11h.39l0,.18-.32-.15Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3413",
    "data-name": "Path 3413",
    className: "cls-246",
    d: "M123.51,28.68c0-.07-.08-.13-.07-.17a.22.22,0,0,1,.14-.14.64.64,0,0,1,.16.06l-.23.25",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3414",
    "data-name": "Path 3414",
    className: "cls-247",
    d: "M194.92,71a.57.57,0,0,1-.1-.13.1.1,0,0,1,0-.09l.17,0-.09.19",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3415",
    "data-name": "Path 3415",
    className: "cls-248",
    d: "M106.57,35.24l-.29.12c0-.07-.08-.18-.06-.2a1,1,0,0,1,.27-.11l.08.2",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3416",
    "data-name": "Path 3416",
    className: "cls-249",
    d: "M198.59,64l.92.13h0l-.93,0,0,0V64Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3417",
    "data-name": "Path 3417",
    className: "cls-250",
    d: "M197.81,65.72l.1.17-.11,0s-.06,0-.09,0l.11-.15",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3418",
    "data-name": "Path 3418",
    className: "cls-251",
    d: "M26.27,84.9v.46h-.12V84.9h.12",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3419",
    "data-name": "Path 3419",
    className: "cls-252",
    d: "M92.64,208.25l.43.18-.11.15-.31-.32Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3420",
    "data-name": "Path 3420",
    className: "cls-253",
    d: "M178.65,182.26l.31.18c0-.09.1-.21.08-.24a1.54,1.54,0,0,0-.35-.15.16.16,0,0,0,0,.07.17.17,0,0,0,0,.1Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3421",
    "data-name": "Path 3421",
    className: "cls-254",
    d: "M118.21,26.75l0-.18a.2.2,0,0,1,.11,0l.12.12-.2.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3422",
    "data-name": "Path 3422",
    className: "cls-255",
    d: "M157.34,28.56l.08,0,0,.13a.13.13,0,0,1-.09,0s0-.06,0-.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3423",
    "data-name": "Path 3423",
    className: "cls-256",
    d: "M121,30.18a1.39,1.39,0,0,1,.19-.06s0,.05.08.08l-.2.05s0,0-.07-.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3424",
    "data-name": "Path 3424",
    className: "cls-257",
    d: "M15.55,136.74l-.21-.24v0l.2,0,0,.22Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3425",
    "data-name": "Path 3425",
    className: "cls-258",
    d: "M131,21.63l-.08.25.07-.24h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3426",
    "data-name": "Path 3426",
    className: "cls-259",
    d: "M16.62,132.16v.26h0v-.28Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3427",
    "data-name": "Path 3427",
    className: "cls-260",
    d: "M192.32,74.37a.07.07,0,0,1,0,.06l-.09,0,0-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3428",
    "data-name": "Path 3428",
    className: "cls-261",
    d: "M16.43,130.75v-.06l.08,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3429",
    "data-name": "Path 3429",
    className: "cls-262",
    d: "M162.2,24.39a.24.24,0,0,0,.09.06.31.31,0,0,0,.06-.06l-.16,0v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3430",
    "data-name": "Path 3430",
    className: "cls-263",
    d: "M24.24,84.7s-.09.1-.13.09L24,84.7s.06-.07.08-.06a.7.7,0,0,1,.19.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3431",
    "data-name": "Path 3431",
    className: "cls-264",
    d: "M23.55,106.71l.08.05,0-.13-.06.08h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3432",
    "data-name": "Path 3432",
    className: "cls-265",
    d: "M25.11,104.92v-.17l-.18,0A1,1,0,0,0,25,105s.06,0,.09,0,0-.06,0-.08l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3433",
    "data-name": "Path 3433",
    className: "cls-266",
    d: "M25.59,102.35l.27-.46,0,0-.26.46Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3434",
    "data-name": "Path 3434",
    className: "cls-267",
    d: "M200.54,100.73l-.12.1s-.06,0,0-.07a.76.76,0,0,1,.06-.16l.11.13",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    className: "cls-268",
    d: "M25.21,86.5c-.05,0-.09.09-.13.09s-.1-.06-.14-.09,0-.07.07-.07l.2.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    className: "cls-269",
    d: "M28.2,93.75l0,.17-.14,0,.13-.13Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3437",
    "data-name": "Path 3437",
    className: "cls-270",
    d: "M21.6,86.74c0,.1.07.21,0,0-.05.21,0,.11,0,0h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3438",
    "data-name": "Path 3438",
    className: "cls-271",
    d: "M20.4,116.47l.72.12h0l-.76-.14Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3439",
    "data-name": "Path 3439",
    className: "cls-272",
    d: "M20.37,116.45l.18,0v-.17l-.2.07s0,.05,0,.08h.09l-.05,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3440",
    "data-name": "Path 3440",
    className: "cls-273",
    d: "M21.11,78.41l-.11.12a.17.17,0,0,1-.1,0,.38.38,0,0,1,0-.15l.21,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3441",
    "data-name": "Path 3441",
    className: "cls-274",
    d: "M122.37,28.16l-.1.06-.06-.18s.05-.05.08-.07l.08.19",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3442",
    "data-name": "Path 3442",
    className: "cls-275",
    d: "M158.58,27.57l-.2.12.15.09.05-.16Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3443",
    "data-name": "Path 3443",
    className: "cls-276",
    d: "M207.76,107.71l0,.09-.08-.12.07-.05,0,.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3444",
    "data-name": "Path 3444",
    className: "cls-277",
    d: "M205.6,106.67s0,0,0,.07l-.09-.1.08,0,0,.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3445",
    "data-name": "Path 3445",
    className: "cls-278",
    d: "M176.93,186.48H177l0,.1Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3446",
    "data-name": "Path 3446",
    className: "cls-279",
    d: "M81.32,185.92l.09.24s-.07,0-.08-.08a1.1,1.1,0,0,1,0-.18h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3447",
    "data-name": "Path 3447",
    className: "cls-280",
    d: "M28.32,186.18l-.08,0,.09,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3448",
    "data-name": "Path 3448",
    className: "cls-281",
    d: "M29.41,185.29l-.09.17s-.06-.06-.06-.08a1.11,1.11,0,0,1,.07-.16l.08.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3449",
    "data-name": "Path 3449",
    className: "cls-282",
    d: "M29.37,180.8V181l.18,0-.19-.14h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3450",
    "data-name": "Path 3450",
    className: "cls-283",
    d: "M30.28,180.79c0-.11,0-.22,0-.08,0-.15,0-.05,0,0v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3451",
    "data-name": "Path 3451",
    className: "cls-284",
    d: "M114.44,207.2l0,.06-.08,0,0-.06.09,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3452",
    "data-name": "Path 3452",
    className: "cls-285",
    d: "M76.76,200.53l0-.08,0,.11-.09,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3453",
    "data-name": "Path 3453",
    className: "cls-286",
    d: "M52.29,199.61s-.06.07-.08.06a.7.7,0,0,1-.19-.06s0-.07.07-.07l.2.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3454",
    "data-name": "Path 3454",
    className: "cls-287",
    d: "M78.12,199.73v-.45h0v.48Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3455",
    "data-name": "Path 3455",
    className: "cls-288",
    d: "M79.42,196.71h-.29v-.11l.26.15,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3456",
    "data-name": "Path 3456",
    className: "cls-289",
    d: "M118.8,195.09l.06,0h-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3457",
    "data-name": "Path 3457",
    className: "cls-290",
    d: "M77.81,194.72l0,.1-.1-.11.07-.07.06.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3458",
    "data-name": "Path 3458",
    className: "cls-291",
    d: "M129.34,194.18l-.08,0,0-.09.12,0v.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3459",
    "data-name": "Path 3459",
    className: "cls-292",
    d: "M128.32,10.53s.06.06.06.1,0,0-.06.08,0-.06,0-.09,0-.06,0-.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3460",
    "data-name": "Path 3460",
    className: "cls-293",
    d: "M81.43,190.34l.2.08s-.06.08-.09.07a.8.8,0,0,1-.2-.07l.09-.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3461",
    "data-name": "Path 3461",
    className: "cls-294",
    d: "M80.88,190.32l0-.15-.16.08.24.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3462",
    "data-name": "Path 3462",
    className: "cls-295",
    d: "M144.78,10.87c-.05,0-.1.1-.13.1a.56.56,0,0,1-.15-.1s.05-.07.07-.07l.21.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3463",
    "data-name": "Path 3463",
    className: "cls-296",
    d: "M201.36,160.93c-.1,0-.2.1,0,0h.06l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3464",
    "data-name": "Path 3464",
    className: "cls-297",
    d: "M207.24,160.73h.09c.13.08,0,0-.06,0l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3465",
    "data-name": "Path 3465",
    className: "cls-298",
    d: "M16.07,160.23l-.05.07,0-.15,0,.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3466",
    "data-name": "Path 3466",
    className: "cls-299",
    d: "M133.14,19.87s-.08.05-.08,0l-.07-.09a.17.17,0,0,1,.1,0s0,0,0,.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3467",
    "data-name": "Path 3467",
    className: "cls-300",
    d: "M15.75,144.41l-.08-.13,0,.15.14-.05,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3468",
    "data-name": "Path 3468",
    className: "cls-301",
    d: "M214.9,141.51a.18.18,0,0,1-.1,0l0-.06.09,0,0,.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3469",
    "data-name": "Path 3469",
    className: "cls-302",
    d: "M21.69,179.11l-.14,0s0-.07,0-.09a1.13,1.13,0,0,1,.1-.13l.07.17",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3470",
    "data-name": "Path 3470",
    className: "cls-303",
    d: "M153.94,178.5a.69.69,0,0,1,.13.11.14.14,0,0,1,0,.09.43.43,0,0,1-.16,0l0-.19",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3471",
    "data-name": "Path 3471",
    className: "cls-304",
    d: "M68.09,14.73l-.08,0,.12,0,0,.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3472",
    "data-name": "Path 3472",
    className: "cls-305",
    d: "M125.35,14.34l.08.22s-.06,0-.06,0a.62.62,0,0,1,0-.19Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3473",
    "data-name": "Path 3473",
    className: "cls-306",
    d: "M142.64,15l-.08-.29.09.29h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3474",
    "data-name": "Path 3474",
    className: "cls-307",
    d: "M182.38,176.25v.05l-.07,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3475",
    "data-name": "Path 3475",
    className: "cls-308",
    d: "M182.78,175.25a.18.18,0,0,1,0,.09s0,0,0,.06v-.15",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3476",
    "data-name": "Path 3476",
    className: "cls-309",
    d: "M13,171.12l.07,0c.12.15.05.06,0,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3477",
    "data-name": "Path 3477",
    className: "cls-310",
    d: "M159,169.51c0,.05.11.09.11.13s-.07.09-.1.13-.07-.05-.07-.08a1.27,1.27,0,0,1,.06-.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3478",
    "data-name": "Path 3478",
    className: "cls-311",
    d: "M123.76,16c-.05,0-.1.09-.15.09s-.08-.07-.12-.1.06-.06.08-.06l.19.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3479",
    "data-name": "Path 3479",
    className: "cls-312",
    d: "M33.6,167.83h0c0-.14,0-.05,0,0l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3480",
    "data-name": "Path 3480",
    className: "cls-313",
    d: "M171.11,16.24l-.14-.11v.09l.16,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3481",
    "data-name": "Path 3481",
    className: "cls-314",
    d: "M187,166.72l.12-.05-.06-.07a.53.53,0,0,1,0,.12h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3482",
    "data-name": "Path 3482",
    className: "cls-315",
    d: "M17,165.72l.14.11a.17.17,0,0,1,0,.1h-.17l0-.21",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3483",
    "data-name": "Path 3483",
    className: "cls-316",
    d: "M171.23,16.79l0,.09a.39.39,0,0,1-.08-.1l.06-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3484",
    "data-name": "Path 3484",
    className: "cls-317",
    d: "M121.05,31.72l.11,0,0,.13-.1,0s0-.05,0-.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3485",
    "data-name": "Path 3485",
    className: "cls-318",
    d: "M109.55,31.89l-.13.07a.47.47,0,0,1,0-.17s0-.05.07-.07l.09.17",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3486",
    "data-name": "Path 3486",
    className: "cls-319",
    d: "M201.69,60.85l.31.06L202,61l-.23-.18,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3487",
    "data-name": "Path 3487",
    className: "cls-320",
    d: "M200.89,63.83l-.11-.11V64l.12-.12h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3488",
    "data-name": "Path 3488",
    className: "cls-321",
    d: "M109.2,31.05l-.11.11a.14.14,0,0,1-.09,0V31l.2,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3489",
    "data-name": "Path 3489",
    className: "cls-322",
    d: "M195.05,69.94l.1-.26-.08.25h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3490",
    "data-name": "Path 3490",
    className: "cls-323",
    d: "M183.75,37.46s0,0,0,.08,0,0-.05.06,0-.05,0-.07,0-.05.05-.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3491",
    "data-name": "Path 3491",
    className: "cls-324",
    d: "M109,33.62l-.09.17s-.07-.06-.06-.08a1.42,1.42,0,0,1,.08-.18l.07.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3492",
    "data-name": "Path 3492",
    className: "cls-325",
    d: "M34.63,55.26l0-.07,0,.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3493",
    "data-name": "Path 3493",
    className: "cls-326",
    d: "M33.49,55.43l0,.06,0-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3494",
    "data-name": "Path 3494",
    className: "cls-327",
    d: "M209.4,41.35l.16,0v-.1l-.13.09v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    className: "cls-328",
    d: "M45.31,41l0,.18.07-.2Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    className: "cls-329",
    d: "M111.86,32.42l-.32-.06v-.1l.32.17h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3497",
    "data-name": "Path 3497",
    className: "cls-330",
    d: "M103.23,40.68l-.07.07a.89.89,0,0,1-.08-.17l.07-.07.08.17",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    className: "cls-331",
    d: "M23.08,73.12l0,.09-.12,0a.19.19,0,0,1,0-.08.08.08,0,0,0,.06,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3499",
    "data-name": "Path 3499",
    className: "cls-332",
    d: "M191.62,30.16s0,.06,0,.06l-.09,0s0-.06,0-.06l.09,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3500",
    "data-name": "Path 3500",
    className: "cls-333",
    d: "M210.05,42.76c0-.11,0-.23.06-.32v0l-.11.36Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3501",
    "data-name": "Path 3501",
    className: "cls-334",
    d: "M182,34.83h.18l0-.09-.14,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    className: "cls-335",
    d: "M13.48,170.68l-.07,0,0-.05h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3503",
    "data-name": "Path 3503",
    className: "cls-336",
    d: "M13,171.13l-.07,0,0-.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3504",
    "data-name": "Path 3504",
    className: "cls-337",
    d: "M105.58,34.66Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3505",
    "data-name": "Path 3505",
    className: "cls-338",
    d: "M104.63,36.86l0,.07h-.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3506",
    "data-name": "Path 3506",
    className: "cls-339",
    d: "M92.65,208.26l0-.07v.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3507",
    "data-name": "Path 3507",
    className: "cls-340",
    d: "M186.79,167l.27,0-.08-.32h0l-.27,0,.09.31h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3508",
    "data-name": "Path 3508",
    className: "cls-341",
    d: "M33.94,168l.05-.06h-.12l.06.05Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3509",
    "data-name": "Path 3509",
    className: "cls-342",
    d: "M33.57,168.17l0-.34,0,0,.37.11h0l-.42.22Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3510",
    "data-name": "Path 3510",
    className: "cls-343",
    d: "M33.52,168.18v-.05l.07,0h-.05",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3511",
    "data-name": "Path 3511",
    className: "cls-344",
    d: "M210,42.74h.07l-.09,0,.05.07,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3512",
    "data-name": "Path 3512",
    className: "cls-345",
    d: "M208.65,42.85l0-.07.06,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3513",
    "data-name": "Path 3513",
    className: "cls-346",
    d: "M172.68,15a.87.87,0,0,0,.07-.17l-.08,0,.05,0v.26Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3514",
    "data-name": "Path 3514",
    className: "cls-347",
    d: "M64.75,207.26s0,.05-.08.05a.22.22,0,0,1-.06-.07s0-.05.07-.05,0,0,.07.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3515",
    "data-name": "Path 3515",
    className: "cls-348",
    d: "M96.73,14.93l-.08,0,0-.05h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3516",
    "data-name": "Path 3516",
    className: "cls-349",
    d: "M11.54,176.88l.15-.39v0l-.18.38,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3517",
    "data-name": "Path 3517",
    className: "cls-350",
    d: "M68.9,14.94l-.07,0,0-.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3518",
    "data-name": "Path 3518",
    className: "cls-351",
    d: "M140.79,14.74h-.07l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3519",
    "data-name": "Path 3519",
    className: "cls-352",
    d: "M102.91,41.49l-.15,0,0,.08.12-.09Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3520",
    "data-name": "Path 3520",
    className: "cls-353",
    d: "M182.06,34.79l0,.07-.06,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3521",
    "data-name": "Path 3521",
    className: "cls-354",
    d: "M121.25,15.6l.07,0v.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3522",
    "data-name": "Path 3522",
    className: "cls-355",
    d: "M13.24,172l-.08,0,.09,0-.06-.06h.05",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3523",
    "data-name": "Path 3523",
    className: "cls-356",
    d: "M210.11,42.43l-.06-.07.07,0v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3524",
    "data-name": "Path 3524",
    className: "cls-357",
    d: "M95.66,15.24l.06.06-.07,0v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3525",
    "data-name": "Path 3525",
    className: "cls-358",
    d: "M107.47,34.89l.08,0v.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3526",
    "data-name": "Path 3526",
    className: "cls-359",
    d: "M139.9,15.15l.08,0v.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3527",
    "data-name": "Path 3527",
    className: "cls-360",
    d: "M11.06,174.48l0-.06.07.05h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3528",
    "data-name": "Path 3528",
    className: "cls-361",
    d: "M12.14,174.94v-.48h0v.47",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3529",
    "data-name": "Path 3529",
    className: "cls-362",
    d: "M94.67,18.09v0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3530",
    "data-name": "Path 3530",
    className: "cls-363",
    d: "M201.67,43.9V44l0-.06,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3531",
    "data-name": "Path 3531",
    className: "cls-364",
    d: "M207.76,160.14l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3532",
    "data-name": "Path 3532",
    className: "cls-365",
    d: "M94.69,18.1l.37-.25,0,0-.35.22h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3533",
    "data-name": "Path 3533",
    className: "cls-366",
    d: "M189.74,160.56l.07,0v.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3534",
    "data-name": "Path 3534",
    className: "cls-367",
    d: "M206.44,160.56l.08,0v.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3535",
    "data-name": "Path 3535",
    className: "cls-368",
    d: "M16.91,160.85h0l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3536",
    "data-name": "Path 3536",
    className: "cls-369",
    d: "M208.68,44.42l-.14.08.13,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3537",
    "data-name": "Path 3537",
    className: "cls-370",
    d: "M92.9,210.88h-.08l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3538",
    "data-name": "Path 3538",
    className: "cls-371",
    d: "M18,158.45l.07.05,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3539",
    "data-name": "Path 3539",
    className: "cls-372",
    d: "M37.09,158.7l-.07,0h.06v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3540",
    "data-name": "Path 3540",
    className: "cls-373",
    d: "M194.41,159.18l0,.07h-.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3541",
    "data-name": "Path 3541",
    className: "cls-374",
    d: "M208.67,44.47l0-.06v.08l.06-.06v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3542",
    "data-name": "Path 3542",
    className: "cls-375",
    d: "M105.59,34.66h0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3543",
    "data-name": "Path 3543",
    className: "cls-376",
    d: "M197.8,162.36l.07.17-.07-.16h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3544",
    "data-name": "Path 3544",
    className: "cls-377",
    d: "M15.76,165.25c0-.15,0-.3.05-.44h0c0,.15-.07.31-.1.45Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3545",
    "data-name": "Path 3545",
    className: "cls-378",
    d: "M15.74,165.26,15.6,165l-.25.25h.41l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3546",
    "data-name": "Path 3546",
    className: "cls-379",
    d: "M92.3,209.82l0,.07,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3547",
    "data-name": "Path 3547",
    className: "cls-380",
    d: "M198.7,160.78l.09,0v.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3548",
    "data-name": "Path 3548",
    className: "cls-381",
    d: "M196.35,161.06l.07.07.05-.14-.09,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3549",
    "data-name": "Path 3549",
    className: "cls-382",
    d: "M208.87,43.85l.08,0v.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3550",
    "data-name": "Path 3550",
    className: "cls-383",
    d: "M206.58,161.14l0,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3551",
    "data-name": "Path 3551",
    className: "cls-384",
    d: "M196.37,161v.08l0-.06,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3552",
    "data-name": "Path 3552",
    className: "cls-385",
    d: "M206.55,161.12l.06.08,0-.06,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3553",
    "data-name": "Path 3553",
    className: "cls-386",
    d: "M193.67,161.65l0,.07h-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3554",
    "data-name": "Path 3554",
    className: "cls-387",
    d: "M95.07,17.85l0,.06a.05.05,0,0,1,0,0l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3555",
    "data-name": "Path 3555",
    className: "cls-388",
    d: "M207.71,162.1l0,.06h-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3556",
    "data-name": "Path 3556",
    className: "cls-389",
    d: "M65.41,203.84l0,.06h-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3557",
    "data-name": "Path 3557",
    className: "cls-390",
    d: "M142.78,11l-.07-.05,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3558",
    "data-name": "Path 3558",
    className: "cls-391",
    d: "M145.76,7.58l0-.08h.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    className: "cls-392",
    d: "M149.79,8.06l0-.05,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    className: "cls-393",
    d: "M104,35.81l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3561",
    "data-name": "Path 3561",
    className: "cls-394",
    d: "M128.15,196.94l-.08.06s-.06-.05-.06-.08.05,0,.07-.06l.07.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3562",
    "data-name": "Path 3562",
    className: "cls-395",
    d: "M78.41,198.39v-.07l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3563",
    "data-name": "Path 3563",
    className: "cls-396",
    d: "M161,8.29l0-.07,0,.08.07-.05v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3564",
    "data-name": "Path 3564",
    className: "cls-397",
    d: "M148.93,8.44l-.06,0V8.4Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3565",
    "data-name": "Path 3565",
    className: "cls-398",
    d: "M116.11,201.17l.09,0,0,.06,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3566",
    "data-name": "Path 3566",
    className: "cls-399",
    d: "M146.43,10.44l.06,0v.05Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3567",
    "data-name": "Path 3567",
    className: "cls-400",
    d: "M129.06,192.39l0,.06H129Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3568",
    "data-name": "Path 3568",
    className: "cls-401",
    d: "M52.68,193.56l-.08.05,0-.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3569",
    "data-name": "Path 3569",
    className: "cls-402",
    d: "M146,9.49l0,.06H146Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3570",
    "data-name": "Path 3570",
    className: "cls-403",
    d: "M51.61,196.4l0,.08h-.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3571",
    "data-name": "Path 3571",
    className: "cls-404",
    d: "M141.62,13.38l0,.06.11,0-.07,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3572",
    "data-name": "Path 3572",
    className: "cls-405",
    d: "M178.67,182.23v.07l0-.08-.07.05,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3573",
    "data-name": "Path 3573",
    className: "cls-406",
    d: "M102.31,40.79l-.37,0h0l.19.21.12-.14Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3574",
    "data-name": "Path 3574",
    className: "cls-407",
    d: "M179.11,182.89l0-.07,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3575",
    "data-name": "Path 3575",
    className: "cls-408",
    d: "M141.63,13.37h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3576",
    "data-name": "Path 3576",
    className: "cls-409",
    d: "M69.38,13.35v-.07l.06.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3577",
    "data-name": "Path 3577",
    className: "cls-410",
    d: "M125.29,13.13l-.08,0,0-.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3578",
    "data-name": "Path 3578",
    className: "cls-411",
    d: "M122.22,13.13l.07,0v.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3579",
    "data-name": "Path 3579",
    className: "cls-412",
    d: "M8.88,183.87l.24-.38v0l-.23.39,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3580",
    "data-name": "Path 3580",
    className: "cls-413",
    d: "M123.43,12.9l.07,0v.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3581",
    "data-name": "Path 3581",
    className: "cls-414",
    d: "M102.91,41.53l0-.05v.07l0-.06v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3582",
    "data-name": "Path 3582",
    className: "cls-415",
    d: "M173.39,14.3l.06,0h-.09l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3583",
    "data-name": "Path 3583",
    className: "cls-416",
    d: "M101.31,41.26l0,0,0-.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3584",
    "data-name": "Path 3584",
    className: "cls-417",
    d: "M125.38,14.35l-.06,0,0,0h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3585",
    "data-name": "Path 3585",
    className: "cls-418",
    d: "M174.08,14l0,.07H174Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3586",
    "data-name": "Path 3586",
    className: "cls-419",
    d: "M141.89,14h0c.13.08.06,0,0,0h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3587",
    "data-name": "Path 3587",
    className: "cls-420",
    d: "M102.28,40.82l.09.09-.06-.12,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3588",
    "data-name": "Path 3588",
    className: "cls-421",
    d: "M75.8,206.4l0-.06h.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3589",
    "data-name": "Path 3589",
    className: "cls-422",
    d: "M45.34,41l0,.06,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3590",
    "data-name": "Path 3590",
    className: "cls-423",
    d: "M140.44,13.76l0,.06h-.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3591",
    "data-name": "Path 3591",
    className: "cls-424",
    d: "M126.37,13.86l0-.06h.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    "data-name": "Path 3592",
    className: "cls-425",
    d: "M29.23,187.31l-.07,0,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3593",
    "data-name": "Path 3593",
    className: "cls-426",
    d: "M108.67,35.89l-.06,0,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3594",
    "data-name": "Path 3594",
    className: "cls-427",
    d: "M80.74,187.8l0,.17-.17-.16,0,0h.29Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3595",
    "data-name": "Path 3595",
    className: "cls-428",
    d: "M127.8,11.33l.07,0v.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3596",
    "data-name": "Path 3596",
    className: "cls-429",
    d: "M102.67,40l0,.08h-.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3597",
    "data-name": "Path 3597",
    className: "cls-430",
    d: "M148.19,7.24l0,.08h-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3598",
    "data-name": "Path 3598",
    className: "cls-431",
    d: "M200.82,63.46l-.17-.05.14.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3599",
    "data-name": "Path 3599",
    className: "cls-432",
    d: "M202.36,61.83l-.09.05.14.06,0-.09Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3600",
    "data-name": "Path 3600",
    className: "cls-433",
    d: "M28,94.7l.24,0H28Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3601",
    "data-name": "Path 3601",
    className: "cls-434",
    d: "M28,94.92V94.7h0V95Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3602",
    "data-name": "Path 3602",
    className: "cls-435",
    d: "M202.37,61.85l-.06,0h.05v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3603",
    "data-name": "Path 3603",
    className: "cls-436",
    d: "M200.87,61.79l.51,0,0-.05-.52.08h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3604",
    "data-name": "Path 3604",
    className: "cls-437",
    d: "M27.11,97.48l-.07,0,0,.11,0-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3605",
    "data-name": "Path 3605",
    className: "cls-438",
    d: "M27.12,97.49l.17.36v0H27l0,.05.06-.39h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3606",
    "data-name": "Path 3606",
    className: "cls-439",
    d: "M201.37,61.77l0-.07,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3607",
    "data-name": "Path 3607",
    className: "cls-440",
    d: "M26.77,98.57c0-.11,0-.23-.07-.34v0c0,.11,0,.22,0,.34Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3608",
    "data-name": "Path 3608",
    className: "cls-441",
    d: "M26.75,98.54l.07,0-.05,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3609",
    "data-name": "Path 3609",
    className: "cls-442",
    d: "M26.06,99.94l0-.12-.08,0,.06.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3610",
    "data-name": "Path 3610",
    className: "cls-443",
    d: "M23.62,87.13l0-.12-.06.09Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3611",
    "data-name": "Path 3611",
    className: "cls-444",
    d: "M23.59,87.1l.08,0h-.05l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3612",
    "data-name": "Path 3612",
    className: "cls-445",
    d: "M213.62,87.08l0,0,0,0v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3613",
    "data-name": "Path 3613",
    className: "cls-446",
    d: "M22.34,87.58l0,.07h-.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3614",
    "data-name": "Path 3614",
    className: "cls-447",
    d: "M116.09,31.54l-.08,0a.21.21,0,0,0,0-.06l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3615",
    "data-name": "Path 3615",
    className: "cls-448",
    d: "M200.79,63.49l.1.34h0l-.06-.38,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3616",
    "data-name": "Path 3616",
    className: "cls-449",
    d: "M119.57,31.52l.08,0v.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3617",
    "data-name": "Path 3617",
    className: "cls-450",
    d: "M191.72,25.57l-.05-.08.07,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3618",
    "data-name": "Path 3618",
    className: "cls-451",
    d: "M206.84,93.17l-.05.24.32-.11v0a2,2,0,0,1,0-.24l-.32.12v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3619",
    "data-name": "Path 3619",
    className: "cls-452",
    d: "M28.22,93.78l.32-.21,0,0v.27l0,0-.32,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3620",
    "data-name": "Path 3620",
    className: "cls-453",
    d: "M23.68,107.51v-.27h0v.29Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3621",
    "data-name": "Path 3621",
    className: "cls-454",
    d: "M119.14,32l.07.06,0-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3622",
    "data-name": "Path 3622",
    className: "cls-455",
    d: "M32.25,58.31s-.07-.05-.06-.07,0,0,.07-.06.06,0,.06.07,0,0-.07.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3623",
    "data-name": "Path 3623",
    className: "cls-456",
    d: "M204.56,108.28h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3624",
    "data-name": "Path 3624",
    className: "cls-457",
    d: "M23.2,108.6h-.39v.05l.38-.26h0v.25Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3625",
    "data-name": "Path 3625",
    className: "cls-458",
    d: "M201.27,108.51l-.07,0,.09,0-.06-.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3626",
    "data-name": "Path 3626",
    className: "cls-459",
    d: "M22.81,108.59l0,.07v-.08l-.06.06v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3627",
    "data-name": "Path 3627",
    className: "cls-460",
    d: "M199.35,109.43h-.07l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3628",
    "data-name": "Path 3628",
    className: "cls-461",
    d: "M26.07,99.91l0,.24.29-.13v0a2,2,0,0,1,0-.24l-.29.14v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3629",
    "data-name": "Path 3629",
    className: "cls-462",
    d: "M25.82,100.65l-.07,0,.09,0-.06-.07h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3630",
    "data-name": "Path 3630",
    className: "cls-463",
    d: "M32.85,60.28l-.08,0a.1.1,0,0,0,0-.05l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3631",
    "data-name": "Path 3631",
    className: "cls-464",
    d: "M60.7,25.16l.15-.18,0,.17,0,0h-.27Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3632",
    "data-name": "Path 3632",
    className: "cls-465",
    d: "M25,102.53l.07,0h0v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    "data-name": "Path 3633",
    className: "cls-466",
    d: "M198.48,103.22l0-.08,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3634",
    "data-name": "Path 3634",
    className: "cls-467",
    d: "M161.79,24.93a.55.55,0,0,0,.06-.18s0-.05-.07-.07l0,0V25Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3635",
    "data-name": "Path 3635",
    className: "cls-468",
    d: "M198.45,103.93l-.39.19,0,0,.45-.2,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3636",
    "data-name": "Path 3636",
    className: "cls-469",
    d: "M198.06,104.12a.19.19,0,0,0,0,.07l-.05,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3637",
    "data-name": "Path 3637",
    className: "cls-470",
    d: "M24,104.91l.07,0H24Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3638",
    "data-name": "Path 3638",
    className: "cls-471",
    d: "M100.08,24.86l.29.07,0,0a.14.14,0,0,1-.2,0l-.11-.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3639",
    "data-name": "Path 3639",
    className: "cls-472",
    d: "M204.33,59.35l.07.07v-.14l-.07.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    "data-name": "Path 3640",
    className: "cls-473",
    d: "M24.75,106.38l0,.07,0-.08-.07,0v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    "data-name": "Path 3641",
    className: "cls-474",
    d: "M204.41,59c0,.12,0,.25-.08.38h0l-.2-.14.05,0,.26-.22Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3642",
    "data-name": "Path 3642",
    className: "cls-475",
    d: "M23.55,107.15v-.44h0v.45Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3643",
    "data-name": "Path 3643",
    className: "cls-476",
    d: "M192,76.28l0,.08-.05,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3644",
    "data-name": "Path 3644",
    className: "cls-477",
    d: "M188.18,28.85V29l.08,0-.06-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3645",
    "data-name": "Path 3645",
    className: "cls-478",
    d: "M119.13,29.11l0-.06h.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3646",
    "data-name": "Path 3646",
    className: "cls-479",
    d: "M116,28.87l0,.09.14-.06-.09,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3647",
    "data-name": "Path 3647",
    className: "cls-480",
    d: "M188.21,28.88h-.06s0,0,0,0l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3648",
    "data-name": "Path 3648",
    className: "cls-481",
    d: "M116,28.85l0,.06,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3649",
    "data-name": "Path 3649",
    className: "cls-482",
    d: "M116.46,30.68l0-.07h.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3650",
    "data-name": "Path 3650",
    className: "cls-483",
    d: "M25.1,71.51l-.06,0,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3651",
    "data-name": "Path 3651",
    className: "cls-484",
    d: "M124.74,28.39l-.07,0v-.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3652",
    "data-name": "Path 3652",
    className: "cls-485",
    d: "M156.16,30.4v0h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3653",
    "data-name": "Path 3653",
    className: "cls-486",
    d: "M23.66,74h-.07l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3654",
    "data-name": "Path 3654",
    className: "cls-487",
    d: "M115.22,30.4a2.08,2.08,0,0,0,0-.23l.07,0a.85.85,0,0,1-.06.17Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3655",
    "data-name": "Path 3655",
    className: "cls-488",
    d: "M23.78,72.66l0-.07h.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3656",
    "data-name": "Path 3656",
    className: "cls-489",
    d: "M192.94,74.35l0,.07h-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3657",
    "data-name": "Path 3657",
    className: "cls-490",
    d: "M115.2,30.37h0l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3658",
    "data-name": "Path 3658",
    className: "cls-491",
    d: "M156.46,29.84l.06-.26,0,0v.27Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3659",
    "data-name": "Path 3659",
    className: "cls-492",
    d: "M156.52,29.58h.23l0,0h-.28Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3660",
    "data-name": "Path 3660",
    className: "cls-493",
    d: "M187.21,29.17l0,.07,0,0v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3661",
    "data-name": "Path 3661",
    className: "cls-494",
    d: "M18.11,84.77h0l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3662",
    "data-name": "Path 3662",
    className: "cls-495",
    d: "M122,30.86l-.06.07h.14l-.07-.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3663",
    "data-name": "Path 3663",
    className: "cls-496",
    d: "M114.24,26.6l.06,0v.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3664",
    "data-name": "Path 3664",
    className: "cls-497",
    d: "M18.81,86.47v0l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3665",
    "data-name": "Path 3665",
    className: "cls-498",
    d: "M20.67,86.52l-.07,0v-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3666",
    "data-name": "Path 3666",
    className: "cls-499",
    d: "M21.86,86.51l.08,0-.09,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3667",
    "data-name": "Path 3667",
    className: "cls-500",
    d: "M21.85,86.5l-.26.24h0l.27-.23h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3668",
    "data-name": "Path 3668",
    className: "cls-501",
    d: "M122,30.86h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3669",
    "data-name": "Path 3669",
    className: "cls-502",
    d: "M205.59,80.66s0,.06,0,.08v-.06l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3670",
    "data-name": "Path 3670",
    className: "cls-503",
    d: "M158.58,27.61l-.05-.07v.09l.05-.07v.05",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3671",
    "data-name": "Path 3671",
    className: "cls-504",
    d: "M124.26,27.5l-.08,0v-.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3672",
    "data-name": "Path 3672",
    className: "cls-505",
    d: "M28.14,82.43l0,.07h-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3673",
    "data-name": "Path 3673",
    className: "cls-506",
    d: "M208.8,82.52l.17.18,0-.18.05,0h-.29Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3674",
    "data-name": "Path 3674",
    className: "cls-507",
    d: "M14.22,143.29h-.08l.09.05-.05-.08,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3675",
    "data-name": "Path 3675",
    className: "cls-508",
    d: "M214.6,143.79l.06,0,0-.07,0,.06v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3676",
    "data-name": "Path 3676",
    className: "cls-509",
    d: "M117.29,33.33l-.07,0,.09,0-.06-.07h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3677",
    "data-name": "Path 3677",
    className: "cls-510",
    d: "M166.34,21l0-.05,0,.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3678",
    "data-name": "Path 3678",
    className: "cls-511",
    d: "M22.3,145.52l-.21.18h0l.17-.2h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3679",
    "data-name": "Path 3679",
    className: "cls-512",
    d: "M21.61,145.76l.49,0h0l-.46,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3680",
    "data-name": "Path 3680",
    className: "cls-513",
    d: "M21.63,145.74l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3681",
    "data-name": "Path 3681",
    className: "cls-514",
    d: "M212,148.61h.2a.16.16,0,0,0,0-.1l-.16,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3682",
    "data-name": "Path 3682",
    className: "cls-515",
    d: "M212.07,148.57l0,.06,0-.08-.07,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3683",
    "data-name": "Path 3683",
    className: "cls-516",
    d: "M20.83,149l-.06-.05,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3684",
    "data-name": "Path 3684",
    className: "cls-517",
    d: "M15.34,136.5l.18-.29,0,0-.2.34v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3685",
    "data-name": "Path 3685",
    className: "cls-518",
    d: "M114.57,32.54l.09,0,0,0h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3686",
    "data-name": "Path 3686",
    className: "cls-519",
    d: "M15.52,136.72l-.19.29h0l.22-.27h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3687",
    "data-name": "Path 3687",
    className: "cls-520",
    d: "M110.85,32.87l.07,0v0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3688",
    "data-name": "Path 3688",
    className: "cls-521",
    d: "M15.43,139.06l-.07,0,0-.05,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3689",
    "data-name": "Path 3689",
    className: "cls-522",
    d: "M203.38,48.12v0h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3690",
    "data-name": "Path 3690",
    className: "cls-523",
    d: "M118.88,32.89h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3691",
    "data-name": "Path 3691",
    className: "cls-524",
    d: "M14.2,142.39l-.07,0,.09,0-.05-.07h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3692",
    "data-name": "Path 3692",
    className: "cls-525",
    d: "M117.18,33.78l.11.2-.1-.2h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3693",
    "data-name": "Path 3693",
    className: "cls-526",
    d: "M17.71,156.7l.41,0-.05,0v.26h0l-.38-.17h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3694",
    "data-name": "Path 3694",
    className: "cls-527",
    d: "M18,157.31l0,.07-.05,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3695",
    "data-name": "Path 3695",
    className: "cls-528",
    d: "M17,157.65l-.08,0,.06,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3696",
    "data-name": "Path 3696",
    className: "cls-529",
    d: "M212,150.4l0-.1v.13Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3697",
    "data-name": "Path 3697",
    className: "cls-530",
    d: "M211.92,150.43v-.06l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698",
    "data-name": "Path 3698",
    className: "cls-531",
    d: "M212.48,151.6l.05-.16h-.16l.07.12Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    className: "cls-532",
    d: "M212.43,151.58h.07l-.08,0,.05.07,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    className: "cls-533",
    d: "M193.25,111.41a1,1,0,0,1-.05.16h.17l-.08-.13Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    "data-name": "Path 3701",
    className: "cls-534",
    d: "M35.12,55.81l0-.07h.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702",
    "data-name": "Path 3702",
    className: "cls-535",
    d: "M22,113.55a.88.88,0,0,1-.05-.15s0-.06,0-.09h0v.26Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3703",
    "data-name": "Path 3703",
    className: "cls-536",
    d: "M21.68,116.63l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3704",
    "data-name": "Path 3704",
    className: "cls-537",
    d: "M193.66,109.8l0,.07h-.07Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    "data-name": "Path 3705",
    className: "cls-538",
    d: "M119.16,32h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    "data-name": "Path 3706",
    className: "cls-539",
    d: "M205.38,56.08v.26h0v-.29Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3707",
    "data-name": "Path 3707",
    className: "cls-540",
    d: "M22.1,111.37l.26-.12-.25-.23v.36",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3708",
    "data-name": "Path 3708",
    className: "cls-541",
    d: "M193.28,111.43h-.07l.09,0-.05-.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3709",
    "data-name": "Path 3709",
    className: "cls-542",
    d: "M17.25,127.86l-.25.36v0l.24-.3Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3710",
    "data-name": "Path 3710",
    className: "cls-543",
    d: "M108.74,32.61l0,.06h-.06Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3711",
    "data-name": "Path 3711",
    className: "cls-544",
    d: "M201.75,49.68l0-.06,0,0v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3712",
    "data-name": "Path 3712",
    className: "cls-545",
    d: "M17.21,130.6l-.33-.25h0l.33.22v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3713",
    "data-name": "Path 3713",
    className: "cls-546",
    d: "M40,49.7l0-.06H40l.06,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3714",
    "data-name": "Path 3714",
    className: "cls-547",
    d: "M164.52,22.26l.06-.06,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3715",
    "data-name": "Path 3715",
    className: "cls-548",
    d: "M17,131.26l0,.07-.06,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3716",
    "data-name": "Path 3716",
    className: "cls-549",
    d: "M16.59,132.61l.05.08,0-.06,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3717",
    "data-name": "Path 3717",
    className: "cls-550",
    d: "M15.69,134.18l0,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3718",
    "data-name": "Path 3718",
    className: "cls-551",
    d: "M15.67,134.41l0-.23,0,0h.26l0,0v.26l0,0h-.26Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3719",
    "data-name": "Path 3719",
    className: "cls-552",
    d: "M15.65,134.67l0-.26h0v.27Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3720",
    "data-name": "Path 3720",
    className: "cls-553",
    d: "M15.9,135.78l.17.07-.14-.09Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3721",
    "data-name": "Path 3721",
    className: "cls-554",
    d: "M15.52,136.21l0-.07.05,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3722",
    "data-name": "Path 3722",
    className: "cls-555",
    d: "M19.56,120.07v-.24l0,0v.28Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3723",
    "data-name": "Path 3723",
    className: "cls-556",
    d: "M19.56,121v-.25h0V121Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3724",
    "data-name": "Path 3724",
    className: "cls-557",
    d: "M19.47,121.62v.06l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3725",
    "data-name": "Path 3725",
    className: "cls-558",
    d: "M19.66,122.21l-.06,0h0v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3726",
    "data-name": "Path 3726",
    className: "cls-559",
    d: "M18,124.33h0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3727",
    "data-name": "Path 3727",
    className: "cls-560",
    d: "M18,124.55v-.22l.06,0v.27Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3728",
    "data-name": "Path 3728",
    className: "cls-561",
    d: "M17.62,127.25V127h0v.28Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3729",
    "data-name": "Path 3729",
    className: "cls-562",
    d: "M17.23,127.9v-.07l0,.09.07,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3730",
    "data-name": "Path 3730",
    className: "cls-563",
    d: "M116.81,32.29l.52.49-.52-.49",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3731",
    "data-name": "Path 3731",
    className: "cls-564",
    d: "M93.82,210.3v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3732",
    "data-name": "Path 3732",
    className: "cls-565",
    d: "M20.64,119l.3,0v.08l-.27-.08,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3733",
    "data-name": "Path 3733",
    className: "cls-566",
    d: "M16.61,139.18l-.13.1a.45.45,0,0,1-.07-.18c0-.06.08-.07.12-.1l.08.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3734",
    "data-name": "Path 3734",
    className: "cls-567",
    d: "M204.64,95.64c-.06-.11-.11-.22,0,0v.06l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3735",
    "data-name": "Path 3735",
    className: "cls-568",
    d: "M60.76,25.41l-.29.11,0-.17.3.08,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3736",
    "data-name": "Path 3736",
    className: "cls-569",
    d: "M21.61,118.17a.48.48,0,0,1-.2.07s-.08-.08-.12-.12a.68.68,0,0,1,.2-.07s.08.08.12.12",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3737",
    "data-name": "Path 3737",
    className: "cls-570",
    d: "M23.16,108.63v-.26l.53.07,0,0-.56.22",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3738",
    "data-name": "Path 3738",
    className: "cls-571",
    d: "M19,181.94l-.07.18c-.05,0-.12-.07-.12-.11s0-.11.06-.17l.13.1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3739",
    "data-name": "Path 3739",
    className: "cls-572",
    d: "M78.1,199.74v-.48h.27l-.26.48",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3740",
    "data-name": "Path 3740",
    className: "cls-573",
    d: "M116.26,198.05a.19.19,0,0,0,0,.08l-.11,0v-.08a.17.17,0,0,0,.08,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3741",
    "data-name": "Path 3741",
    className: "cls-574",
    d: "M59.92,176l.22.24-.07.05-.19-.31Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3742",
    "data-name": "Path 3742",
    className: "cls-575",
    d: "M116.46,34.25l-.17,0v.08l.16-.09v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3743",
    "data-name": "Path 3743",
    className: "cls-576",
    d: "M194.21,71.48l-.31,0v0l.31,0h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3744",
    "data-name": "Path 3744",
    className: "cls-577",
    d: "M162.63,166v0l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3745",
    "data-name": "Path 3745",
    className: "cls-578",
    d: "M101.06,43.34l-.14-.18.24.09-.1.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3746",
    "data-name": "Path 3746",
    className: "cls-579",
    d: "M59.88,175.93h.06l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3747",
    "data-name": "Path 3747",
    className: "cls-580",
    d: "M181.63,176l0,0-.06.05h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3748",
    "data-name": "Path 3748",
    className: "cls-581",
    d: "M121,18l0,.07.08-.06-.08,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3749",
    "data-name": "Path 3749",
    className: "cls-582",
    d: "M101.46,44.54l.25,0a.2.2,0,0,1,0,.06l-.21,0h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3750",
    "data-name": "Path 3750",
    className: "cls-583",
    d: "M19.91,158.92,20,159s-.06.07-.09.07,0,0-.08-.07l.09-.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3751",
    "data-name": "Path 3751",
    className: "cls-584",
    d: "M66.81,17.09h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3752",
    "data-name": "Path 3752",
    className: "cls-585",
    d: "M139.57,16.82l.18.12-.15-.15,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3753",
    "data-name": "Path 3753",
    className: "cls-586",
    d: "M18.21,163.86s.07.06.07.08-.05.05-.07.08-.07-.06-.07-.09.05,0,.07-.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    className: "cls-587",
    d: "M121,17.92l-.23,0,.18.08,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    className: "cls-588",
    d: "M17.09,161.81l.21.07-.18-.1,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756",
    "data-name": "Path 3756",
    className: "cls-589",
    d: "M139.77,17.62s-.06.06-.08.06-.07-.05-.07-.07,0-.05.08-.07l.07.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    "data-name": "Path 3757",
    className: "cls-590",
    d: "M78.51,191.94a1.42,1.42,0,0,1-.08-.18l.06,0V192l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    "data-name": "Path 3758",
    className: "cls-591",
    d: "M186,37l.18,0-.09.1-.07-.17Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    "data-name": "Path 3759",
    className: "cls-592",
    d: "M114.9,202.4h-.08l.05,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    "data-name": "Path 3760",
    className: "cls-593",
    d: "M93.23,206h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    "data-name": "Path 3761",
    className: "cls-594",
    d: "M150.35,178.67l.08.08s-.06.06-.08.06-.06,0-.08-.07l.08-.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762",
    "data-name": "Path 3762",
    className: "cls-595",
    d: "M86.73,6.73l0,.07-.05,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    "data-name": "Path 3763",
    className: "cls-596",
    d: "M39.91,187.73h-.09l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    className: "cls-597",
    d: "M80.78,187.85H80.5l.16-.25.12.25",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    "data-name": "Path 3765",
    className: "cls-598",
    d: "M93.72,205.16l.09.07s-.06.07-.09.07-.06-.05-.08-.08l.08-.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    "data-name": "Path 3766",
    className: "cls-599",
    d: "M89.67,205.84l-.11-.21.18.14Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3767",
    "data-name": "Path 3767",
    className: "cls-600",
    d: "M27,97.83h.28v.26L27,97.83",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768",
    "data-name": "Path 3768",
    className: "cls-601",
    d: "M102.59,26.07l-.25.11.15-.21.1.1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769",
    "data-name": "Path 3769",
    className: "cls-602",
    d: "M29.73,64.73l.07,0,0,.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770",
    "data-name": "Path 3770",
    className: "cls-603",
    d: "M28.61,87.65h-.23l.05-.11.18.12h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771",
    "data-name": "Path 3771",
    className: "cls-604",
    d: "M29.7,89.33l.26-.25-.26.25",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3772",
    "data-name": "Path 3772",
    className: "cls-605",
    d: "M161.07,25.61h.08l-.05,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3773",
    "data-name": "Path 3773",
    className: "cls-606",
    d: "M30,91.32l-.21-.12.08-.07.11.22,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3774",
    "data-name": "Path 3774",
    className: "cls-607",
    d: "M208.2,91.87l-.09-.23h.09c0,.07,0,.14,0,.21h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3775",
    "data-name": "Path 3775",
    className: "cls-608",
    d: "M161.55,25.41l.07-.05-.05,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3776",
    "data-name": "Path 3776",
    className: "cls-609",
    d: "M23.65,107.53v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3777",
    "data-name": "Path 3777",
    className: "cls-610",
    d: "M23.64,107.73l.2.06-.1.1-.08-.19Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3778",
    "data-name": "Path 3778",
    className: "cls-611",
    d: "M23.69,108.44l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    "data-name": "Path 3779",
    className: "cls-612",
    d: "M200.13,109.24l.11.21-.23-.1.12-.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3780",
    "data-name": "Path 3780",
    className: "cls-613",
    d: "M100.19,24.93a.14.14,0,0,0,.2,0l-.2,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3781",
    "data-name": "Path 3781",
    className: "cls-614",
    d: "M161.82,24.93v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3782",
    "data-name": "Path 3782",
    className: "cls-615",
    d: "M88.39,103s-.07,0-.07-.07a.1.1,0,0,1,.08-.07s0,.05.07.08l-.08.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3783",
    "data-name": "Path 3783",
    className: "cls-616",
    d: "M195.47,76.29l-.08.17-.08-.11.18,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3784",
    "data-name": "Path 3784",
    className: "cls-617",
    d: "M22.89,77.76l-.08.07s-.08-.06-.07-.08.05,0,.08-.07l.07.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3785",
    "data-name": "Path 3785",
    className: "cls-618",
    d: "M203.22,78.94l0,.09,0-.06v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3786",
    "data-name": "Path 3786",
    className: "cls-619",
    d: "M24.46,74.65h.09l-.06,0Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3787",
    "data-name": "Path 3787",
    className: "cls-620",
    d: "M24.49,74.62l0,.06-.05,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3788",
    "data-name": "Path 3788",
    className: "cls-621",
    d: "M156.5,29.59h.28l-.28.27v-.27",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3789",
    "data-name": "Path 3789",
    className: "cls-622",
    d: "M196,29.34l0,.08,0-.06v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3790",
    "data-name": "Path 3790",
    className: "cls-623",
    d: "M28.21,71.7l-.09.07s-.07,0-.07-.08.05,0,.08-.07l.08.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3791",
    "data-name": "Path 3791",
    className: "cls-624",
    d: "M208.76,82.57H209l-.08.17-.2-.17",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3792",
    "data-name": "Path 3792",
    className: "cls-625",
    d: "M102.69,26.34l0,.07,0-.05,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3793",
    "data-name": "Path 3793",
    className: "cls-626",
    d: "M57.2,28.4l-.07,0,0,0h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3794",
    "data-name": "Path 3794",
    className: "cls-627",
    d: "M26.5,80.67s-.06.08-.09.07-.05,0-.08-.07.06-.07.09-.07,0,.05.08.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    "data-name": "Path 3795",
    className: "cls-628",
    d: "M63.33,21.28l-.07.08.1-.05,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3796",
    "data-name": "Path 3796",
    className: "cls-629",
    d: "M22.38,145.68h.2l0,.11-.12-.15,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    className: "cls-630",
    d: "M204.36,46.57v.06l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    "data-name": "Path 3798",
    className: "cls-631",
    d: "M182.13,147.33s-.06.06-.09.06,0,0-.07-.07.05-.07.08-.07,0,.05.08.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    className: "cls-632",
    d: "M22,148.13l-.23-.13.23-.14v.27",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    "data-name": "Path 3800",
    className: "cls-633",
    d: "M22,148.35v-.26l.18.18-.19.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    className: "cls-634",
    d: "M201.88,48.66s-.07,0-.07-.08.05,0,.08-.07.08.06.07.08-.05,0-.08.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    className: "cls-635",
    d: "M14.68,142.55l.06,0h0l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    className: "cls-636",
    d: "M19.65,157.22h-.23l0-.11.18.13h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804",
    "data-name": "Path 3804",
    className: "cls-637",
    d: "M21.74,149.47l-.29-.26.29.26",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    className: "cls-638",
    d: "M61.28,23.17l0,.07h-.08Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    "data-name": "Path 3806",
    className: "cls-639",
    d: "M198.57,32.07v.06l0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3807",
    "data-name": "Path 3807",
    className: "cls-640",
    d: "M24.25,109.92l-.08-.08s.06-.07.09-.07.06,0,.08.08l-.09.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3808",
    "data-name": "Path 3808",
    className: "cls-641",
    d: "M205.16,110.17l-.18-.07.1-.07,0,.17Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3809",
    "data-name": "Path 3809",
    className: "cls-642",
    d: "M197.41,110.65h.23l0,0h-.28Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3810",
    "data-name": "Path 3810",
    className: "cls-643",
    d: "M197.63,110.65h.26l-.25.22,0,0v-.26Z",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3811",
    "data-name": "Path 3811",
    className: "cls-644",
    d: "M205.41,56.07v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3812",
    "data-name": "Path 3812",
    className: "cls-645",
    d: "M18.31,127.93l.29-.26-.29.26",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3813",
    "data-name": "Path 3813",
    className: "cls-646",
    d: "M17.78,130.91V131l-.07,0v-.12l.07,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3814",
    "data-name": "Path 3814",
    className: "cls-647",
    d: "M15.9,134.43v-.25l.27.25H15.9",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3815",
    "data-name": "Path 3815",
    className: "cls-648",
    d: "M95.34,21.66l.14.08-.13-.06h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    "data-name": "Path 3816",
    className: "cls-649",
    d: "M93.07,21.78l0,0,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    "data-name": "Path 3817",
    className: "cls-650",
    d: "M19.53,121v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3818",
    "data-name": "Path 3818",
    className: "cls-651",
    d: "M96.89,22.89l0,.06,0,0,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3819",
    "data-name": "Path 3819",
    className: "cls-652",
    d: "M18.58,125.93l0-.1-.06.07,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    className: "cls-653",
    d: "M19.14,126.26l-.28,0,.22-.1,0,0a.64.64,0,0,0,.06.18l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3821",
    "data-name": "Path 3821",
    className: "cls-654",
    d: "M134.62,22.25s.07.06.07.08-.05.05-.08.07-.07,0-.07-.08.05-.05.08-.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    className: "cls-655",
    d: "M15.31,167.51l-.11-.72.45.08c-.13.21-.25.41-.37.63l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    className: "cls-656",
    d: "M15.38,166.41l-.08.07s-.07-.06-.07-.08,0-.05.08-.07l.07.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    className: "cls-657",
    d: "M15.07,168.35l.08.07s-.06.07-.09.07-.05-.05-.08-.07l.09-.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    "data-name": "Path 3825",
    className: "cls-658",
    d: "M11.46,179.43l-.63-.32.22-.26.39.58h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3826",
    "data-name": "Path 3826",
    className: "cls-659",
    d: "M13,175.61l-.08.07s-.07-.05-.07-.08,0,0,.08-.07l.07.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3827",
    "data-name": "Path 3827",
    className: "cls-660",
    d: "M16.1,163.62l.22,0-.18-.08,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3828",
    "data-name": "Path 3828",
    className: "cls-661",
    d: "M16.59,164.16l-.08.08s-.07-.05-.07-.08a.29.29,0,0,1,.08-.07l.08.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3829",
    "data-name": "Path 3829",
    className: "cls-662",
    d: "M20.77,149.93l-.28-.5.28.5",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3830",
    "data-name": "Path 3830",
    className: "cls-663",
    d: "M20.74,150.15v-.27l.18.18-.18.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3831",
    "data-name": "Path 3831",
    className: "cls-664",
    d: "M117.87,32.44l0-.06h0l.07,0h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3832",
    "data-name": "Path 3832",
    className: "cls-665",
    d: "M177.76,185l-.16-.12.07,0,.06.08h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3833",
    "data-name": "Path 3833",
    className: "cls-666",
    d: "M28.5,93.82v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3834",
    "data-name": "Path 3834",
    className: "cls-667",
    d: "M28.82,93.85h0c.14.08.06,0,0,0h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3835",
    "data-name": "Path 3835",
    className: "cls-668",
    d: "M16.65,132.15h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3836",
    "data-name": "Path 3836",
    className: "cls-669",
    d: "M205.38,57.92l.28-.27-.28.27",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3837",
    "data-name": "Path 3837",
    className: "cls-670",
    d: "M19.53,120.09v0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3838",
    "data-name": "Path 3838",
    className: "cls-671",
    d: "M17.58,127.26V127h.54l-.54.26",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3839",
    "data-name": "Path 3839",
    className: "cls-672",
    d: "M22.28,111l0-.09.05.06,0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3840",
    "data-name": "Path 3840",
    className: "cls-673",
    d: "M187.6,34.48l-.21-.06.21.07h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3841",
    "data-name": "Path 3841",
    className: "cls-674",
    d: "M15.65,134.85l.28.26-.28-.26",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3842",
    "data-name": "Path 3842",
    className: "cls-675",
    d: "M18.07,124.57v-.27h.29l-.28.27",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3843",
    "data-name": "Path 3843",
    className: "cls-676",
    d: "M172.71,15.05v-.26l.53.26h-.53",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3844",
    "data-name": "Path 3844",
    className: "cls-677",
    d: "M15.66,134.68v-.28h.27l-.27.27",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3845",
    "data-name": "Path 3845",
    className: "cls-678",
    d: "M197.67,110.62v.26l-.27-.25h.27",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3846",
    "data-name": "Path 3846",
    className: "cls-679",
    d: "M27.79,96.5c-.61-.63-.12-1.09.24-1.57l0,0,.26,0c-.38,1-.17,1.29,1.22,1.22l-1.24-1.21,0-.25h0L29,94.3l-.06,0,.2,1.08.57-1.08,0,0a4,4,0,0,0,.79-2.69c0-.09-.37-.16-.56-.24l-.11-.21-.07.06.2.13-.63,1.19-.58-.38.95-1.38,1-.1.28.88c.17-.52.25-.75.33-1v-.48l-.19,0,.21.45-.65.13-.95-1.37,0,0L30,89.1l0,0,.79.46-.45-3.37-.31-.1-.46,1.26c-.74,0-.4,2.06-1.89,1.43l-.91-1.18h0A4.1,4.1,0,0,0,28,84.41l0,0,.76.33V82.62l1.22.21L29.3,81.5l0,0c.19-.2-.11-1.14.7-.39a1.76,1.76,0,0,0,.24-.3L31,79.48a.32.32,0,0,1,.19,0l.57.6.2-.28-.8-.29-.13-.2v.23L30.33,79l1.11-.91-.05,0L32,78l.45.07v-.17L32,78c.3-.82-.42-.7-.88-.82l.05,0-.14-.67h-.23l-.15.67,0,0L29.34,78l-.19-.67-.31,0c.06.31.11.61.18.91s.12.51.19.76l0,0-.63-.07h0c0-.19,0-.53-.07-.54a4.2,4.2,0,0,0-1.58,0c-.19.06-.24.75-.18,1.14.09.56.75,1.06-.14,1.65-.29.2-.13,1-.16,1.34l-1.61-2.72,1-.82-.29-.63.4-.12-.14-.13-.23.27c-.72-.61-.72-.61-.14-2.42-.7.11-1.13,1.23-.81,2.13l0,0c-.58,0-.79.17-.82.77a19.47,19.47,0,0,1-.54,2.63l-.63-.19,1.08-1.92c-1.77-.09-1.33,1.4-2,2a3.24,3.24,0,0,0-.81,1.5,13.94,13.94,0,0,0-.27,2l.05,0-1.07-.11c0-.14,0-.28,0-.42l-.18,0,.17.36-.92,1.81,0,0c-.27-.55-1.07-.9-.74-1.68l0,0c1.49-.39.2-1.45.78-2.4l.63,1.06L20.3,83l-.74-1.06,0,0,.67-1.38-.31-.15.7-.1-.37-.58c.1-.1.14-.17.19-.18,1.26-.2,1.5-.74,1-2-.09-.23.13-.8.3-.83,1.21-.23,1.21-1.18,1.5-2a5.74,5.74,0,0,1,.4-.78l0,0a11.72,11.72,0,0,0,.95-1.16,8.28,8.28,0,0,0,.57-1.29l0,0c.35-.32,1-.61,1-.93s-.48-.79-.79-1.26l.49-.4.89.91.44,0,.72-2.33a.5.5,0,0,1,.15-.17l.72-.57-.87-.55,1.14-2.71v1.21l.82,0,0-.06-.07,0a6.31,6.31,0,0,0,.91-.88c.41-.63.74-1.3,1.09-2l0,0,1.17-1.65,0,0a2,2,0,0,0,1-2.19c-.19-.6.07-.63.53-.59l0,0-.07.63.25.06.34-.7,0,0,1.39-2.13h0l.75-.53-.18-1.12.32.75,2-2.54-1.42-.16,0-.36,1.51.12,2.19-2.58c.57-.68.22-1.08-.51-1.36.63-.85.94-.08,1.34.2,0,0,.16,0,.2-.07s0-.13,0-.2h0a16.42,16.42,0,0,0,1.35-1.76c.14-.22-.09-.63-.17-1l1.16-.35c-.49-.76-.48-1.4.31-1.91v1.43c.84-.7.48-1.09.07-1.48l.56-1.12.22.07-.12,1.44a1.41,1.41,0,0,0,.66-1.89,1.6,1.6,0,0,0-.21-.32c-.1-.12,0-.4,0-.6l.24.11-.13-.21c.45-1.31,1.26.12,1.92-.24a1.62,1.62,0,0,1-.27-2.21h0l-.06,0c.45-.39,1.33-.44,1.13-1.33,0-.09.39-.22.55-.38a6.21,6.21,0,0,0,.61-.73c0-.05,0-.18,0-.2,1.37-.63,1.31-2.2,2.33-3.08h0c.24,0,.63.14.68.07.46-.74.87-1.51,1.46-2.59l.44,2-.47,0,.43.77c.31-.72,1.17-1.07.5-1.84l.06,0-.08,0,.41-1.67c-.1.63.2.69.72.44,0,.34,0,.67,0,1l-.57,0,.09.27.46-.32c.09-.51,1.11-.83.33-1.51l0,0,.07,0-.35.63-.73-.43,1.28-1,.2.5a.16.16,0,0,0-.09,0,.08.08,0,0,1,0,.06l.1-.12.47.57.69-.85-1-1.51v.05l2-.23a.17.17,0,0,0,0,.14l-.63.17.32.63-.61.16-.14-.32-.08,0,.07-.11a.16.16,0,0,1,0,.07l.15.31.56-.15.45-.68.56-.18L59.76,26l-.4-1.52,1.18.34h0l.15.36,0,0,.13.32-.29-.09,0,.17.29-.12.18-.28,0,0c.63-.31.67-.69.44-1.32a5.71,5.71,0,0,1,0-1.89l.81,1.15,0,0,.51-.15L63,23l.31-.55L63,22.4V23L62.55,23l-.17-1.17,0,0,.52,0,0,.2.14-.08-.18-.1-.5-.25,0,0a.78.78,0,0,1,0-.21l0,0,.7-.32.27.29-.09.06.06-.08.82.43.13-1.29.18.13-.13-.17.27-.91-1.08.12,2-1.71c0,.28,0,.67.07,1.06l-.35-.1-.08-.18-.1.1.2.06v.25a.19.19,0,0,0-.1,0,.1.1,0,0,1,0,.06l.09-.12.34-.12c.65.57,1-.08,1.22-.39.13-.15-.15-.63-.28-.94a2.21,2.21,0,0,1-.29-1.15l.59.61h0c.24-.44.52-.86.72-1.31.31-.71.7-.8,1.24-.19l-.82-.11.34.79-.34.13c-.59.53-.59.53.31.84l-.31-.87.36-.11.46-.69.15-.63,0,0c.83.43.71-.33,1-.65h0a.58.58,0,0,0-.15-.81.52.52,0,0,0-.26-.1h0l.63-.52.83,1c.25-.5.41-.85.58-1.19a.71.71,0,0,1,0-.21l-.12,0,.12.17a6.59,6.59,0,0,1-1-.4c-.1,0-.06-.31-.08-.47l.43.13-.24,0,0,.13.12-.15,2-2.57-.4,1.77.2.06.28-.6L74,11a9.84,9.84,0,0,0-.22-1.08c-.14-.34-.3-.67-.47-1l.94-.18,0,.18.11-.06-.18-.09a2.87,2.87,0,0,1,2-2.9l.52.83a6.35,6.35,0,0,0,.38-.84,3.35,3.35,0,0,0,.05-.63c-.21.12-.43.22-.63.36a2.42,2.42,0,0,0-.33.31,13.34,13.34,0,0,1,1-1.85c.22-.28.19-1.1,1-.7l.54-1.14,1.33.53-.2,0,.09.12L80,2.68c2.1-.09,3,1.42,4.2,2.63,1.18-.25,1.53,1.08,2.48,1.46l.05,0,0-.07c.58.45,1.14.92,1.74,1.35,1.5,1.09,3,2.16,4.54,3.24a28.12,28.12,0,0,1,2.43,1.79c.65.59.48,1.39.22,2.13v0l-.54-.08-.05.74-.57.38.35.21.19-.63.21.89c-1.78,0-2,.12-2.65,1.77a11.35,11.35,0,0,0-3.36,4.59.65.65,0,0,0,.06.21c-1.07-.14-1.32.7-1.32,1.26C88,25,87.84,26,89,26c-.57-1.49-.57-1.49-.22-2,.43.52.69.51.72-.2l.17-.09-.12-.06,0,.17-.24-.44L90.62,22l.68.28a2.87,2.87,0,0,1,0-1c.42-.9.92-1.78,1.39-2.66l.18.82,0,0c-.15,0-.41.06-.42.11-.14.73-.24,1.46-.35,2.21,0,.43-.1.85-.16,1.26l-.53-.23,0,.48L92,23l1-.46-.81-.8,1,.06,0,0,0,0,2.28-.1.13.06-.14-.08,1.53,1.26,0,0,0-.06,3.18,2,.11.08.2,0,0,0,2.12,1-.15.21.25-.11c0,.09.05.19.08.29l0,.05,0-.08a8.2,8.2,0,0,0,.78.4,4.17,4.17,0,0,1,.78.25c.38.24.89.86,1,.78A8.84,8.84,0,0,0,107,26.5a25.9,25.9,0,0,0,3.73-3.21,20.56,20.56,0,0,1,2-2l2.41-2.26.61,2,.36-2.69.34,1.58c.68-1.08.57-1.44-.36-1.56l.1-.55,1.18-.08,0,0v1.89l.2.16.42-.62h0l2.71-2.06c.11-.08.27-.27.31-.25,1.14.63,1.41-.32,1.88-1,.65,1.06-.53,1.34-.7,2l-.63-.5c-.31.81-.12,2-1.57,1.71l-.25-.24-.18-.11.22.07.21.28c-.65,1.75-2.31,2.73-3.55,4s-2.39,2.19-3.56,3.32c-1.66,1.59-3.3,3.21-4.9,4.84-.26.27-.28.73-.43,1.09-.07.19-.12.47-.27.53a7.41,7.41,0,0,0-4.48,4.41h-1l.78,2.1-.58.4q-.25-.41-.51-.78l-.85,1.46.37.16a2.61,2.61,0,0,1,.39-.69c.13-.13.41-.12.63-.17a2,2,0,0,0-.35.59c0,.09.21.23.33.35h0l-.63.5h0c-.63.41-.63.41.22.83l-.82.36,1.72.72a11.78,11.78,0,0,1,2.34-2.39c1.13-.65.56-1.64,1.1-2.35.48.17,1.39-.63,1.52-1.4,0-.2.24-.37.36-.56l-.1.42h.18l-.09-.42.93-.58,0,0,.11-.64a11.06,11.06,0,0,0,3.1-2.8h0l.86-.35-.25-1,.27-.1.73,1.4L113,33l-1-.15.75,1.27.4-.06-.13-1.1,1,.48,0,0-.27,1.54-.78.13-.19-.42,0,0,.07,0,.17.39.63.72.24-.75c.52,0,1.92-1.13,1.89-1.54,0,0-.18-.06-.27-.1l.05,0c.83-.45.76-1.18.68-1.92l0,0,.74.35,0,0-.49.18.49.31,0,0,.52.48,0,0c-.53.25-.91.56-.52,1.17,0,0-.21.2-.33.32l-.16.09v-.09l.17,0,.76,1.29.28-.11c-.5-.52,1.14-1.23-.32-1.65h0l.12-.45,0,0c1.12.73,1.3.68,1.64-.42h0l-.26,1.53h0l-.21.72-.8-.39.65,1.91c1-1.34,1.81-2.42,2.71-3.42.71-.8,1.59-1.46,2.36-2.2,2-1.94,3.92-3.9,5.9-5.83,1.37-1.34,2.84-2.59,4.15-4a30.14,30.14,0,0,1,3-2.72c.5-.39.77-1.2,1.52-1.54l.13.7-.15.12.2.12.16.16.08-.16.57.86c0-1,0-1.69-1-1.78l.59-.68,1.1.45.15.15-.18-.12.63-1h0l.51,1.18,1.94-2h0c1.28-.51.32-1.58.73-2.65a3.4,3.4,0,0,0,.28,1.05.86.86,0,0,0,.63.24c.31-.37.58-.8.88-1.19a3.12,3.12,0,0,1,.46-.43c1.36-1.13,2.73-2.25,4.08-3.4.11-.1.06-.36.09-.54l0,0a4.58,4.58,0,0,0,1-.46c1.29-1,2.52-2.14,3.83-3.17a1,1,0,0,1,.91,0c.92.71,1.73,1.53,2.67,2.21s1.84,1.15,2.76,1.71l0,0,.45,1.95A4.85,4.85,0,0,0,158.19,13l.05,0-.86-.16.11,1.41,1-.36,0,0a4,4,0,0,0,2.41-2.71l.76.42a5.36,5.36,0,0,1,.7-.73c1.07-.79,1.43-.71,2.41.22a25.19,25.19,0,0,0,2.62,2.11c.6.42.69.82.22,1.28-.77.78-1.67,1.47-2.4,2.28-2.21,2.42-4.38,4.88-6.55,7.34-1,1.17-2.05,2.34-3,3.55-1.69,2.06-3.32,4.15-5,6.19-.63.77-1.37,1.45-1,2.52-.88-.45-1,.18-1.29.63l.91.32.06.07-.05-.1.47.23-.11-1.17.54.13-.13-1c1.1.17,2,0,1.65-1.35l.07,0h-.1l2.31-2.32,1.43.4c.14-.58.23-1,.32-1.42l.71.07-.18-.45h0l.3-.56,0,0,.28-.26,0,0,.54.1,0,0-.24.53.28.1.44-1.09,0,0,1.57-.81-.15-1.33.34,0,.21.88c.84-.59.81-.59.9-1.62,0-.24.34-.46.53-.7l.05,0h-.07l.49-.23h.06l-.08.05.24-.49h0v-.28l-.05,0,.43-.29v0c.84.88,1.12.84,1.57-.19l.18-.1-.15-.06v.19s0-.1,0-.11L163.5,24l1-1.7,0,0v1.37l-.19,0,0,.14.14-.14a1.66,1.66,0,0,0,.45-.25,21.45,21.45,0,0,0,1.46-1.7c.1-.14-.06-.43-.1-.66h0l.54-.86.46.8.65-.87c0,.15-.07.3-.11.45h.18l-.09-.44.18-1.16-.87.29.05-.32,1.78.38c.52-.36,1.09-.83.48-1.73.54-.37.54-.37,1.27.74l1-2.15h0l.89.63-.13-.82c1.46-.32,1.86-1.42,2.23-2.55v0l.71.46V12.29l.09.52.63.38.1-.28-.75-.08c.27-.11.58-.38.79-.31.71.19.74-.27.87-.66.17.05.34.12.63.23l-.23-.55-.4.35.31-1.08,0,0h.32l0,0,.25-.14-.25-.13,0,0v-.33l0,0a1.66,1.66,0,0,0,1.72.4c.32-.11.77.13,1.15.21v0H181v0c.87.63,1.74,1.26,2.6,1.92.29.21.56.46.84.7.06,0,.11,0,0,0h0a5.36,5.36,0,0,0,2.62,1.89l-.07,0,.05-.07.45.45h.32L189,16.89l-.2,0,0,.06.08-.18a10.5,10.5,0,0,1,3,1.93,2.1,2.1,0,0,0,2,1.13c1.15-.13,1.3,1.56.18,2.52s-1.83,1.83-2.92,2.62a41.92,41.92,0,0,0-3.64,3.15c-.24.22-.25.66-.37,1l0,0a3.76,3.76,0,0,0-1.24.44q-2.27,1.95-4.43,4a3.11,3.11,0,0,0-.63,1.12c-.19.48-.32,1-.47,1.47l-.41.19,3.62,2.92L186,37l.06.17.1-.1L186,37c1-.85,2-1.67,2.89-2.53.19-.17.2-.52.27-.72l1.74-1.07-.51-1.34.15-.07L191,32l1-.65h0l.53-.78,0,0a4,4,0,0,0,.82-.66,1.89,1.89,0,0,1,2.61-.56l0,.06,0-.08,2.58,2.76,0,0v0l2,1.3-.05.05.15.24.13-.24,0,0c.35.36.68.73,1,1.09s.68.48.65.69c-.1,1,.6.84,1.2.92l-.13.23.25-.12,1.37,1.06,0,0v.29l0,0,.27.26,0,0h.29l0,0c0,.38.1.86-.11,1.12-.74.93-1.62,1.76-2.41,2.66-.52.6-1.14,1.19-.94,2.09,0,.08-.32.21-.5.32l0,0,.14-.78-.26-.09-1.3,1.86-.32-.14.41,1.3A14.89,14.89,0,0,0,204,42.42c.07-.13.28-.19.4-.32.63-.67,1.3-1.32,1.86-2.05.44-.57,1-1.19,1.67-.88s1,1,1.41,1.53c.12.15.07.42.1.63v0l-.63.65.12.1-.83.5.57.22,0,0a10.92,10.92,0,0,0-2.78,2,9.43,9.43,0,0,0-1,1.63c-.08.11-.36.11-.55.16l0,0v-.06a3.93,3.93,0,0,0-2.35,2.7,1.41,1.41,0,0,1-.27.4v0a4.32,4.32,0,0,0-.52-.44c-.73.6-1.44,1.22-2.12,1.89-.08.07.1.54.17.54,1.14,0,1.07,1.1,1.66,1.58l0,0v-.06l.5.17-.1.21.21-.1c.93.52,1.89,1,2.77,1.57a6,6,0,0,1,1,1.05h0v.29h0l-.87,1.46s0,0,.08,0l.21,0h0L204.41,59l0,0-.63-.67c-.2.17-.54.32-.54.51s.27.41.43.63l0,0-2,1.39,0,0-.85,1h0a15.69,15.69,0,0,0-1.67,1.12,3.81,3.81,0,0,0-.63,1.06l.05,0-.87-.1-.12,1,1-.63-.05,0c.22,1.36-1.09.87-1.58.91-.84.08-.88.23-.76.93.06.35-.35.81-.61,1.18a22.12,22.12,0,0,0-1.75,2.44c-.28.56-.58,1.36.32,1.85l-.32,0v0l.32,0c-.48.43-.71.43-.84,0a4.68,4.68,0,0,1-.09-.91c-.48.47-.48.47.07,2.83l-1.62-1c-.13.6-.57,1.36-.35,1.89.43,1-.63,1.32-.69,2.16l-1.26-1.08-.23.17.45.88-1.15.23v1l.22.11.71-.89.26.07-1,2.71.39.1,1.15-2.52a.43.43,0,0,1-.11-.39l1.48.67-.17.31-.46-.24-.05,0,.08,0-.6,1.7c.58.67.8.66,2.11-.34v0l1.31-1.05-.84-.18,2.41-.9-1-.76c0-.05.11-.14.13-.13.33.13.66.29,1,.43l-.18,0,.09.11.07-.17.37-.83a11.61,11.61,0,0,1,1.67,0,2.57,2.57,0,0,1,.92.46c1,.58,1.94,1.17,2.9,1.77q.94.61,1.89,1.26l0,.07,0-.09c.54.34,1.1.66,1.63,1a6.87,6.87,0,0,1,.74.69h0l3.25,1.84,0,0,.21.18.08-.18,0,0a11.8,11.8,0,0,0,2.47,1.79,2.67,2.67,0,0,1,1.89,2.28,1.57,1.57,0,0,0,.27.49v0a9,9,0,0,0-1.94.7c-.33.21-.4.78-.6,1.18h0c-.87.63-1.75,1.26-2.6,1.89-.06,0,.11.32.12.49,0,.42,0,.85,0,1.26l-.49,0c0-.25,0-.5,0-.76a1.49,1.49,0,0,1,0-.21h-.08l.09.22c-1.22-.26-1.24.57-1.37,1.3v0c-1.15-.08-1.08,1-1.7,1.48l.91.93-1.42.06v-.06l0,0-.32,1h-.14V96c-1.89,1-2.11,1.49-1.43,3l-1.2-.83-.28.89,0,0c-.22.06-.54.05-.63.18-.59.77-1.16,1.58-1.69,2.38a3.22,3.22,0,0,0-.19,1,1.29,1.29,0,0,0-.63.25c-.45.43-.18.56.33.46l0,0-.06.74,0,0c-.37-.37-.9-1-1.12,0-.31,1.45-2,2-2.34,3.39a5.43,5.43,0,0,1-.63,1.19h0a21.63,21.63,0,0,0-1.61,1.84A10,10,0,0,0,192,112a4.35,4.35,0,0,1-.45.61l2.25.86,1.39-1,.14.55-.56-.11v.21l.53-.13c0-.19.09-.38.14-.56a.34.34,0,0,0,.06.12h.58l0-.07.07,0-.1,0,.06,0h-.59l.07-.18a.14.14,0,0,1-.05,0l-.06.14-.32,0,1.48-1.61v0l.28.27,0,0,.15.45.14-.46,0,0,.59,1-.66.07.15.28.49-.38.65-1,.22-.3-.47-.13-.16-.2-.07.19h-.49l-.25,0,0,0c.35-.49.6-1.12,1.49-.71.14.07.43-.13.66-.2l.39.39.12-.25-.53-.11v-.32l0,0,.7-.06.23.11-.11-.21c.27-.39,1.41.39,1.14-.73h0l2.09-.82.32.54,1.13-1.27.16.09a7,7,0,0,0-.48.84c0,.11.07.27.12.41h0l-.08,1,1.11-.61.11-.09.82-.63.17.07-.89,1.33a7,7,0,0,1,2.33.06c.63.22,1.05.95,1.58,1.47a6.4,6.4,0,0,1,1.66.36,12,12,0,0,0,1.84,1.06l.23,1.3.75-.46,4.57,3.57.31-.34a1.83,1.83,0,0,0,1.8,1.34c.27,0,.78.92.71,1.35a16.07,16.07,0,0,1-1.89,4.6,7.81,7.81,0,0,0-1.58,4.27c0,.41-.63.84-.8,1.32a49.86,49.86,0,0,0-3.5,10.77,36.29,36.29,0,0,1-1.19,4.26,5.57,5.57,0,0,0,0,1.29c-.15.24-.56.6-.63,1-.48,2.84-.88,5.68-1.31,8.51l0,0a8.91,8.91,0,0,0-.5,1.51c-.11.87-.15,1.73-1.41,2,.63,1.1-.31,1.28-1,1.58l0,0a3.54,3.54,0,0,0,.07-.92.8.8,0,0,0-.44-.48,4.1,4.1,0,0,0-.93-.14l-.1,1.36-1.95-1.79-.27.19.54.74,0,0-.76.11.27.61-.05,0v.75l-.95-1,.32-.4a1.4,1.4,0,0,1,.1-.16l-.08,0,0,.22-.33.39c-.69.4-1.32.83-.75,1.61l-1.12-.24,0,0,.56-.4-.53-.95.3.32L199.85,161l-1.33-1-.28,0,.54,1.53-1,.69h0v-2.28l-2.16-.17,0,0a5.75,5.75,0,0,1,.76-.8,2.37,2.37,0,0,1,.73-.22,2.8,2.8,0,0,0-.16-.46,4.73,4.73,0,0,0-.82.22.72.72,0,0,0-.21.12l-2-1.16-.46,1-.06-.17-.09.09.18.06-.87,1.19.75.9-1.81-.39a12.48,12.48,0,0,0-.29-1.62c-.05-.18-.39-.28-.61-.42v0l.09-1,0,0-.07-.05.4-1-.5-.15-.92,2.64h0a3.94,3.94,0,0,0-.66.75c-.63,1.42-1.19,2.86-1.82,4.28a5.06,5.06,0,0,1-.74.92l.73.26c-.16.12-.23.21-.27.2-.72-.19-1,.16-1.13.74a8.69,8.69,0,0,1-.34,1.83c-.25.56-1.12.81-.82,1.7.1.29-.46.76-.71,1.16l0,0c-.63.53-.61.74.28,1.54q-.32,0-.63-.09a2.83,2.83,0,0,1-.4-.17,11.56,11.56,0,0,0-.6,1.09c0,.14.05.32.07.49l.54-.32.11.23-1,.38c-.29.76-.57,1.5-.84,2.25l.06-.05,0,0-.84,1.2v0a1.09,1.09,0,0,0-.81,1.31,1.13,1.13,0,0,0,.08.24h0L178.79,181l0,0a3.93,3.93,0,0,0-1.26,2.78l0,0a2.54,2.54,0,0,0-1.36,1.86L174.66,187l.47.44,1,1.37-.32.17-.47-.65c-.51.63-1.7,1.09-.72,2.08a6.2,6.2,0,0,1-5.46.57c-1,.95-2.35.63-3.53.63a14.44,14.44,0,0,0-5.45.88l-.12-.16-.06.14h.2c-1.53.23-3.05.48-4.58.69a4.76,4.76,0,0,1-3-.67l0,0,.29-2.06.05,0,.27,0,.24.22.17.2.11-.12-.32-.06-.24-.23,0-.24,0,0,.25-.14-.25-.13h0c-.34-.4-.38-.73.26-.89h0l-.09.07,0,.1-.2.17.26.09.27.25.54.05.4-.36-.73-.36-.24-.25h0l.51-.66.63.06,0,.49-.45-.09v.18c.14,0,.28-.07.42-.12s0-.31.06-.45l-.65,0,.22-2,.15.5-.09-.05.07,0v-.57l.32-1,.4.11h.8a2.82,2.82,0,0,1,0,.41l-.63.09-.22.18c.12,0,.25,0,.36,0v.53l-.63-.24.26.44.37-.2v-.53l0-.07h-.07l.53-.18c0-.12,0-.24,0-.36l-.21-.22L156,185l-.31.08-.6.22c.12-.15.36-.39.32-.42-.86-.92.07-1.74.27-2.52a33.31,33.31,0,0,1,1.71-4.31c0-.12.22-.2.33-.31l.14.42.32-.37-.47,0c.74-1.67,1.5-3.34,2.2-5,.63-1.51,1.18-3.06,1.8-4.58.1-.23.49-.36.63-.6a3.42,3.42,0,0,0,.18-.9c-1-.08-.55-.81-.69-1.28l.25-.22.14,1.14.38-.31v0c.44-1.08.88-2.15,1.3-3.24a2.15,2.15,0,0,0,0-.67c-.21.14-.49.24-.61.43a14.13,14.13,0,0,0-1,1.73,5,5,0,0,0-.24.94l-.24.23a4.13,4.13,0,0,0-2,3.94l-1.36-.53c.47,1.18-1.37,1.74-.45,2.89,0,0-.17.32-.2.32a11.45,11.45,0,0,1-1.12-.41v4h-.34l-.26-2.1h-.49l-.29,2.65-1.16.36.5,1.21-1.11-.24c-.39,1.28-.72,2.6-1.21,3.87-.26.68-.9,1.24-1.19,1.92-1.4,3.16-2.73,6.35-4.1,9.53-.55,1.28-1.07,2.57-1.67,3.82a2.86,2.86,0,0,1-.85,1,.91.91,0,0,1-1.52-.63,3,3,0,0,1,.21-1.18c.36-1,.77-2.09,1.13-3.15a1.2,1.2,0,0,0,0-.65c-.22-.88-.15-1,.85-1.48-.37-.53-1.12-1.14.07-1.69-.28.09-.74.13-.81.31-.33.84-.54,1.72-.84,2.58s-.63,1.5-.87,2.27a10.94,10.94,0,0,0-.26,1.62h0l-.27.27,0,0a3.34,3.34,0,0,0-.5.56,10.23,10.23,0,0,1-1.16,2.13,1.79,1.79,0,0,1-1.55.1c-.28-.12-.47-.86-.36-1.24.47-1.63,1.08-3.23,1.58-4.85.06-.21-.15-.5-.54-.76-.34.87-.69,1.73-1,2.6-.54,1.54-1,3.1-1.61,4.62a1.52,1.52,0,0,1-.89.85c-1.64.41-3.32.7-5,1-.51.11-1,.3-1.5.39a2.12,2.12,0,0,1-1.21.06c-.29-.16-.38-.66-.38-1a9.2,9.2,0,0,1,.27-1.57l-.94-.79.26-.26.75.57c.14-.48.44-.94.35-1.36-.26-1.17.77-1.91,1-2.9a5.34,5.34,0,0,0,0-1.13,5.59,5.59,0,0,0,1.12-3l.44-.48-.35-.15-.06.67c-.19.11-.54.22-.54.31,0,1.21-.94,1.29-1.83,1.4-2.39.29-4.8.52-7.18.84a12.35,12.35,0,0,0-2.13.7l-.27,1.7-.9-1.06-.46,2.76c-1.54.56-.63,2-1.21,2.83h0c.73.72-.46,1.13-.31,1.75l0,0a2,2,0,0,0-.32.17c.48,1-.14,1.11-1,1.06l-.05,0h.08a23,23,0,0,0,.1,2.49c.06.47.25.87-.34,1.12l.22-.12v0l-.17.17-.51-.69.3-.05-.1-.11-.17.19c-.74,0-.76.38-.63.87a1.68,1.68,0,0,1-1.17,2.06,2.07,2.07,0,0,1-.5.06c-1.34.07-2.67.29-4,.47-.84.11-1.63.63-2.52.21l.53.2,0-.25-.56.08a7.68,7.68,0,0,0-2.28.44c-1.35.73-3.06.53-4.2,1.16s-2.39.05-3.49.55c-.28.13-1-.59-1.53-.92l0,0v-.72l0,0,.51-2.11-.9.32,1.26-2.31-.26-.1-1.26.55h0l-.25.68a2.84,2.84,0,0,0-.35-.61c-.36-.38-.66-.83-1.39-.49a4.81,4.81,0,0,1-1.5.21l-.19-.13.12.2-5.94,1.52c-1.74.43-3.5.83-5.22,1.32-1.16.33-1.94-.15-2-1.3,0-.24-.15-.48,0-.71v-1h0c0-.18-.16-.45-.08-.52a4.85,4.85,0,0,0,1.32-3.78,12.73,12.73,0,0,1,.32-1.61l0,0,.27-.48,0,0c.24-.45.52-.89.72-1.35a8.9,8.9,0,0,0,.35-1.22l0,0,.68-.75L79,195.43c.49-.22,1.18-.31,1.45-.7s.16-1,.22-1.51c.16-.17.5-.36.55-.6a7.42,7.42,0,0,1,.83-2.07c.09-.16,0-.39,0-.59h0c1-.55.23-1.25.09-2,1.16.61,1.29-.39,1.28-.77a3.66,3.66,0,0,0-.71-1.91c-.12-.17-.87,0-1.31.08-.07,0-.08.36-.12.55v0a4.87,4.87,0,0,0-.44.81,6.73,6.73,0,0,0-.12,1.1l0,0-.12-.25-.16.25,0,0a3.54,3.54,0,0,0-.35.51c-.13.29-.19.6-.32.9s-.38.88-.6,1.32-.52.94-.78,1.43v-.24l-.07,0,.09.18L78.29,193l-.12-.45-.31.46.46,0c-.11.27.24,1-.61.55-.22.65-.46,1.3-.67,2,0,.1.21.28.18.36a22.28,22.28,0,0,0-1,2.48L76,200.42a4.81,4.81,0,0,1-.5-.51.59.59,0,0,0-.39-.33v1.08a3.72,3.72,0,0,1-.09.81c-.1.44-.86.81-.12,1.34,0,0-.13.31-.18.48a4.18,4.18,0,0,0-.4,1.47c.09,1-.32,1.48-1.36,1.7s-1.89.71-2.88,1a26.73,26.73,0,0,1-3.3.76c-.2,0-.71-.5-.71-.78a8.09,8.09,0,0,1,.15-3.91c.12-.25-.24-.68-.34-1,0-.06.22-.17.33-.26l.16.11,0-.06-.23,0V201c1.37-.66.76-2.19,1.41-3.2a1.52,1.52,0,0,1,0-.21l-.06,0,.07.23a12.7,12.7,0,0,0-1.85.14c-1.12.23-2.21.55-3.3.86-.48.14-.95.35-1.41.49-.86.26-1.72.5-2.59.75-1.28.35-2.57.66-3.83,1.07-1,.3-1.48.07-1.68-.82s-.39-1.63-.57-2.46a2,2,0,0,1,0-.6c.11-1.23.21-2.45.32-3.68h0c.12,0,.32,0,.32-.11.53-1.64.94-3.34,1.6-4.94.74-1.82,1.74-3.55,2.56-5.35.6-1.3,1.06-2.65,1.6-4,.22-.55.47-1.08.74-1.6.41-.75.38-1.32-.6-1.68s-1.74-.4-2.25.53a23.28,23.28,0,0,0-1,2.23c-1.26,3-2.57,6.05-3.78,9.1a19.16,19.16,0,0,0-.82,3c-.45,2-1.11,2.31-3,1.23l0,0v-1.37l-.28,0-.39.68v-3l.74.62c-.08-.42-.15-.73-.21-1,.05-.11.11-.23,0-.06v.09c-.74-.09-1.08-.39-.66-1.09,0-.14,0-.28,0-.43l-.2,0,.19.4c-1.89.28-3.78.56-5.7.81-.57.07-1.15.07-1.73.1l0,0h.08c-.83.19-1.67.39-2.52.55-1.63.31-3.27.58-4.9.87l-.35.08c-1.79.58-1.79.58-3-.76,1.22-.35,0-.79,0-1.17l0,0c.25-.14.65-.23.71-.41a8.91,8.91,0,0,0,.2-1.53c.13-1.13.26-2.25.4-3.37l0,0a17.44,17.44,0,0,0,.94-5.65c.16-.14.58-.39.68-.71s-.32-.57-.47-.82c.24-.39,1-.45.82-1.3-.1-.44.27-1,.44-1.46l2.2-6.64,0,0,.86-1.94h0c.11-.86.22-1.72.32-2.58l.42.32.08-.21-.53-.07q1.23-2.34,2.42-4.69l-.5-.25h0l-.35-.53c-1.25,0-2.3,0-3.36,0a15,15,0,0,0-3.2.29c-.44.13-.78.88-1,1.41-.74,1.91-1.41,3.85-2.1,5.77-.15.43-.28.86-.41,1.29h0l-.06,0c-.57,1-.41,2.45-1.8,3.12a7.61,7.61,0,0,1-2.58,5.75c.9.47.9.47.47,1L22.54,174c0-.16,0-.32,0-.48l-.35.15.35.31-.53.81,1.19.76-1.16.47v-.23s-.06,0-.06,0a.67.67,0,0,0,.07.18c.31,1.86.33,1.93-1.53,2.67-.95.38-.8,1.06-.84,1.74l.05,0c-.52.53-.49.51-.18,1.06a.67.67,0,0,1,0,.67,3.87,3.87,0,0,1-1.42,1.08,22.34,22.34,0,0,1-2.94.4c-.43.06-.84.19-1.26.23s-.95.17-1.18,0a1.25,1.25,0,0,1-.37-1.11c.73-2.7,1.55-5.38,2.32-8.06.23-.78.4-1.56.63-2.41l-.94-.73-.45.55,0,0-.46-1.41h0l1.89,1.06c.56-1.69,1.85-3.15,1.12-5l0,0a1.92,1.92,0,0,0,1.36-2.29c-.3-.69-.61-1.39-.86-2.1-.06-.15.12-.37.19-.56l.18.1-.21-.07.06-.25-.05,0,.66-.14-.68-.11,0,0-.25-.51,0,0,.79-.15.53,1.4a14.49,14.49,0,0,0,.91-3,1.49,1.49,0,0,0-1.1-1.8h0l0,0,.13-.47h0l.26,0,.08.17.15-.17,1.09.38-.18-.13,0,.12h.23l.36-.16.48.5.2-.26-.72-.21c-.06-1-.13-2-.19-2.93l.57-.08-.08-.22-.46.32c-.18.15-.47.29-.5.47-.07.46,0,.94-.07,1.39-.06.23-.43.38-.67.57l-.25-.24h0c.12-.45.22-.9.36-1.35s.4-1.1.6-1.65h0a3.06,3.06,0,0,0,.53-.71,9.23,9.23,0,0,0,.26-1.27l0,0,.27.12,0,0c1.17.46,1.23.4,2.06-2l-.59-.05,0,0-.29-.26.05,0c-.05-.41,1.5-.08.49-.93l0,0,.18-.08-.18-.19,0,0v-.22l.88.09c.54-.8,1-1.58-.48-2-.07,0-.05-.31-.06-.49h0c0,.09,0,.13.14.13l.12.16.05-.11h-.2l.34-.9-7-.38,0,0c-.06-.44-.11-.89-.18-1.33,0-.18,0-.36-.07-.55l-.34.11.43.44-.78,0h0l-.63-.68h0l.54.2h0l-.06,0,0-1.18,0,0,.25-.13-.25-.13,0,0,.17-.35h0l1,.24c0,.22.07.44.12.67l.28-.11-.43-.54.33-.71-.51,0v-.53l.28,0-.08-.24-.21.21v.51l-.88-.15,0,0V140l0,0,.73-1,0,0c.56-.48.56-.48.14-1.39h0l-.2-.63h0l.91,0c.26-.43.54-.9.81-1.37s0-1.14-.91-1.3l0,0-.27-.25,0,0,1.55-.81-.17.83h.29l-.12-.84a4.85,4.85,0,0,1,.23-1.36c.38-.78-.05-.82-.68-.78v0l.18-.7v0h1.05l-.73-1.42h1.31l-.46-1.26,0,0,.29-.27,0,0,.53-1.41a.35.35,0,0,1-.05-.18l.45-.21-.2-.2-.24.46-.22.1.28,0-.42.7-.17-1.06.06-.07,0,.1-.2-.43c1.36-.52,1.31-1.5,1-2.6-.05-.2.15-.46.24-.69h0l.53,0-.2-.44.69.41c-.11-.35.16-1.37-.67-.38l-.53-.22,0,0,.12-.68h0v-.27h0l.58-.11h0l.72-.12c-.06-.29,0-.7-.21-.84-.43-.31-.7-.45,0-.66l.26.08V119l-.29,0v-1.29h0c.11-.08.3-.14.31-.25a8.72,8.72,0,0,0,.16-.89h0l.67,1,.37-.21-.49-.71,0,0L20.94,115l.34-.17.86,1.32c.52-.69.43-1-.11-1.5-.21-.22,0-.75,0-1.14h0l.2-.08-.2-.19h0l-.14-1.33.65-.18-.17,1.34.27.14.83-1-.95-.5-.33-.4v0l1.82-.07-.13-2.07.31-.08-.91-.57,0,0,.56-.22,0,0-.53-.07h0l.48-.67.07.18.11-.1-.21-.06a.31.31,0,0,0,.05-.21h0v-.29h0l0-.1h-.1c.21.17.5.32.61.52a3.42,3.42,0,0,0,.67,1.19c.11-.79.22-1.58.3-2.36a1.23,1.23,0,0,0-.37-.12l0,0,.38-.79-.37,0h0l1.08-.72-.72-.05,0,0a9.67,9.67,0,0,1,.28-1.21c0-.17.3-.28.45-.42l0,0,.14,1.39.38,0,.57-3.1-1.09.35.05,0,0-1.24,0,0,.54-.59v0l1.65.52-.66-2.27,0,0,.54-.09,0-.16h-.52l0,0v-.24c1.32,0,1.32,0,1.62-.61l-1.12-.53-.06,0,.18-.07-.18-.19ZM115.4,22.89l-.09-.16-.07.1.2,0,.14.15-.18-.12m89.76,87.28.17.1-.21-.07,0-.17-.09.07.17.07M20.27,154.6l.18.11-.21-.08-.17-.12.2.09M141.53,46h-.26l-1.46-1c0,.93.53,1.28,1.48,1.18l.16.16.07-.16h.27v.59l.31-.1-.36-.45-.21-.24M200.3,33.8l0,0h.07v.11a.59.59,0,0,1,0-.13M187.84,80.7v-.25a1.63,1.63,0,0,0,0,.23l0,0v.06M24.49,74.62l.06,0h-.08l.05,0,0-.06m7.43-1.05,0,.18.11-.07-.17-.09-.09-.15-.06.1.18,0M91.29,24.07l-.3.23-.16-.06,0,.12.15-.09a3.15,3.15,0,0,0,.29-.22l.08-.18h-.09l.06.22M82.8,32.43l0-.15,0,.16-.15-.11-.06.11h.23m30.06-8.33h0v0l0,0m35.18,15.45-.29.14-.14.37-.18,0,0,.06h.24c0-.13,0-.26.08-.39l.34-.13.23-.32.21-.27-.16-.08c0,.12,0,.24-.07.36l.07.28-.32,0m-36.55.63-.18-.1.21.07.17.12-.2-.09M72.32,12.61l-.09.06,0-.09.09-.17-.05.21M153.86,192l0,0-.08,0,.06,0,0,.07M151.27,36.21l-.08-.17.09.19-.18-.1,0,.13.21,0m-51,7.64,0,.29,0-.29-.08.07,0-.14.07.07m40.59.23.08-.18-.11,0,0,.19.34-.11,0,0c0-.19,0-.07,0,.06l-.38.1M121,18l-.17-.08.22,0,.08,0L121,18,121,18m29.58,19.15.12-.39h-.2l.09.43-.17-.1,0,.13.21-.06M29.25,72l0-.07.06,0,.19.49,0,.17.11-.08-.18-.07c-.06-.16-.13-.31-.2-.47m80.33-33.2-.12-.27-.09.13.24.11v.07c.13.14,0,0,0,0M23.68,170.57h-.52l.43.33.06-.36.16-.1-.13,0v.16M59.92,176l0,0h-.06l.19.32.07-.05-.22-.24M159,179v.22l.06,0L159,179l-.23-.29-.06.16.31.11M75.09,9.74l-.36-.09v.17l.36-.08v-.2l-.12,0,.12.17M115,201l.08-.15.1.15H115v0m41.31-17.38-.29.15.28.07.47.27.15-.27-.57,0-.06-.21.25-.1-.25-.09.87-.73.22.21c0-.23,0-.46.07-.68.91-.26.54-.79.31-1.29l.22-.29-.17-.07,0,.38c-.92.26.06.92-.32,1.29-.28,0-.56.09-.83.15-.6.19-.86.49-.32,1v.25M49.85,185.19l.15-.36-.19,0,.06.42-.17-.07,0,.14.17-.1m82.41,2.52-.28.46-.49,0,.23.69-.45-.11v.17l.46-.07.24-.71c.09-.15.18-.3.28-.45l0-.43-.2,0,.19.39M32.18,79l-.12-.13,0,.1h.19V79c.11.15,0,0,0,0m-3.55,8.68.18-.4-.26-.08.06.47-.18-.12-.05.11h.23m127.11,96.89.41.13,0-.18-.47.08.14-.51-.22,0c0,.17.07.34.11.5M199.61,160l-.23-.23-.28-.34-.17.24.47.08.19.29.21.39,0-.39.65.15.42-1.23-.18-.11-.92,1.16a.18.18,0,0,0-.2,0M142.78,44.83l-.2-.18s-.07.07-.06.07l.17.18.55.3.1-.32-.56-.06m61.14,64.47.23.42.24-.17-.49-.21-.13-.72-.28.1.45.59M33.24,77.06l-.58.12.43.52.12-.65,0-.21h-.08l.09.23m82.62,123.1.35.21.06-.19h-.43l-.16-.45-.27.27.45.16M152.05,19.63l-.51,0c.08.21.17.41.25.63l-.21.46-1.19.41.17.32,1-.73.21-.47c.09-.22.18-.43.26-.65l0-.2-.12,0,.11.18M144.59,43l.72-.13-.2-.31c-.16.15-.31.31-.49.47l0,.06V43M98.94,47.66l0,0h-.07l-.09-.69-.32.12.45.6M116.12,37l.18.11-.21-.08-.08-.4-.43.42.12.12.42-.17m.52,1.17.36-.63-.56-.07.16.66-.46.22.21.21.29-.4M113.13,38l0-.06,0,0,.33.57.24-.2-.55-.34M98.64,44.32l.5-.31-.3-.3-.18.63-.07,0,0-.08m37.15-23.95,0-.06.08,0-.16.77.65-.1c-.25-.28-.4-.45-.56-.6M29.07,65.4l-.61.32.39.29c.07-.21.13-.42.19-.63l.1-.17-.07,0v.23M147,186.59l-1-.26.39.83.59-.57v0M191,80.22l-.79.09.26.43.52-.53V80l-.12,0,.12.16M28,77l-.12-.14,0,.13.18,0-.26,1c.74-.42.74-.42.23-.94m72.06-34.82c-.36.38-.36.38.43.68l-.36-.63.14-.16-.21.1m40.34,148.7-.51,0,.61.81.28-.18-.41-.7.21-.56-.35-.06.17.63M53.9,33l.82-.68-.5-.3-.31,1-.52.48.26.15.24-.63m57.86,1.57-.8.72.55.24.22-1,.41.16-.13-.77-.25,0ZM137,19.82l.63-.42-.36-.32c-.08.25-.17.5-.25.75l-.39.34.19.12.17-.48m-104.54,56c-.16-.53-.36-.94-1-.24l1,.21-.84,1c.7-.11,1.29-.28.8-1m0-3.81L32,71.66l-.1.23.55.09v1.2c.72-.7,1.13-1.11,0-1.17M154.55,187.64l0-.19-.12.08.19.08,1.23.23-.16-1.17-1.1,1M188.12,77.53l-1.12.82,1.1.44V77.53l0-.21-.12,0,.12.18M85.8,29l.22.1-.14-.17H84.65l.47,1.16L85.8,29M197.68,48.26l1.61-1L198.22,47c-.17.44-.34.88-.52,1.32l-.52.1.16.31.34-.42M20.4,153.61l.44.08v-.17l-.44.1c0-.56,1.34-.94.13-1.84-.05.74-.1,1.3-.14,1.86l-.19-.12-.05.12h.26m132.47-120-.14-.06.16,0v.8l1.47-1.52-.26-.26-1.23,1M35.23,80.09c-.23.37-.47.75-.67,1.14a4.09,4.09,0,0,0,.41.27c.1-.37.21-.74.28-1.12a.87.87,0,0,0-.06-.32l.2-.09-.17.12m65.94-36.84-.23-.1.14.18-.53.91.94.27a1.55,1.55,0,0,1,.21,0l0,0-.24,0,.74-.5-1-.79M32.37,84.6l-.66-1.72-.4,2,1.07-.29.49,2.07c.35-.91.56-1.45.76-2L33.56,83l-.5.09.63,1.55-1.32-.07M198.86,46.22l1.07.52.19-.29-.65-1.18-.32,0-.28,1-.47.16.27.28.18-.47m-172,30.15c.28-.26.72-.5.8-.81s.77-.82-.14-1l-.06-.17-.1.09.18.06c-.22.63-1.64.91-.65,1.89-.57,0-.57,0-.32.71l.27-.74m5.32,11.87c.29-.92-.84-2.82-1.67-2.86l1.57,2.76L31,88.24c.43.39.85.76,1.19,0M153.69,18c.92-.43,1.16-1.34,1.68-2l.24.71-.16-.1,0,.14.19-.07,2-2L156.44,14,156.38,15l-.72-.24-.41,1.06a2,2,0,0,0-1.54,2.21c-.74.08-.74.08-.22.85l.2-.88M50,36.59c-1.62,1.66-1.62,1.66-.59,2.45l-.11-1.14H50ZM20.5,178.06l.48.17.82-1.93-.5-.19-.81,1.95M32.9,75.58l.63-2.13c-.83.49-1.43,1-.63,2.13m42-68.42-.3,1.17a6.28,6.28,0,0,0,1-.49A5.08,5.08,0,0,0,76.28,7l-1.37.13m36.82,29.62.18-.25-1.16-.85-.35,1.5.37.09.38-.81.58.31M33.8,82.69l-.2-1.8c-.3.38-.75.72-.71,1s.56.51.91.8m157.51-8.48c-1.08-.17-1.26,0-1.27,1.34l1.27-1.34M117.82,36.12h-.56a4.22,4.22,0,0,0,0,.87c0,.06.39.08.59.11Zm23.11,153.06.39.27.74-1-.32-.21-.81.95M47.54,41.13l.4-.24-.74-1a3.53,3.53,0,0,0-.32.21c.21.35.44.69.67,1m-17,34.13-.31.22.86.85.46-.42-1-.64M53.36,32.75c-1.23,0-.91.59-.66,1.13l.66-1.13m94.77,150.7-.34-.4-.8.72.22.21.92-.53M29.51,75.72l-.38,0,.09,1.13.4,0Zm116.17,112.5.42-.15-.46-1.07-.29.09.33,1.13M33.87,74.44l.32.07.33-1.05-.37-.08-.27,1.06m53.23-46.7.37.08.24-1-.34-.06-.26,1M78.57,3.51l-.32.3.82.75.33-.32-.83-.73m65.57,40.07-.41-.07-.21,1.12.31.06.32-1.1M30.92,74.81l1.16-.61c-.44,0-1.15-.48-1.16.61M52.79,34.36c-1.06-.51-1.18-.13-1.07.66l1.07-.66m36.92-9.14.26,0,.19-1.16-.31,0-.13,1.17M27.22,100.5l-.4.14.27.92.39-.09-.26-1m0-26.7.36-.14-.33-1.08-.26,0,.23,1.18m88.21-52.14-.43-.18a6,6,0,0,0-.19.73s.17.1.3.18l.32-.73M35.76,72.82l-.45-.06c0,.25,0,.49,0,.74,0,0,.21.06.37.1l.06-.78M79.62,3.47l.18-.25L79,2.62l-.27.31.85.54m-51.3,70.3L28,73.9l.37.81.34-.12-.37-.82M143.55,43.2l.24-.14-.57-.85-.28.16.61.83m-3.2,4.59v-1.1l-.59.16.59.95m6.44-8.63.32.23.49-.69-.31-.19-.51.65M51,35.8a1.86,1.86,0,0,0-.24.54c0,.08.22.25.3.23a1.42,1.42,0,0,0,.39-.28L51,35.8m58.17,1-.27-.24-.58.72.31.21.54-.69M65.49,19.55l-.38,0v.78l.26,0,.11-.77M42.33,63.74,42,63.46l-.56.48.28.26.57-.46m68.45-29.31-.31-.09-.23.78.29.08.27-.77M33.74,80.76l.31-.39a1.5,1.5,0,0,0-.41-.23s-.23.21-.21.29.18.2.32.32M99.57,40.88l-.1-.32-.78.23.11.29.77-.21m0,.47-.4,0v.79l.21,0,.18-.78M26.49,77.61l0-.18-.63,0,.1.39.56-.25m86.28-42.15-.28-.27-.53.59.21.18.6-.5m3.49-.16-.2.05.17.79.34-.09ZM83.71,186.18l.31-.13-.35-.48-.2.12.22.49M77.61,4.2l-.32.2.42.5L78,4.74l-.34-.54m-42,67.13-.13.36c.22,0,.45.08.68.1,0,0,.09-.07.19-.15l-.74-.32M16.47,138l.37,0-.17-.63-.27.05.07.63M117.4,21l-.34,0,0,.71h.24l.05-.74M23.67,145.62l.3-.27-.57-.41-.09.12.37.56m115.8-97.43.17.18.63-.48-.18-.2-.63.5M38.18,67.69l-.29-.13-.18.56.16,0,.31-.48M147.54,37.54c.12.07.21.17.27.15s.16-.12.24-.18c-.07-.07-.15-.21-.2-.2a2.11,2.11,0,0,0-.32.23M110.7,35.68l-.09-.25a4.87,4.87,0,0,0-.53.21,1.21,1.21,0,0,0,0,.18l.57-.14m86.73,11.59-.29-.15-.2.56.19.07.31-.48m-54-5.37.22-.08-.12-.48c-.1,0-.28.11-.28.14a3.25,3.25,0,0,0,.18.43m62.36,115.21-.35.08.21.48.2-.06-.06-.5m-11.07.58.23,0-.1-.5-.29.1a3.43,3.43,0,0,0,.16.45M22.88,114.16l0-.29-.68-.05,0,.19.67.15m25.75,73,.16-.22-.76-.28-.07.17.67.33m111-12.1.22.17.32-.55-.21-.12-.34.5M35.12,78c-.07.24-.15.4-.12.43a2.62,2.62,0,0,0,.46.19L35.12,78m-7.68-.47-.1-.16-.54.21.17.25.47-.31m72.26-34,.21-.15-.35-.45-.17.11.31.49M51,37a1.82,1.82,0,0,0-.46-.11.4.4,0,0,0-.24.18s.09.19.16.2.18-.08.54-.26m94.16,3.19-.26.12.32.38.13-.07-.2-.43m-1.12.07-.14.12.35.41.17-.15-.38-.38M147.57,185a2.14,2.14,0,0,0-.44-.08.66.66,0,0,0-.27.12,2,2,0,0,0,.24.27,3.55,3.55,0,0,0,.47-.32M115.07,38.54l-.18,0,0,.57h.13Zm2.37,156.06-.17.18.46.29.13-.17-.42-.32M110.7,38.42l-.2.13.36.44.15-.1-.31-.47m83.2,118,0,.2.63-.07v-.13ZM137.67,51.12c-.13-.07-.21-.15-.29-.15s-.17.14-.15.18a.32.32,0,0,0,.22.17c.05,0,.12-.11.22-.2m23.07,120.35.25.2c.06-.08.16-.17.16-.26s-.12-.13-.18-.2l-.23.26M99.91,45.61h.21l-.07-.59h-.13Zm-3-.23c-.09.33-.17.47-.13.52a1.15,1.15,0,0,0,.31.13l-.18-.65M34.72,71.85l-.21.12.14.44c.09-.06.26-.13.25-.17a1.38,1.38,0,0,0-.18-.39m1.82-2.06-.26.12.29.51.16-.07-.19-.56m-5.35-.87.23-.07-.14-.54-.17,0,.1.56m84.15-32.71L115,36c-.06.09-.17.18-.19.28s.15.2.17.19a2.08,2.08,0,0,0,.34-.24M75.74,8.66a.76.76,0,0,0-.32-.11c-.09,0-.14.11-.21.18l.32.21.21-.28m87.05,16.67a1.45,1.45,0,0,0-.42-.12c-.09,0-.17.1-.25.16s.11.17.17.18.18-.06.5-.22M72.07,11.6c-.12-.06-.22-.15-.31-.14s-.13.13-.2.2l.3.21.21-.27M52.36,35.37a1.55,1.55,0,0,0-.38-.13.66.66,0,0,0-.27.12,1.32,1.32,0,0,0,.25.28,2.11,2.11,0,0,0,.4-.26m32.05-4.93-.29-.16-.17.3c.09,0,.2.13.27.11s.12-.15.19-.25M88,26.21c-.22-.08-.32-.16-.43-.15a.19.19,0,1,0,0,.37c.07,0,.18-.07.48-.23m75,142.33.07-.12-.32-.27-.11.27.38.12m-4.62,11.39-.14.27a.75.75,0,0,0,.26.05c.05,0,.09-.09.13-.14l-.25-.18M196.21,48.19l-.25.2.17.29c.08,0,.22-.08.22-.12a2.32,2.32,0,0,0-.13-.37M170.8,152.5a1.75,1.75,0,0,0-.32-.12s-.16.1-.15.13a1,1,0,0,0,.15.24l.32-.24m-56.11-132,.21-.05-.09-.45h-.12Zm27.54,25.54.25,0,0-.48h-.15l-.07.46m24.65,112.45-.11-.09s-.05.07,0,.09l.1.1,0-.1M146.35,39.88c.05-.2,0-.1,0,0h0m-1.71-.42-.21-.17-.1.39.32-.22m-44.51-.14.16.12.26-.27-.12-.1-.31.25M37.32,69.57l.07-.11-.29-.26-.12.24.34.13M30.66,81.83l-.25,0,.1.39.15-.41M31.15,70c-.11-.08-.19-.17-.25-.16a.27.27,0,0,0-.21.15c0,.06.08.14.13.22l.32-.21M101,38.73l.21-.24-.26-.11a2,2,0,0,0-.11.26s.09,0,.16.09M30.36,71l-.17,0,.06.46.17,0L30.36,71m-1.47.42a1.65,1.65,0,0,0,.07-.32l-.37-.1.31.41M149,38.09a1.57,1.57,0,0,0-.43-.15c-.08,0-.16.09-.24.13a.89.89,0,0,0,.21.22c.09,0,.16-.06.46-.2M29.26,72.81l-.27,0,0,.48h.14l.09-.46M72.9,205.39l-.12.06.15.32.25-.11-.28-.27m41.78-.8-.14-.12c-.07,0-.19.05-.2.09a.92.92,0,0,0,0,.28l.29-.25m-.53-182-.14-.1c0,.06-.07.12-.06.18s.08.07.12.1l.08-.18M20.25,123l-.07-.17c-.05,0-.12.06-.12.1s0,.11.06.17l.13-.1m9.9-49.85-.11.13a.6.6,0,0,0,.19.06s.07-.07.11-.11l-.19-.08m-1.92,3a.76.76,0,0,0-.18-.09s-.06,0-.09.06.05.08.07.08l.2,0m-11.62,63-.07-.17c-.05,0-.13.06-.13.09a1.08,1.08,0,0,0,.07.18l.13-.1m13-65.3s.08,0,.07-.07a1.19,1.19,0,0,0-.08-.16,1.22,1.22,0,0,0-.07.17s0,0,.08.06M34,75.32v-.09l-.35,0v.11Zm-7.83-.06-.21-.07-.06.08a.49.49,0,0,0,.13.1s.09-.06.14-.11m84.09-49-.11.12a.49.49,0,0,0,.19.07s.08-.08.11-.11l-.19-.08M161.61,26l-.18.07a.87.87,0,0,0,.21.17s.1-.08.15-.11l-.18-.12M32.26,86.36a1.42,1.42,0,0,0,.08-.18s0-.06-.07-.09-.12.09-.12.13.07.09.1.14m-.55,2.9h.1v-.35h-.1ZM21.61,118.17s-.08-.11-.12-.11a.66.66,0,0,0-.2.06s.08.12.12.12a.48.48,0,0,0,.2-.07M196.68,113l-.19-.08s-.05,0-.09,0,.08.11.12.11a.48.48,0,0,0,.16-.08M35.92,78.83h-.09v.31h.09Zm153.89,3s-.07-.11-.11-.11a.41.41,0,0,0-.19.05s.07.12.11.12a.6.6,0,0,0,.19-.06m-158.06.72s-.07,0-.07.08a1.42,1.42,0,0,0,.08.18.67.67,0,0,0,.07-.18s0-.05-.08-.08m1.08,1.58L32.7,84a.36.36,0,0,0-.07.17s.08.07.12.1l.08-.17m112.82,105H146V189h-.37Zm-96.85-.6-.08-.17s-.12.06-.12.1a1.56,1.56,0,0,0,.07.17l.13-.1m95.44-6v.11h.35v-.1h-.35M19,182l-.13-.1c0,.06-.07.12-.06.17s.08.07.12.11L19,182M78.26,5.48,78,5.41s0,0-.08.08.1.09.16.1.09-.07.15-.11m37.41,196.34-.21,0v.16a.09.09,0,0,0,.1,0,.63.63,0,0,0,.11-.12m.58-3.78h-.06a.11.11,0,0,0,0,.08l.11,0,0-.08m-67.87-8.8v.12h.36v-.1l-.36,0m116.52-28.47h-.1v.34h.1ZM192.48,159a.6.6,0,0,0,.07-.18c0-.06-.09-.08-.13-.11a.45.45,0,0,0-.07.18c0,.05.08.07.13.11m7.82-.56-.08-.18s-.12.07-.12.1a.94.94,0,0,0,.06.18l.14-.1m6.86-.1h.1v-.32h-.1ZM193,158l-.12-.1a.36.36,0,0,0-.07.17s.08.06.12.1L193,158m-1.71-.06s0-.09-.05-.09l-.2.06s0,.08.06.08l.19-.05m4.92-.26a.83.83,0,0,0,.16.09.16.16,0,0,0,.08-.06.13.13,0,0,0-.06-.08l-.18,0m-26.76-2.72c-.05,0-.12.07-.13.11a.68.68,0,0,0,.07.17s.12-.06.12-.1,0-.11-.06-.18M117.29,20.46l-.08-.18s-.12.07-.12.1,0,.12.06.18l.14-.1m17,.67v.11h.35v-.09l-.35,0m25.27,156.65h-.1v.33h.1Zm-4.51-2.08-.14-.12c0,.06-.08.13-.07.19s.09.08.14.11l.08-.18M23.33,171.28h-.1v.32h.1Zm1.5-2.93-.07-.17s-.12.06-.12.09,0,.12.06.18l.13-.1m141-5.48h.1v-.31h-.1ZM146.24,40.18a.89.89,0,0,0-.08.17s0,.06.06.09.11-.09.12-.14-.06-.08-.1-.12M108,40l-.22-.07s-.06,0-.09.08a.7.7,0,0,0,.16.1c.06,0,.1-.07.15-.11M108,38.77h.1v-.34H108Zm4.41-.26c0-.07.07-.12.07-.18s-.08-.07-.12-.1a.47.47,0,0,0-.07.17c0,.05.07.07.12.11M29.53,65.45h.09v-.31h-.09Zm9.95-.29a.68.68,0,0,0-.07.2s0,0,.07.08.11-.1.11-.15-.07-.09-.12-.14m-4.95,3.69-.14-.1c0,.05-.07.11-.06.17s.07.07.12.11l.08-.18M114.8,38.06c0-.07.07-.12.06-.18s-.07-.07-.12-.1-.07.12-.06.17.07.07.12.11M37.9,69.15,37.82,69s-.11.07-.12.1a.68.68,0,0,0,.07.17l.13-.09M146,37.54h-.09v.31H146ZM35.44,70.29h-.1v.32h.1Zm-5.2.26-.19,0a.49.49,0,0,0,0,.17.14.14,0,0,0,.09,0,.47.47,0,0,0,.09-.12m81.58-32.92h.1V37.3h-.1Zm-81,32.88h-.1v.33h.1ZM142,44.92l-.18.1.06.09L142,45l-.07-.09m-.79-.43h-.11v.36h.11Zm-45.27,0s-.12.07-.12.11a.36.36,0,0,0,.07.17s.11-.06.12-.1a.89.89,0,0,0-.07-.18m43.34,1.21v-.1h-.35v.11ZM107.07,44H107v.31h.1Zm-9.39,2.65-.07-.18s-.13.07-.13.11a1.57,1.57,0,0,0,.07.18l.13-.11m18.13-12.07h-.16a1.65,1.65,0,0,0,0,.31h.07c0-.1,0-.21,0-.31M98.36,43.15h-.1v.31h.1Zm9-1.12h-.09v.31h.09Zm-8.94.09V42H98v.1ZM142.7,42l-.07-.18s-.12.07-.13.1a.47.47,0,0,0,.07.17l.13-.1m-31.52-1.06-.22-.07s0,0-.08.07.1.1.16.1.09-.06.14-.1m2.14-.29-.1.08.18.08s0,0,.08-.07l-.19-.09M33.49,71.72s-.08-.11-.13-.12a.6.6,0,0,0-.19.06s.07.12.11.13a.58.58,0,0,0,.21-.07M50.31,36.45l-.18-.07s-.07,0-.06.06.07.11.1.1.1-.06.15-.1m4.53-5.78-.13-.09c0,.05-.08.11-.07.16s.08.07.12.11l.08-.18m87.27,12s-.08,0-.08.08,0,.05.07.07.08,0,.08-.07-.05,0-.07-.08M163,169.77s-.05-.08-.08-.08-.06,0-.09.06,0,.08.08.08.06,0,.09-.06M106.14,43.65l-.08-.08s-.08,0-.08.07a.08.08,0,0,0,.07.07s.06,0,.09-.06M26.2,166.1l-.08.07.07.08s.08,0,.08-.07,0-.05-.07-.08m133.42,1a.2.2,0,0,0-.08-.08s0,.05-.08.07a.29.29,0,0,0,.07.08s.06-.05.09-.07M141,43l-.07-.08s-.08,0-.08.07a.08.08,0,0,0,.07.07S141,43,141,43M160,176.19s-.08.05-.08.08,0,0,.07.08.08,0,.08-.07,0-.06-.07-.09M105.41,41.85l-.08-.07s-.07,0-.07.06,0,.08.07.08,0,0,.08-.07m39.94.45-.08-.08s-.08,0-.08.07.05.05.07.08l.09-.07m-32.92-.22-.08-.08s-.07,0-.08.07a.12.12,0,0,0,.07.07s.06,0,.09-.06m1.69-5.2-.07,0V37s0,0,.07,0v-.06m23.24-18.59-.08-.08-.08.07s.05.07.08.07.05,0,.08-.06M28.86,159.59l-.08.07s0,.07.07.07.06,0,.09-.06l-.08-.08m136,.61s.08,0,.08-.07-.05,0-.07-.08-.08,0-.08.07,0,0,.07.08m.51,0,0-.07h-.08Zm.54.13-.07-.08-.08.07.11.07,0-.07m-47.28-141s-.08.05-.08.08,0,.05.07.08.09,0,.09-.08,0-.05-.08-.08m74.28,139.3.09-.08s-.05-.07-.08-.07-.06,0-.08.06l.07.08m10.74-.06-.07-.08s-.08,0-.08.07,0,0,.07.08l.08-.08m-183.75.38-.09.07s.06.08.08.08S20,159,20,159l-.08-.08M142.43,44.34l-.07-.08s-.08.05-.08.07,0,.05.07.08ZM18.21,163.86s-.07,0-.07.08,0,.05.07.08.07-.05.07-.08,0-.05-.07-.08M112.67,36.7l-.07-.08s-.08,0-.08.07,0,.05.07.08l.08-.07m47.9,128.14-.07-.08s-.08,0-.09.07.05.06.08.08l.08-.07M109.92,43.72l.09-.07s-.05-.07-.08-.07-.06,0-.08.06.05,0,.07.08M77.25,6.7l.08-.06-.07-.07-.08.09.07,0m62.52,10.92-.08-.08s-.07,0-.08.07a.12.12,0,0,0,.07.07s.06,0,.09-.06M48.54,190l-.07-.08s-.08,0-.08.07,0,.05.07.08l.08-.07M111.39,38.19l-.09.07.08.07s.07,0,.08-.07,0,0-.07-.07m-63.09,0s0-.07-.08-.07,0,0-.08.07l.12.07,0-.07m101.09-.13s.07-.05.07-.08-.05-.05-.07-.08-.08.05-.08.08,0,0,.08.08m4.67,153.21s-.05-.07-.08-.07-.06,0-.09.06.05.07.08.07.06,0,.09-.06m-8-2.69s-.05-.07-.08-.08-.06,0-.09.07.05.07.08.07.06,0,.09-.06M114.61,36s0-.06-.07-.06-.05,0-.07.05l.1.07,0-.06M71.77,205l-.07-.08s-.08,0-.08.07,0,.05.07.08l.08-.07m2.19-.45s0-.08-.08-.08-.06.05-.09.07,0,.07.08.07.06,0,.09-.06m41.13-2.71-.08,0v.07ZM74.12,9.46,74,9.54l.08.08.08-.07-.07-.09M74,202.76l-.08-.08s-.07,0-.08.07,0,.05.07.08l.09-.07M109.53,37.82l-.08-.08-.08.07s0,.07.07.07.06,0,.09-.06m0,2.92s0-.08-.08-.08-.06,0-.08.07,0,.07.07.07.06,0,.09-.06m-2.18.67-.08-.08a.29.29,0,0,0-.08.07s0,.07.07.07.06,0,.09-.06m43,137.25-.08.07s0,.07.08.07.05,0,.08-.06l-.08-.08m-6-137.49s-.05-.07-.08-.07-.06,0-.08.06,0,.08.07.08.06,0,.09-.07M157.6,179.25l.08-.07-.07-.07-.09.1.08,0M140.9,40.87s-.08.05-.08.07,0,.05.07.08S141,41,141,41s-.05-.05-.07-.08M108.55,41l-.08-.08s-.08.05-.08.07a.11.11,0,0,0,.07.08s.06-.05.09-.07M71,14.09S71,14,71,14s0,0-.07-.07-.07.05-.07.07,0,.05.06.08m42.92,25.07s0-.07-.07-.07-.06,0-.09.06,0,.08.08.08,0,0,.08-.07m-1.45,0-.07-.08s-.08.05-.08.07,0,.05.06.08l.09-.07M73.22,11.56s0-.07-.07-.07-.06,0-.09.06,0,.08.08.08.06-.05.08-.07m73,25.43.08-.07s-.05-.07-.08-.07a.09.09,0,0,0-.07.06s0,.05.07.08M93.72,205.16l-.08.06s0,.08.08.08.06-.05.09-.07l-.09-.07M49.18,188l.09-.07s-.05-.07-.08-.07-.06,0-.08.06l.07.08M115.57,35.77l-.07-.07s-.08,0-.08.07,0,.06.07.08l.08-.08m30.41,3,.09-.07s0-.07-.08-.07-.06,0-.08.06.05,0,.07.08m-37.52,0,.08-.07s0-.07-.07-.07-.06,0-.08.06l.07.08m4.45,1.28-.07-.07-.09.07s0,.08.08.08.06,0,.08-.07m32.67-.44s0-.08-.07-.08-.06,0-.09.07.05.07.08.07.05,0,.08-.06m-36.12-.08-.08.07s.05.07.08.07.05,0,.08-.07l-.08-.07m-81,57-.07,0v.14s.06,0,.07,0,0-.05,0-.07M132,25.32l.08-.07s-.05-.07-.07-.07-.06,0-.09.06l.08.08m-97.2,39.2-.08-.08s-.08,0-.08.07,0,0,.07.08l.09-.07m96.8-38.82-.08-.08s-.08,0-.08.07.05,0,.07.08l.09-.07m-17.26-1.88s-.08.05-.08.07.05.06.07.08.08,0,.08-.07,0,0-.07-.08M88.39,103l.08-.06a.29.29,0,0,0-.07-.08.1.1,0,0,0-.08.07s0,0,.07.07M45.08,59.73s-.08,0-.08.07,0,.05.07.08a.29.29,0,0,0,.08-.07s0-.05-.07-.08m86.64-35s-.08.05-.08.07,0,.05.07.08.07,0,.08-.07,0-.05-.07-.08m-87,34-.08-.08s-.07,0-.08.07.05,0,.07.08l.09-.07M22.9,77.76l-.08-.09s-.08,0-.08.08,0,0,.07.08l.09-.07m164.55,1.09-.06-.07-.08.06.1.07,0-.06M86.05,28.39,86,28.31s-.08.05-.08.07,0,.06.07.08l.08-.07M30.87,73.27l-.07-.08s-.08,0-.08.07,0,0,.07.08l.08-.07m-.24.67-.07-.09s-.08.05-.08.07,0,.06.06.09l.09-.07m-4.93.54s.08,0,.08-.07-.05-.06-.07-.09-.08.05-.08.07,0,.06.07.09m2.52-2.78-.09-.08s-.08,0-.08.07,0,.06.07.08l.09-.07m4.84,4.73L33,76.35s-.08,0-.08.07,0,0,.07.08l.09-.07M19.18,84.65l-.09.07.08.08s.08,0,.08-.07-.05,0-.07-.08m18.4-18.41s-.07,0-.07.07,0,0,.06.08.08,0,.08-.07,0-.06-.07-.08M32.69,86.69l0,.07h.14a.07.07,0,0,0,0-.07h-.07M191.56,80l-.07-.08s-.08,0-.08.07a.1.1,0,0,0,.07.07s.05,0,.08-.06M32.79,70.13l-.07-.07-.07.06.1.07,0-.06m53-42.34s.08-.05.08-.07,0,0-.07-.08-.08.05-.08.07,0,.05.07.08M26.52,80.67s-.06-.07-.09-.07-.06.05-.09.07.05.07.08.07.06,0,.1-.07M86.71,27.19l-.09.07s0,.07.08.07.06,0,.09-.06l-.08-.08M33.29,69.9l-.07-.08s-.08,0-.08.07,0,0,.07.08l.08-.07m-1-.43-.07-.08s-.08,0-.08.07,0,.05.07.08l.08-.07M153,33.17s.08-.05.08-.07,0-.05-.07-.07l-.09.1.08,0m-11.57,14-.07-.06-.07.06.1.06,0-.06M52.12,33.61l.08-.07-.08-.07-.08.11.08,0m130,113.72s0-.07-.08-.07-.06,0-.08.06.05.07.08.07,0,0,.08-.06M99.35,46.57l-.07-.08s-.08,0-.08.07,0,.07.07.07,0,0,.08-.06m40.91,2.25-.08-.08s-.07,0-.07.07,0,.07.06.07.06,0,.09-.06m61.63-.15s.08,0,.08-.07,0-.05-.07-.08-.08,0-.08.07,0,.06.07.08m-36.3,108.25s-.07,0-.07.06,0,.06.07.08.07,0,.07-.07,0-.05-.07-.07M118.73,19.86s0-.07-.08-.07-.06,0-.09.06,0,.08.08.08.06,0,.09-.07m87.84,137.57s0-.07-.08-.07-.06,0-.08.06.05.08.08.08.06-.05.08-.07M116.78,20.29s0-.06-.07-.06,0,0-.07.06l.1.06,0-.06m77.36,26.12.09-.07s0-.07-.08-.07-.06,0-.08.06l.07.08m-.4,108.77s-.05-.07-.08-.07,0,0-.08.06,0,.08.08.08.05-.05.08-.07M99.11,45.89s-.06-.06-.08-.06-.06,0-.09.06S99,46,99,46s.06,0,.09-.07m100.12,9.8s-.08.05-.08.07,0,.06.07.08.08,0,.08-.07,0-.05-.07-.08m-4.34,58s.06,0,.06-.07,0,0-.06-.06l-.08.1.08,0M61.29,23.17l0,.07h.08ZM133,23s-.05-.07-.07-.07-.06,0-.09.06,0,.07.08.07S133,23,133,23M24.25,109.93l.09-.08s-.05-.07-.08-.07-.06,0-.09.06l.08.09m178.45-.08-.08-.08s-.08,0-.08.07.05.06.07.08l.09-.07m-89.3-86.4-.08-.08s-.07,0-.07.07,0,0,.06.08l.09-.07m35.26-.3s-.08,0-.08.07,0,.05.07.08.07-.05.07-.07,0-.05-.06-.08M17.78,130.92l-.07,0V131l.07,0v-.06m120.8-81.43s0-.07-.07-.07-.06,0-.08.06,0,.07.07.07.05,0,.08-.06m-.34-.38.08-.07-.07-.08s-.08,0-.08.07,0,0,.07.08M46.53,52.7l.09-.07s0-.08-.08-.08a.1.1,0,0,0-.08.07s0,.05.07.08m-1.12-2.09-.08-.08s-.08,0-.08.07,0,0,.07.08l.09-.07m89.22-28.37a.29.29,0,0,0-.08.07s0,.05.07.08.08,0,.08-.07,0-.05-.07-.08m-21.79.16s.08,0,.08-.07,0-.06-.07-.08-.08,0-.08.07,0,.05.07.08",
    transform: "translate(-8.47 -2.18)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4527",
    "data-name": "Group 4527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4528",
    "data-name": "Group 4528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3849",
    "data-name": "Path 3849",
    className: "cls-680",
    d: "M84.82,58.8c.43.2.71.73,1.16,1.23a3.12,3.12,0,0,1,1.44-1.75,2.89,2.89,0,0,0,1.37-2.12,2.07,2.07,0,0,0-.45-2.25,13,13,0,0,0-1.86-1.53.67.67,0,0,0-.44,0,3.31,3.31,0,0,0-3,3.64,3.09,3.09,0,0,0,.09.53,3.4,3.4,0,0,0,1.64,2.28",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3851",
    "data-name": "Path 3851",
    className: "cls-680",
    d: "M138.68,32.17a1.46,1.46,0,0,0-.15,1.49c.24.44.72.49,1.32.57a4.79,4.79,0,0,0,3-2,1.5,1.5,0,0,1,.73-.47c.54-.24,1.1-.44,1.65-.66a1.9,1.9,0,0,0,1.17-1.28,10.42,10.42,0,0,0,.39-1.74c.14-1.21-.39-1.68-1.56-1.48a1.79,1.79,0,0,0-1.19.53,7.31,7.31,0,0,0-1.85,2.49,1.32,1.32,0,0,1-1.44,1.08,2.62,2.62,0,0,0-2.1,1.48",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3854",
    "data-name": "Path 3854",
    className: "cls-680",
    d: "M55.18,168.7a2.12,2.12,0,0,0-2.13,1.86,4.92,4.92,0,0,1-.46,1.92c-.39.8.13,1.44.68,2s1,.14,1.44-.08a14.23,14.23,0,0,0,2.19-1.14,2.27,2.27,0,0,0,1-3.05,1.09,1.09,0,0,0-.08-.15,3.22,3.22,0,0,0-2.64-1.34",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3856",
    "data-name": "Path 3856",
    className: "cls-680",
    d: "M106.68,39a5.89,5.89,0,0,0,.91.89,2.85,2.85,0,0,0,2.53,0,4.85,4.85,0,0,0,1.6-2.87,1.25,1.25,0,0,0-.47-1.18,2.91,2.91,0,0,0-3.53-.17c-.77.4-.85,1.18-1.25,1.79a1.36,1.36,0,0,0,.21,1.6",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3857",
    "data-name": "Path 3857",
    className: "cls-680",
    d: "M99,169.91a2.55,2.55,0,0,0,3-1.48c-.08-.46-.15-.74-.22-1-.52-2.14-1.16-2.58-3.31-2.21-.35.06-.82,0-1,.36a2.9,2.9,0,0,0-.52,2.53A2.62,2.62,0,0,0,99,169.91",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3859",
    "data-name": "Path 3859",
    className: "cls-680",
    d: "M94.47,140.05a2.28,2.28,0,0,0-.85-2.56l-.86-.69a1.61,1.61,0,0,0-1.87-.16,7.27,7.27,0,0,1-1.85,1l0-.23c-.27-.74-.62-1.21-1.34-1.17a1.61,1.61,0,0,0-1.26.83,1.07,1.07,0,0,0,.1,1.42c.35.39.73.76,1.33.35a8.61,8.61,0,0,0,1-.58,1.12,1.12,0,0,0,.16.22c.47.74.75,1.42,1.12,2.05a2.19,2.19,0,0,0,1.73,1.26c2,.12,2,.49,2.54-1.71",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3860",
    "data-name": "Path 3860",
    className: "cls-680",
    d: "M145.7,42.83a1.85,1.85,0,0,0-.39,2.58.81.81,0,0,0,.12.14,2.93,2.93,0,0,0,4.13-.36,3.6,3.6,0,0,0,.28-.4,5.61,5.61,0,0,1,1.32-1.74.84.84,0,0,0,.1-1.19.81.81,0,0,0-.36-.25,3.05,3.05,0,0,0-1.72-.07,6.61,6.61,0,0,0-3.47,1.29",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3861",
    "data-name": "Path 3861",
    className: "cls-680",
    d: "M78,74a2.43,2.43,0,0,0,.26,2.71c.63.82,1.38,1.36,2.49.8.09-.15.19-.17.46-.23.78-.71,1.22-1.42.87-2.28a2.16,2.16,0,0,1,.06-1.89.58.58,0,0,0-.31-.75c-.24-.16-.53-.26-.78,0a1,1,0,0,1-1,.39C78.9,72.45,78.39,73.2,78,74",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3862",
    "data-name": "Path 3862",
    className: "cls-680",
    d: "M80.48,145a3.41,3.41,0,0,1-.63-.24,1.39,1.39,0,0,0-1.61.3,2.42,2.42,0,0,0-1,2.11c.23,2.55-.54,2.71,2.49,2.23a2,2,0,0,0,1.68-1.13,2.26,2.26,0,0,0,.31-1.64A1.67,1.67,0,0,0,80.46,145",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3863",
    "data-name": "Path 3863",
    className: "cls-680",
    d: "M79.33,129a2.12,2.12,0,0,0,1.83,1.45,3.66,3.66,0,0,0,3.22-1.5,1.77,1.77,0,0,0-.23-1.65,2.66,2.66,0,0,0-4.57-.63,2,2,0,0,0-.24,2.32",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3864",
    "data-name": "Path 3864",
    className: "cls-680",
    d: "M159.35,52.23a6.49,6.49,0,0,0,1-.4,1.17,1.17,0,0,0,.25-1.58.71.71,0,0,0-.94-.37.86.86,0,0,0-.19.11,4.74,4.74,0,0,1-2.15.49l-2.44.27a1.24,1.24,0,0,0-.94.55,2.09,2.09,0,0,0,.15,2.31,1.38,1.38,0,0,0,1.51.68,6,6,0,0,0,3.77-2.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    className: "cls-680",
    d: "M124,98.2a1.84,1.84,0,0,0,2.05,0,5.25,5.25,0,0,0,.58-1.13c.46-1.34-.19-2.55-1.55-2.53a28,28,0,0,0-4.08.66,1.18,1.18,0,0,0-.4.21A1.25,1.25,0,0,0,120,97c.22.63.73.7,1.26.63a3.29,3.29,0,0,1,2.75.58",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3866",
    "data-name": "Path 3866",
    className: "cls-680",
    d: "M195.71,121.92c.86,0,1.26-.66,1.83-1.35,0-2-.54-2.63-2.1-2.86a2.78,2.78,0,0,0-1.87.56,1.61,1.61,0,0,0-.62,2.18,1.92,1.92,0,0,0,.37.44,3.51,3.51,0,0,0,2.39,1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3868",
    "data-name": "Path 3868",
    className: "cls-680",
    d: "M161.36,66.11c-.06-1.62-.06-1.62-1.36-1.75a2.82,2.82,0,0,1-.65-.08,1.6,1.6,0,0,0-1.83.34,3.29,3.29,0,0,0-1.26,1.76,2,2,0,0,0,.44,1.86,1.57,1.57,0,0,0,1.86.18,5.32,5.32,0,0,0,2.8-2.31",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3869",
    "data-name": "Path 3869",
    className: "cls-680",
    d: "M158.42,155.16a2.66,2.66,0,0,0-2.55.21,1.49,1.49,0,0,0-.67,2,1.32,1.32,0,0,0,.19.29c.31.31.57.67,1,1.07a12.54,12.54,0,0,0,1.94.08,2.28,2.28,0,0,0,1.57-.73,1.3,1.3,0,0,0,.16-1.84,1.43,1.43,0,0,0-.32-.28,6.18,6.18,0,0,0-1.33-.8",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    className: "cls-680",
    d: "M155,70.19a4.85,4.85,0,0,0-5.57.22h0a5,5,0,0,0-2.39.16.81.81,0,0,0-.5,1,.87.87,0,0,0,.31.4,9.37,9.37,0,0,0,.95.59c.45.28.69.22.76-.31a1.3,1.3,0,0,1,.81-1.28l.16.2a2.17,2.17,0,0,0,1.09,2.23,2.87,2.87,0,0,0,3.61-1l.11.07c.4-.31.55-.62.37-1a1,1,0,0,0,.2-.15c.29-.47.5-.94.09-1.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    className: "cls-680",
    d: "M47.35,164.2c1.13-.12,1.46-.38,1.63-1.37a3.18,3.18,0,0,0-.4-2.29,3.26,3.26,0,0,0-.78-.7,1.78,1.78,0,0,0-2.45.53,2.15,2.15,0,0,0-.14.26,2.67,2.67,0,0,0-.27,1.71c.23,1.8.54,2,2.41,1.86",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    className: "cls-680",
    d: "M145.48,116.4a1.25,1.25,0,0,0-1,.72,2.25,2.25,0,0,0,1,3l0,0a2.46,2.46,0,0,0,2.52-.24,2,2,0,0,0,.75-2.68,3.85,3.85,0,0,0-3.29-.82",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    className: "cls-680",
    d: "M72.87,125.9a2.38,2.38,0,0,0,.71,2.44,2.06,2.06,0,0,0,2.1.39c1.86-.45,2.17-1.36,1-2.86a5.82,5.82,0,0,0-.78-.71c-.67-.39-1.26-.6-1.83-.24s-1,.46-1.19,1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    className: "cls-680",
    d: "M77.1,139.18a2,2,0,0,0,1.57-.56,2.71,2.71,0,0,0,.72-1.38A2.6,2.6,0,0,0,77.54,135l-.22-.06a1.52,1.52,0,0,0-2,.83,2.29,2.29,0,0,0-.08.28,2.18,2.18,0,0,0,.14,1.73c.35.67.63,1.39,1.71,1.43",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3877",
    "data-name": "Path 3877",
    className: "cls-680",
    d: "M134.25,156.29a8.85,8.85,0,0,0-.95-1.24,2.49,2.49,0,0,0-2.7-.09,1.91,1.91,0,0,0-.48,2.38,2.57,2.57,0,0,0,.51.63,2.46,2.46,0,0,0,2,.36,4.49,4.49,0,0,0,1.54-1.23.6.6,0,0,0,0-.81",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3878",
    "data-name": "Path 3878",
    className: "cls-680",
    d: "M120.47,50.16a3.71,3.71,0,0,0,.81.21c.31,0,.51,0,.6-.07.68-.66,1.37-1.31,2-2,.45-.54-.13-1.86-.88-2a3.7,3.7,0,0,0-3,.65,1.8,1.8,0,0,0-.47,2.5,1.82,1.82,0,0,0,.92.69",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    className: "cls-680",
    d: "M131.22,7.93c1.28-.68,1.52-2,2.18-2.9a1,1,0,0,0-.24-1.4,1,1,0,0,0-.63-.18,2.81,2.81,0,0,0-3,2.6,2.85,2.85,0,0,0,.07.87,1.28,1.28,0,0,0,1.48,1l.14,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    className: "cls-680",
    d: "M72.39,45.81a9.33,9.33,0,0,0,1,.48,1,1,0,0,0,.63,0,3,3,0,0,0,1.42-3.93l0,0a.94.94,0,0,0-.79-.38,2.87,2.87,0,0,0-2.8,1.77c-.45,1.57-.45,1.57.56,2.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    className: "cls-680",
    d: "M115.64,186.66a2.07,2.07,0,0,0-1.22-.86,1.82,1.82,0,0,0-2.07,1,2,2,0,0,0,.55,2.24,2.57,2.57,0,0,0,2.07.68,1.35,1.35,0,0,0,1.39-1.31,1.28,1.28,0,0,0-.11-.58,6.25,6.25,0,0,0-.61-1.14",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    className: "cls-680",
    d: "M91.66,123.52a1.75,1.75,0,0,0-2,.59,1.94,1.94,0,0,0-.31,2.28,1.6,1.6,0,0,0,1.63,1,2.28,2.28,0,0,0,1.46-.49,2,2,0,0,0,.74-1.93,2,2,0,0,0-1.51-1.41",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    className: "cls-680",
    d: "M151.05,47.31l0,0c-.32.8.12.72.5.59a1.4,1.4,0,0,0,.28.06c.69.09,1.19.21,1.7.29a2.07,2.07,0,0,0,1.51-.3,3.81,3.81,0,0,0,1.63-2.8c0-.29-.19-.69-.51-.61-1,.32-2.26,0-2.88,1.23a1.76,1.76,0,0,1-1.43.94,1.08,1.08,0,0,0-.75.61",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    className: "cls-680",
    d: "M136.26,73.56a1.44,1.44,0,0,0,.83-.22,3,3,0,0,0,1.45-1.54,1.17,1.17,0,0,0-.52-1.47,1.69,1.69,0,0,0-1.5-.17,2.77,2.77,0,0,0-1.26.9c-.34.47-.94.88-.68,1.55s1,.84,1.67,1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    className: "cls-680",
    d: "M168.78,120.34c-.25.72.16,1.11.64,1.48a5.82,5.82,0,0,0,.9.52,3.48,3.48,0,0,0,2-.58,1.35,1.35,0,0,0,.53-1.85,1.38,1.38,0,0,0-.17-.25,2.35,2.35,0,0,0-2.41-.73,1.77,1.77,0,0,0-1.52,1.41",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    className: "cls-680",
    d: "M108.45,77.61a2.25,2.25,0,0,0,1.14-2.17c0-.13-.17-.23-.39-.44a1.43,1.43,0,0,1-.68-1.64c.1-.44-.36-.63-.74-.35a4.21,4.21,0,0,0-1.45,3.08c-.15,1.44.74,2,2.12,1.51",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    className: "cls-680",
    d: "M100.16,58.78a9.25,9.25,0,0,1,1.6.73c.33.18.44-.24.55-.68.41-.69,1-1,1.1-1.8.23-1.26.25-1.28-1.12-1-.66.13-1.32.18-2,.33a1.12,1.12,0,0,0-.87,1.16,1.13,1.13,0,0,0,.71,1.26",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    className: "cls-680",
    d: "M51.83,151.78l0,.32c.5.61,1,.89,1.65.6S55,152,55.18,151a2.39,2.39,0,0,0-1.08-2.84l-.19.07a2.71,2.71,0,0,1,.3-.13,2.06,2.06,0,0,0-1.78-1,2.43,2.43,0,0,0-2,2.8.52.52,0,0,0,0,.11c.22.77.53,1.53,1.4,1.7",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    className: "cls-680",
    d: "M90.45,170.12c-.78-.3-1.55-.59-2.23.44a2.75,2.75,0,0,0-.14.81,1.88,1.88,0,0,0,2,1.67,2.1,2.1,0,0,0,.7-.21,1.08,1.08,0,0,0,.6-1.1c-.12-.65-.22-1.32-1-1.61",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    className: "cls-680",
    d: "M123.78,23.35a2.31,2.31,0,0,0,.13-1.51c-.24-1-.45-1.11-1.89-.89a2,2,0,0,0-1.11,1.91,1.44,1.44,0,0,0,1,1.3,1.66,1.66,0,0,0,1.87-.81",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    className: "cls-680",
    d: "M38.63,176.65c.95.29,1.38-.26,1.86-.71a1.29,1.29,0,0,0,.28-1.6,1.74,1.74,0,0,0-1.47-1.18c-.63-.06-1.47.47-1.5,1a2.33,2.33,0,0,0,.83,2.46",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3894",
    "data-name": "Path 3894",
    className: "cls-680",
    d: "M84.77,106.42a1.06,1.06,0,0,0-.38,1.46,1.22,1.22,0,0,0,.2.25,13.39,13.39,0,0,0,1.79,1.3c.49.31,1,0,1.12-.63.06-.37,0-.75.12-1.1.21-.87-.2-1.41-1.06-1.86a3.37,3.37,0,0,0-1.79.58",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    className: "cls-680",
    d: "M120.77,71.29a.75.75,0,0,0,.31.53.66.66,0,0,0,.84-.06c.42-.4.78-.87,1.2-1.29.66-.68.42-1.33-.17-2.09a7.29,7.29,0,0,0-1.52-.72c-.59-.16-1.13.29-1,.84a7.12,7.12,0,0,1,.29,2.79",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    className: "cls-680",
    d: "M68.05,209.36a1.65,1.65,0,0,0,1.29,0c.34-.14.7-.25,1.2-.44s.85-.66.66-1.18a1.21,1.21,0,0,0-1.15-.9,13.23,13.23,0,0,0-1.77.16,1.2,1.2,0,0,0-1.1,1.19c0,.53.27.9.88,1.15",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    className: "cls-680",
    d: "M83.35,168.87a1.49,1.49,0,0,0-1.6.07,4.15,4.15,0,0,0-.51,1.36,1.59,1.59,0,0,0,1.6,1.56,1.12,1.12,0,0,0,.32,0,2.1,2.1,0,0,0,1.23-1.44c.17-.47-.39-1.21-1-1.51",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    className: "cls-680",
    d: "M97.72,150.92c-.35.26-.66.44-.72.69a2.79,2.79,0,0,1-.8,1.51c-.51.48-.28,1.23.37,1.66a1.11,1.11,0,0,0,1.52-.35l0,0a5,5,0,0,1,1.12-1.83c.32-.27.22-.68,0-1a1.53,1.53,0,0,0-1.47-.66",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    className: "cls-680",
    d: "M81.37,120.13c1,.16,1.73,0,1.89-.93.12-.59.76-1,.56-1.65-.71-.14-1.42-.32-2.17-.41-1-.11-1.64.59-1.53,1.66.07.69.44,1.07,1.24,1.32",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    className: "cls-680",
    d: "M117.11,85.69c-.87-.07-1.79-.18-2.45.9-.36.86-.23,1.52.39,1.91a1.43,1.43,0,0,0,1.67-.16,2.5,2.5,0,0,0,1-1.87.7.7,0,0,0-.59-.78h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    className: "cls-680",
    d: "M107.27,67.52c.36.52,1,.54,2,0a2,2,0,0,0,.43-.43c.52-.7.77-1.31.18-1.92a1.65,1.65,0,0,0-2.21-.08,1.93,1.93,0,0,0-.36,2.4",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    className: "cls-680",
    d: "M124.4,8.71a1.4,1.4,0,0,0,1-.31,2.84,2.84,0,0,0,1.26-2.2c-.31-1.11-.42-1.21-.94-1a16.07,16.07,0,0,0-1.61.8,1.8,1.8,0,0,0-.82,1.51,1.11,1.11,0,0,0,1,1.18h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    className: "cls-680",
    d: "M133,176.72a.9.9,0,0,0-1,.34c-.3.5-.67,1-.41,1.67s.89.69,1.5.73a2.23,2.23,0,0,0,1.34-.58c0-1.28-.54-2-1.44-2.16",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    "data-name": "Path 3904",
    className: "cls-680",
    d: "M120.25,153c-.85.43-1,.65-.81,1.83a3.93,3.93,0,0,0,2.38,1.36.8.8,0,0,0,.92-.66.65.65,0,0,0,0-.31,3.49,3.49,0,0,0-1.07-1.89,1.09,1.09,0,0,0-1.39-.32",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    className: "cls-680",
    d: "M120.28,14.21c.94.42,1.57.17,2.15-.87s.69-2,.23-2.25c-.67-.38-1.21.25-1.81.45-.12.05-.22.19-.44.41a4.8,4.8,0,0,0-.63.85c-.34.72-.19,1.11.49,1.41",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    className: "cls-680",
    d: "M91.1,35.55a3.13,3.13,0,0,1,1.75,1.51.9.9,0,0,0,1.26.17.58.58,0,0,0,.12-.1,3.73,3.73,0,0,0,.64-.89A1,1,0,0,0,94.49,35l-.06,0c-.44-.24-1.07,0-1.55-.68h0l.2-.08c-.18-.73-.61-.66-1-.59-.59.1-1.09.31-1,1a2,2,0,0,0-.19.22c.09.37.11.7.25.76",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    className: "cls-680",
    d: "M112.06,57.6A13.18,13.18,0,0,1,110,57c-.25-.14-.33.37-.31.83a9.62,9.62,0,0,0,.31,1.67.86.86,0,0,0,1.09.53h0a2.69,2.69,0,0,0,1.46-1,1,1,0,0,0-.24-1.38.84.84,0,0,0-.21-.11",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    "data-name": "Path 3908",
    className: "cls-680",
    d: "M86.68,39.54a3.73,3.73,0,0,0,.88-.12,1.36,1.36,0,0,0,1-1.31,1.71,1.71,0,0,0-1-1.64c-.55-.27-1,.16-1.34.56a7.61,7.61,0,0,0-.69,1.08,2.71,2.71,0,0,0,.14,1c.19.37.59.41,1,.41",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    className: "cls-680",
    d: "M86.59,48.21a2.4,2.4,0,0,1,1.84,1,.83.83,0,0,0,1,0,1.17,1.17,0,0,0,.58-1.14c-.06-.48-.48-.52-.86-.54a5.52,5.52,0,0,1-.81-.06,2,2,0,0,1-.17-.73c-.15-.69-.57-.94-1.09-.63a1.89,1.89,0,0,0-.94.91c-.17.4,0,1.12.42,1.13",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    className: "cls-680",
    d: "M88.45,91.57a1.22,1.22,0,0,0,.14-1.72,1.1,1.1,0,0,0-.42-.32c-.56-.35-1-.06-1.46.15a.71.71,0,0,0-.41.74c.11.74.24,1.48,1.3,1.68a2.7,2.7,0,0,0,.85-.53",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    className: "cls-680",
    d: "M120.74,168.62c-.74-.08-1.22.35-1.26,1.19a3.29,3.29,0,0,0,.28,1,1.1,1.1,0,0,0,1.49.41,1.39,1.39,0,0,0,.73-1,1.34,1.34,0,0,0-1.11-1.56l-.13,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    className: "cls-680",
    d: "M61.19,156.23a13.9,13.9,0,0,0-.87-1.93c-.63-.34-1.14-.41-1.54,0a1.31,1.31,0,0,0-.07,1.47,8,8,0,0,0,.92,1.22.84.84,0,0,0,1.13.33h0a.86.86,0,0,0,.41-1.12",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    className: "cls-680",
    d: "M124.75,147.85a1.1,1.1,0,0,0-1.1,1.1,1.06,1.06,0,0,0,0,.31c.15.83.79,1.28,1.83,1.28a1.1,1.1,0,0,0,1-.44c.25-.36.14-.71-.05-1.22a1.53,1.53,0,0,0-1.71-1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    className: "cls-680",
    d: "M116.31,61.39a2.05,2.05,0,0,0,1.57-.59,1,1,0,0,0,.21-1.4,1.42,1.42,0,0,0-1.52-.71,1.27,1.27,0,0,0-1.23,1.09c-.25.8.06,1.3,1,1.61",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    className: "cls-680",
    d: "M191.47,61.9c.1.53.82.65,2,.35a2.37,2.37,0,0,0,.81-.32,1,1,0,0,0,.38-1,.9.9,0,0,0-.57-.63,2.12,2.12,0,0,0-1.47,0c-.73.43-1.3.82-1.14,1.63",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    className: "cls-680",
    d: "M96.53,72.93A1.68,1.68,0,0,0,96,74.65a1.25,1.25,0,0,0,1.58.82,1.09,1.09,0,0,0,.37-.19,1.9,1.9,0,0,0,.42-2,1.18,1.18,0,0,0-1.6-.5,1.07,1.07,0,0,0-.22.15",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    className: "cls-680",
    d: "M143,158.15a1.31,1.31,0,0,0-1.43.77,1,1,0,0,0,.4,1.31h0a6.37,6.37,0,0,0,.72.41c.94.11,1.67,0,1.87-.91.12-.64-.72-1.43-1.57-1.59",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3919",
    "data-name": "Path 3919",
    className: "cls-680",
    d: "M137.29,100.46a5.76,5.76,0,0,0,.48,1,1.21,1.21,0,0,0,1.67.38,1,1,0,0,0,.38-.38,1,1,0,0,0-.11-1.34,2.24,2.24,0,0,0-1.76-.6.7.7,0,0,0-.71.7.64.64,0,0,0,0,.24",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    className: "cls-680",
    d: "M136.42,141c-.77-.52-1.28-.29-1.64,1a2.41,2.41,0,0,0,1.73,1.49.83.83,0,0,0,1-.27.78.78,0,0,0,0-.83,3.61,3.61,0,0,0-1.12-1.36",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    className: "cls-680",
    d: "M136.28,171.49a1.31,1.31,0,0,0-1.3.58.92.92,0,0,0,0,1.05,1.91,1.91,0,0,0,1.74.82c.49,0,.75-.45.94-.87a.79.79,0,0,0-.27-1,4.88,4.88,0,0,0-1.11-.58",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3923",
    "data-name": "Path 3923",
    className: "cls-680",
    d: "M127.1,103.62a.9.9,0,0,0,.26,1,1.2,1.2,0,0,0,1.63.19,1.28,1.28,0,0,0,.54-1.55,1.13,1.13,0,0,0-1.3-.83,1.72,1.72,0,0,0-1.13,1.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3924",
    "data-name": "Path 3924",
    className: "cls-680",
    d: "M118.87,160.13a1.55,1.55,0,0,0,.5-.31c.19-1.41-.11-1.82-1-1.66s-1.57.81-1.38,1.39.88.83,1.87.58",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3925",
    "data-name": "Path 3925",
    className: "cls-680",
    d: "M100.47,183.46c-.28.22-.82.37-.72,1a20.92,20.92,0,0,0,2,1.09c1-.63,1.2-.9.94-1.49a1.3,1.3,0,0,0-1.53-1,1.28,1.28,0,0,0-.72.43",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3926",
    "data-name": "Path 3926",
    className: "cls-680",
    d: "M112.32,61.61a1.45,1.45,0,0,0-.24,1.26c.1.41.39.6,1,.63a3.26,3.26,0,0,0,1-.26,1.27,1.27,0,0,0,.49-1.58,1.06,1.06,0,0,0-1-.81,1.35,1.35,0,0,0-1.26.75",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3927",
    "data-name": "Path 3927",
    className: "cls-680",
    d: "M187.16,34.52a2.42,2.42,0,0,0,1.17-1c.56-.7.68-1.23.3-1.55s-.94,0-1.53.31-.93.53-1.08,1a1,1,0,0,0,.13,1,.92.92,0,0,0,1,.19",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3928",
    "data-name": "Path 3928",
    className: "cls-680",
    d: "M44.2,68.78a1.9,1.9,0,0,0,.92-.36,2.2,2.2,0,0,0,.22-1,1.2,1.2,0,0,0-1.15-1.1,1.38,1.38,0,0,0-1.14,1.38,1.14,1.14,0,0,0,1.15,1.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3929",
    "data-name": "Path 3929",
    className: "cls-680",
    d: "M187.18,85.43a1.89,1.89,0,0,0-2.09-.13.71.71,0,0,0-.27.56c.06.76.55,1.15,1.83,1.37.54-.08.94-.11,1.1-.5s-.06-.85-.4-1.16l-.17-.14",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3930",
    "data-name": "Path 3930",
    className: "cls-680",
    d: "M100,127.25a1.07,1.07,0,0,0-1.37,0,.68.68,0,0,0-.19.93l.06.07a2.91,2.91,0,0,0,2.77,1.08c.17,0,.35-.25.45-.42a.47.47,0,0,0-.15-.6c-.5-.31-1.14-.4-1.58-1.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3931",
    "data-name": "Path 3931",
    className: "cls-680",
    d: "M132.72,85.31a1.9,1.9,0,0,0,1.49-.82c.39-.44.36-.94-.17-1.49a2.21,2.21,0,0,0-1-.21,1.3,1.3,0,0,0-.85,2.17.82.82,0,0,0,.54.35",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3932",
    "data-name": "Path 3932",
    className: "cls-680",
    d: "M103.38,171.56a.85.85,0,0,0-.87.56,1.34,1.34,0,0,0,.12,1.47,1.38,1.38,0,0,0,1.74.31c.52-.43.6-.81.32-1.26s-.62-1-1.31-1.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3933",
    "data-name": "Path 3933",
    className: "cls-680",
    d: "M112.25,121a1.14,1.14,0,0,0-1.61.15,1.27,1.27,0,0,0-.13.19c-.25.43-.1.71.87,1.4.75.07,1.14-.2,1.29-.79a.83.83,0,0,0-.42-1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3934",
    "data-name": "Path 3934",
    className: "cls-680",
    d: "M93.87,155a2.12,2.12,0,0,0-.83.55.94.94,0,0,0,.14,1.33,1,1,0,0,0,.25.14,1,1,0,0,0,1.37-.29.51.51,0,0,0,.09-.18c.34-.69.13-1.07-1-1.55",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3935",
    "data-name": "Path 3935",
    className: "cls-680",
    d: "M139.72,46.29a3.76,3.76,0,0,0,.74-.75c.22-.51.34-.92-.05-1.15a1.61,1.61,0,0,0-2,.45,1.2,1.2,0,0,0,.08,1.44,1,1,0,0,0,1.23,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3936",
    "data-name": "Path 3936",
    className: "cls-680",
    d: "M166.46,107.4c-.37.08-.7.22-.79.63a.9.9,0,0,0,.26,1,3.68,3.68,0,0,0,1.16.45c1.07-.58,1.3-1,1.08-1.44a1.38,1.38,0,0,0-1.5-.68l-.21,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    "data-name": "Path 3937",
    className: "cls-680",
    d: "M112.83,108.89a.77.77,0,0,0-.79.73.57.57,0,0,0,0,.13,1.43,1.43,0,0,0,1,1.31c.76.25,1.26-.09,1.58-1a1.87,1.87,0,0,0-1.84-1.21",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    "data-name": "Path 3938",
    className: "cls-680",
    d: "M176.9,40.55c.69-.24,1.44-.45,1.69-1.48-.23-1-.62-1.26-1.09-.88a3.57,3.57,0,0,0-1.22,1.55.77.77,0,0,0,.06.63.64.64,0,0,0,.56.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3939",
    "data-name": "Path 3939",
    className: "cls-680",
    d: "M151.69,67a3.29,3.29,0,0,0,.52-.72c.27-.48,0-1-.67-1.07a1.86,1.86,0,0,0-.79.21,2.44,2.44,0,0,0-.46.39c-.52.78-.58,1.29-.19,1.54a1.27,1.27,0,0,0,1.58-.35",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3940",
    "data-name": "Path 3940",
    className: "cls-680",
    d: "M63.84,153.44c.56-.27.59-.78.43-1.47a2.63,2.63,0,0,0-.77-.63.84.84,0,0,0-1.15.32,1.24,1.24,0,0,0,.09,1.42,1.35,1.35,0,0,0,1.4.36",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    className: "cls-680",
    d: "M145.88,174a3,3,0,0,0-1-.48.87.87,0,0,0-.94.42.71.71,0,0,0,.18,1h0a4.93,4.93,0,0,0,1.12.57c.55,0,.91-.12,1-.54a.85.85,0,0,0-.41-.94",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    "data-name": "Path 3942",
    className: "cls-680",
    d: "M141.62,118.14a.94.94,0,0,0-1.23-.06c-.38.26-.75.53-.58,1.06a1.1,1.1,0,0,0,1,.79,1.45,1.45,0,0,0,1.16-.37c.46-.74.09-1.1-.34-1.42",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3943",
    "data-name": "Path 3943",
    className: "cls-680",
    d: "M72.83,82.68a1.1,1.1,0,0,0,1-1,1,1,0,0,0-.65-1A.93.93,0,0,0,72,81c-.29.34-.55.71-.26,1.17a1.1,1.1,0,0,0,1.13.5",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3944",
    "data-name": "Path 3944",
    className: "cls-680",
    d: "M131.27,70.53a.67.67,0,0,0-.05,1l.05,0a5.87,5.87,0,0,0,1,.82c.61.36,1,.07,1.16-.68a10.33,10.33,0,0,0-1-1.33.78.78,0,0,0-1.09.09.61.61,0,0,0-.07.1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3946",
    "data-name": "Path 3946",
    className: "cls-680",
    d: "M111.85,19.27a1.42,1.42,0,0,0,1.61-1.16.8.8,0,0,0-.62-.94.76.76,0,0,0-.3,0,1.29,1.29,0,0,0-1.18,1.06c0,.55.06.95.49,1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3947",
    "data-name": "Path 3947",
    className: "cls-680",
    d: "M72.47,142.45a.9.9,0,0,0-1,.79.62.62,0,0,0,0,.13,1.2,1.2,0,0,0,1.23,1.07c.7,0,.87-.45.74-1.21-.32-.44-.56-.72-1-.77",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3948",
    "data-name": "Path 3948",
    className: "cls-680",
    d: "M142.78,101a1,1,0,0,0-.61,1.06c.08.53.56.64,1,.73a1.11,1.11,0,0,0,1.35-.79c.27-.71-.33-.85-.93-1.1a1.76,1.76,0,0,0-.79.1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3949",
    "data-name": "Path 3949",
    className: "cls-680",
    d: "M80.47,94.78a2.64,2.64,0,0,0,1-.59,1.63,1.63,0,0,0,.17.2,2.59,2.59,0,0,0,.82.2c.92-.08,1.29-.38,1.48-1.07a1.7,1.7,0,0,0-.7-1.74.76.76,0,0,0-.63-.15c-.55.17-1.14.35-1.27,1.24l0,.06a.76.76,0,0,0-.06-.16,8.55,8.55,0,0,0-1.24,0A1,1,0,0,0,79.25,94s0,.09,0,.13a.83.83,0,0,0,1,.69.79.79,0,0,0,.22-.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3950",
    "data-name": "Path 3950",
    className: "cls-680",
    d: "M59.68,81.69a2.38,2.38,0,0,0,.78-.63c.14-.53.07-.87-.3-1.07a1.34,1.34,0,0,0-1-.27.82.82,0,0,0-.38.2,1.18,1.18,0,0,0-.2,1.41.83.83,0,0,0,1.1.37h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3951",
    "data-name": "Path 3951",
    className: "cls-680",
    d: "M162.41,27.3a3.67,3.67,0,0,0,.76-.46.74.74,0,0,0,.28-1c-.19-.4-.55-.45-1.1-.36a1.21,1.21,0,0,0-.82,1.12.63.63,0,0,0,.53.71.6.6,0,0,0,.35,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3952",
    "data-name": "Path 3952",
    className: "cls-680",
    d: "M56.23,116.72c.24-.13.37-.44.56-.84a1.75,1.75,0,0,0-.47-.89.94.94,0,0,0-1.33.11l-.05.06a1,1,0,0,0-.07,1.24.94.94,0,0,0,1.29.36l.07,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3953",
    "data-name": "Path 3953",
    className: "cls-680",
    d: "M155.31,42.77a1.92,1.92,0,0,0,.7-.47c.4-.42.2-.81-.72-1.22a3.11,3.11,0,0,0-.6.09c-.53.15-1,.43-.84,1s.81.77,1.46.55",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3954",
    "data-name": "Path 3954",
    className: "cls-680",
    d: "M86.45,51.27a1.35,1.35,0,0,0,.93-.55.92.92,0,0,0,0-1.3l-.09-.08c-.55-.35-1.14-.17-1.65.58-.08.12-.06.29,0,.59.22.5.47.78.89.76",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3955",
    "data-name": "Path 3955",
    className: "cls-680",
    d: "M133.24,102.78a10.8,10.8,0,0,0,.5,1.45c.17.41.49.38,1.3-.18,0-.91-.79-1.12-1.18-1.64-.06-.06-.3,0-.41,0s-.24.25-.21.34",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3956",
    "data-name": "Path 3956",
    className: "cls-680",
    d: "M98.14,66.81c-.47.22-1,.45-.91,1.26.27.48.54.73,1,.74a2,2,0,0,0,.64-.11c.48-.16.63-.74.38-1.32a.88.88,0,0,0-1.06-.57",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3957",
    "data-name": "Path 3957",
    className: "cls-680",
    d: "M112.89,12.41c.12-.09.22-.2.45-.4.35-.43.44-.77.08-1.06a.69.69,0,0,0-.82,0,3,3,0,0,0-.56.36,1.48,1.48,0,0,0-.63,1.53c.07.35.76.17,1.48-.4",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3958",
    "data-name": "Path 3958",
    className: "cls-680",
    d: "M160.14,142.27c-.5-.2-.89-.27-1.13.1a1.18,1.18,0,0,0,.31,1.58,1,1,0,0,0,1.39-.14h0c.46-.53.16-.94-.27-1.31a1.73,1.73,0,0,0-.31-.22",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3959",
    "data-name": "Path 3959",
    className: "cls-680",
    d: "M83.9,112.25c-1.13.15-1.44.4-1.35.86.14.63,1,1.19,1.47,1s.63-.81.34-1.5c0-.12-.2-.2-.46-.36",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3961",
    "data-name": "Path 3961",
    className: "cls-680",
    d: "M130.62,164.57c-.12-.65-.39-1-.86-1.1a.68.68,0,0,0-.78.25,1.18,1.18,0,0,0,.35,1.55c.47.36.83.21,1.29-.7",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3962",
    "data-name": "Path 3962",
    className: "cls-680",
    d: "M142.36,166.39c-.39-.23-.66-.1-1.12.75a1.18,1.18,0,0,0,.91,1,.63.63,0,0,0,.77-.31,1.16,1.16,0,0,0-.56-1.48",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3963",
    "data-name": "Path 3963",
    className: "cls-680",
    d: "M55.64,12.15a1.14,1.14,0,0,0-.13-1.27c-.28-.31-.82-.17-1.29.39a.84.84,0,0,0-.08.57c.09.2.12.29.18.32.7.4,1.14.41,1.32,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3964",
    "data-name": "Path 3964",
    className: "cls-680",
    d: "M118.66,149.43a.77.77,0,0,0-.57.61.68.68,0,0,0,.34.73c.6.36.85.28,1.55-.66a1.08,1.08,0,0,0-1.32-.68",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3965",
    "data-name": "Path 3965",
    className: "cls-680",
    d: "M37.05,197.43a1,1,0,0,0,.66-1.24c-.05-.39-.24-.73-.67-.74a1,1,0,0,0-.95.76,1.63,1.63,0,0,0,.09.79c.31.34.55.56.87.43",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3966",
    "data-name": "Path 3966",
    className: "cls-680",
    d: "M46.43,86.28a1,1,0,0,0-.19,1.32l.06.07c.31.33.68.25,1.3-.31,0,0,.07-.13.11-.34-.08-.53-.25-.87-.67-.92a.9.9,0,0,0-.61.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3967",
    "data-name": "Path 3967",
    className: "cls-680",
    d: "M120.28,77.27a.88.88,0,0,0,.61-1.07l0-.08c-.38-.4-.71-.54-1.1-.42a1,1,0,0,0-.78,1.16c.11.45.72.65,1.3.41",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3968",
    "data-name": "Path 3968",
    className: "cls-680",
    d: "M57.36,141c.79-.1,1.06-.48.9-1.1a.79.79,0,0,0-.8-.64,1,1,0,0,0-.94.79c-.19.56.27.76.84.95",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3969",
    "data-name": "Path 3969",
    className: "cls-680",
    d: "M162.17,77.5a2.22,2.22,0,0,0,.06.81c.22.63.56.74.92.3a4.65,4.65,0,0,0,.59-.92c.15-.32-.17-.73-.57-.78a1,1,0,0,0-1,.59",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3970",
    "data-name": "Path 3970",
    className: "cls-680",
    d: "M104,128.7a.69.69,0,0,0,.69-.69.85.85,0,0,0-.4-.73.71.71,0,0,0-1,.06,3.6,3.6,0,0,0-.57.83c.24.84.79.58,1.25.53",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3971",
    "data-name": "Path 3971",
    className: "cls-680",
    d: "M84.72,180.12a.81.81,0,0,0-.74.73.76.76,0,0,0,.47.91c.3.14.57,0,1-.26.19-.43.24-.71.06-1a.73.73,0,0,0-.74-.39",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3972",
    "data-name": "Path 3972",
    className: "cls-680",
    d: "M56.88,181.65a.7.7,0,0,0-.07,1,.66.66,0,0,0,.79.17,1,1,0,0,0,.7-1.08.9.9,0,0,0-1.23-.24,1,1,0,0,0-.19.17",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    "data-name": "Path 3973",
    className: "cls-680",
    d: "M87.62,143.44c-.35.66-.32,1.12.35,1.3a.81.81,0,0,0,1-.37.89.89,0,0,0,0-1c-.33-.43-.77-.3-1.26.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    "data-name": "Path 3974",
    className: "cls-680",
    d: "M103.28,17.4a.91.91,0,0,0,1.19-.23.94.94,0,0,0,0-1.21c-.37-.46-.77-.26-1.26.18-.33.55-.4,1,.09,1.26",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3975",
    "data-name": "Path 3975",
    className: "cls-680",
    d: "M158.61,43.34c.41.08.69-.17,1.06-.54s.46-.66.27-.93-.63-.32-1-.1a4,4,0,0,0-.81.72c-.2.23.1.77.45.85",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3976",
    "data-name": "Path 3976",
    className: "cls-680",
    d: "M114.31,103.41a1,1,0,0,0,1-.76.64.64,0,0,0-.22-.78c-.35-.24-.69-.09-1.1.26-.18,1,0,1.3.37,1.28",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    className: "cls-680",
    d: "M150.69,161.92a1.25,1.25,0,0,0-.78,0c-.55.42-.52.81-.19,1.2a.75.75,0,0,0,1.05.13l.08-.07a.77.77,0,0,0,.07-1.08.8.8,0,0,0-.23-.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3978",
    "data-name": "Path 3978",
    className: "cls-680",
    d: "M140,137.06c-.39-.38-.7-.58-1.1-.36a.9.9,0,0,0-.48.72.67.67,0,0,0,.41.73c.64.28,1.08-.06,1.17-1.09",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3979",
    "data-name": "Path 3979",
    className: "cls-680",
    d: "M116.28,181.72a1.18,1.18,0,0,0-.52.27.72.72,0,0,0-.06,1,.5.5,0,0,0,.15.14.88.88,0,0,0,1.21-.11c.4-.43.15-.81-.23-1.13a1.17,1.17,0,0,0-.55-.19",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    className: "cls-680",
    d: "M65.57,85.4a.82.82,0,0,0,.58-.21,3.45,3.45,0,0,0,.59-.84c.06-.54,0-.91-.48-1s-.64.25-.74.63a6.13,6.13,0,0,0-.21.87c0,.22,0,.48.26.52",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    "data-name": "Path 3981",
    className: "cls-680",
    d: "M40.73,152a1.41,1.41,0,0,0,.6-.48.67.67,0,0,0-.14-.94.1.1,0,0,0,0,0,.77.77,0,0,0-1,.18c-.45.41-.34.73.58,1.28",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    "data-name": "Path 3982",
    className: "cls-680",
    d: "M137.54,86.25a1.09,1.09,0,0,0,.29-.23c.22-.69,0-1-.58-1a.64.64,0,0,0-.7.58.38.38,0,0,0,0,.1c.07.54.5.67,1,.52",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    "data-name": "Path 3983",
    className: "cls-680",
    d: "M81.59,66.27a.74.74,0,0,0,.41-1,.75.75,0,0,0-.62-.46c-.31,0-.54.14-.77.52a1.51,1.51,0,0,0,.21.72.58.58,0,0,0,.77.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    "data-name": "Path 3984",
    className: "cls-680",
    d: "M102.82,164.64c.68.84.68.84,1.74-.13-.59-.27-1.13-.77-1.74.13",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3985",
    "data-name": "Path 3985",
    className: "cls-680",
    d: "M136,69.12a.82.82,0,0,0,.55-.22c.37-.46.23-.79-.61-1.17-.34.29-.49.52-.46.83s.18.56.52.56",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3986",
    "data-name": "Path 3986",
    className: "cls-680",
    d: "M135,125.72c-.32.34-.22.63.31.89.46,0,.76,0,.92-.31a.53.53,0,0,0-.09-.76l0,0a.76.76,0,0,0-1.07.13l-.05.07",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3987",
    "data-name": "Path 3987",
    className: "cls-680",
    d: "M162.89,75.38c0-.13,0-.28-.17-.51a.7.7,0,0,0-.34-.12c-.46,0-.89.09-.95.63a.52.52,0,0,0,.41.62h.06a.83.83,0,0,0,1-.62h0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3988",
    "data-name": "Path 3988",
    className: "cls-680",
    d: "M102.87,35a.93.93,0,0,0,.57-.25.69.69,0,0,0,.07-1h0c-.21-.27-.52-.21-.9,0a1.89,1.89,0,0,0-.14.78.43.43,0,0,0,.41.43",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3989",
    "data-name": "Path 3989",
    className: "cls-680",
    d: "M198,69.35a.49.49,0,0,0,0-.69.44.44,0,0,0-.24-.13c-.56-.06-1,0-1.07.83.53.6,1,.42,1.33,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    "data-name": "Path 3990",
    className: "cls-680",
    d: "M119.75,90.32c.16.91.67.8,1.18.56a.63.63,0,0,0,.23-.86l-.06-.08a.75.75,0,0,0-1.16.07.84.84,0,0,0-.19.31",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3991",
    "data-name": "Path 3991",
    className: "cls-680",
    d: "M219.79,113.58c-.52-.2-1-.23-1.06.63.54.54,1,.51,1.26-.1a.37.37,0,0,0-.16-.51l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3992",
    "data-name": "Path 3992",
    className: "cls-680",
    d: "M12.17,210.26c.35.62.77.58,1.14-.23a1.78,1.78,0,0,0-.33-.48c-.24-.21-.51-.31-.77-.09a.59.59,0,0,0,0,.8",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3993",
    "data-name": "Path 3993",
    className: "cls-680",
    d: "M163.05,119.44c-.38.38-.59.73-.11,1a.77.77,0,0,0,1.06-.26l.05-.09a.58.58,0,0,0-.1-.4.74.74,0,0,0-.9-.2",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3994",
    "data-name": "Path 3994",
    className: "cls-680",
    d: "M68.58,166a.62.62,0,0,0,.19.87l.09.05c.57.16.75-.22.62-.86-.37-.42-.71-.48-.9-.06",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3995",
    "data-name": "Path 3995",
    className: "cls-680",
    d: "M156.61,162.7c-.46.36-.36.75.23,1.1.72-.13.85-.5.55-1a.53.53,0,0,0-.73-.16l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3996",
    "data-name": "Path 3996",
    className: "cls-680",
    d: "M38.23,64.92a.55.55,0,0,0,.37-.68v0a.49.49,0,0,0-.46-.4.55.55,0,0,0-.63.44v.06a.85.85,0,0,0,.16.53.87.87,0,0,0,.57.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3997",
    "data-name": "Path 3997",
    className: "cls-680",
    d: "M164.31,48.88c-.09.14,0,.39.14.7.32.07.59.12.73,0a.57.57,0,0,0,.15-.76.44.44,0,0,0-.14-.13.54.54,0,0,0-.77,0,.42.42,0,0,0-.11.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3998",
    "data-name": "Path 3998",
    className: "cls-680",
    d: "M153.38,4.33c.19-.65,0-1-.56-1a.54.54,0,0,0-.5.57.13.13,0,0,1,0,.06c.08.56.45.68,1,.36",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3999",
    "data-name": "Path 3999",
    className: "cls-680",
    d: "M175.63,124.59c.7-.21.79-.54.34-.94a.6.6,0,0,0-.85-.07,1.27,1.27,0,0,0-.1.12c-.42.56.06.72.61.89",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    "data-name": "Path 4000",
    className: "cls-680",
    d: "M151.18,76.34c-.44.34-.37.72.22,1.07.7-.15.86-.49.56-1a.53.53,0,0,0-.74-.15l0,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    className: "cls-680",
    d: "M156.81,117.69c-.29.18-.32.47-.1.86a1.06,1.06,0,0,0,.7-.1.44.44,0,0,0,.15-.59.51.51,0,0,0-.69-.21l-.06,0",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    "data-name": "Path 4002",
    className: "cls-680",
    d: "M155.73,109.53c-.14.48-.14.86.36.85a.55.55,0,0,0,.6-.5.41.41,0,0,0,0-.19c-.11-.48-.49-.39-1-.16",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    className: "cls-680",
    d: "M156.79,132.54a1.2,1.2,0,0,0,.46.58.35.35,0,0,0,.5-.07.41.41,0,0,0,.05-.09.78.78,0,0,0-.07-.6c-.29-.34-.63-.29-.95.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4004",
    "data-name": "Path 4004",
    className: "cls-680",
    d: "M76.73,180.65c-.16.49-.16.87.34.88a.57.57,0,0,0,.62-.51.58.58,0,0,0,0-.19c-.1-.49-.48-.43-.94-.18",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4005",
    "data-name": "Path 4005",
    className: "cls-680",
    d: "M62.62,111.51a.48.48,0,0,0-.2-.66l-.06,0c-.34-.09-.47.18-.44.61.29.38.56.39.7.08",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    "data-name": "Path 4006",
    className: "cls-680",
    d: "M115.6,72.58c-.21.09-.31.27-.16.6a.79.79,0,0,0,.52.06.37.37,0,0,0,.25-.46.14.14,0,0,0,0-.06.43.43,0,0,0-.59-.14",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4007",
    "data-name": "Path 4007",
    className: "cls-680",
    d: "M89.85,9.58c.24,0,.38-.2.42-.44,0-.48-.19-.66-.75-.47-.14.49-.19.89.33.91",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    "data-name": "Path 4008",
    className: "cls-680",
    d: "M61.9,44.68a.34.34,0,0,0-.36-.32l-.12,0c-.31.12-.36.39-.12.77.46.06.64-.14.6-.48",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    className: "cls-680",
    d: "M121,116.09c.21.27.48.2.71-.19-.08-.43-.28-.66-.58-.52a.46.46,0,0,0-.2.61.36.36,0,0,0,.07.1",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    className: "cls-680",
    d: "M114.11,3.16c.1-.34,0-.51-.26-.47a.35.35,0,0,0-.23.28c0,.25.17.35.49.19",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4011",
    "data-name": "Path 4011",
    className: "cls-680",
    d: "M108.81,105.16a.38.38,0,0,0,0,.36c.18.17.37.1.49-.24-.18-.31-.37-.31-.52-.12",
    transform: "translate(-8.47 -2.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4012",
    "data-name": "Path 4012",
    className: "cls-680",
    d: "M95.89,92h0",
    transform: "translate(-8.47 -2.18)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    className: "cls-680",
    d: "M160.74,152.4h-30l-19-19.27-26.57-27v-.07l26.57-27.23,19-19.46h30l-43.35,46.27,43.34,46.7Zm-62.26,0H71.91V106.17l26.57,27v19.28ZM71.91,106.1V59.41H98.48V78.87L71.91,106.09Z",
    transform: "translate(-8.47 -2.18)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKadenai);
export default __webpack_public_path__ + "static/media/kadenai.12f416583fdca1057a93cbf0225fb8e0.svg";
export { ForwardRef as ReactComponent };